export default {
  '已上架': '已上架',
  '已下架': '已下架',
  '确认下架': '确认下架',
  '下架后该样本册在下单/销售价格表中将不再可见，确认下架': '下架后该样本册在下单/销售价格表中将不再可见，确认下架',
  '批量上架': '批量上架',
  '批量下架': '批量下架',
  '批量转移样本册': '批量转移样本册',
  '上架': '上架',
  '下架': '下架',
  '条面料执行': '条面料执行',
  '操作，确认继续？': '操作，确认继续？',
  '请选择目标样本册': '请选择目标样本册',
  '将把': '将把',
  '款面料转移到目标样本册下（允许跨品牌）': '款面料转移到目标样本册下（允许跨品牌）',
  '短袖长': '短袖长',
  '上衣版型': '上衣版型',
  '上衣长度': '上衣长度',
  '裤子版型': '裤子版型',
  '裤腰高度': '裤腰高度',
  '上海旗舰店': '上海旗舰店',
  '刚刚': '刚刚',
  '北京朝阳店': '北京朝阳店',
  '1分钟前': '1分钟前',
  '深圳南山店': '深圳南山店',
  '3分钟前': '3分钟前',
  '成都春熙店': '成都春熙店',
  '8分钟前': '8分钟前',
  '杭州西湖店': '杭州西湖店',
  '15分钟前': '15分钟前',
  '工作台总览': '工作台总览',
  '管理员': '管理员',
  '· 全店数据 · 实时更新': '· 全店数据 · 实时更新',
  '点击进入': '点击进入',
  '广州天河店': '广州天河店',
  '在线': '在线',
  '未回款客户': '未回款客户',
  '家': '家',
  '天未回': '天未回',
  '交货': '交货',
  '出货': '出货',
  '运输': '运输',
  '配送': '配送',
  '手机': '手机',
  '邮件': '邮件',
  '裙装设计': '裙装设计',
  '同上衣': '同上衣',
  '创建订单失败': '创建订单失败',
  'AI思考中': 'AI思考中',
  '档': '档',
  '当前档位：': '当前档位：',
  '档 ·': '档 ·',
  '销售额': '销售额',
  '(汇率': '(汇率',
  '综合提成率：': '综合提成率：',
  '分档明细': '分档明细',
  '档（': '档（',
  '档(': '档(',
  '个人提成按定制单/团单分别计算；团队管理提成基于全团队总销售额（含本人）超额累进': '个人提成按定制单/团单分别计算；团队管理提成基于全团队总销售额（含本人）超额累进',
  '· 适用定制单提成阶梯': '· 适用定制单提成阶梯',
  '提成': '提成',
  '当前档：': '当前档：',
  '· 适用团单提成阶梯': '· 适用团单提成阶梯',
  '其他团队成员销售额': '其他团队成员销售额',
  '· 定制单 + 团单合并计入团队管理提成': '· 定制单 + 团单合并计入团队管理提成',
  '小计：$': '小计：$',
  '添加成员': '添加成员',
  '保存成员': '保存成员',
  '个人业绩小计 (USD) 定制单 + 团单': '个人业绩小计 (USD) 定制单 + 团单',
  '小计（': '小计（',
  '人）': '人）',
  '团队总销售额：': '团队总销售额：',
  '本人 $': '本人 $',
  '+ 其他成员 $': '+ 其他成员 $',
  '团队管理提成：': '团队管理提成：',
  '个人提成（定制单 + 团单）': '个人提成（定制单 + 团单）',
  '定制': '定制',
  '+ 团单': '+ 团单',
  '团队总销售 $': '团队总销售 $',
  '合计提成': '合计提成',
  '汇率': '汇率',
  '加载提成配置...': '加载提成配置...',
  '加载历史记录失败': '加载历史记录失败',
  '请输入员工姓名': '请输入员工姓名',
  '定制单': '定制单',
  '团单（成衣单）': '团单（成衣单）',
  '已删除': '已删除',
  '审批历史': '审批历史',
  '保存记录': '保存记录',
  '订单原价 (USD)': '订单原价 (USD)',
  '折后实收价 (USD)': '折后实收价 (USD)',
  '最低折扣系数（审批红线）': '最低折扣系数（审批红线）',
  '折）': '折）',
  '折扣可视化': '折扣可视化',
  '折扣系数': '折扣系数',
  '审批红线': '审批红线',
  '100%（原价）': '100%（原价）',
  '最低限制': '最低限制',
  '提成影响分析': '提成影响分析',
  '折扣导致提成减少': '折扣导致提成减少',
  '提成阶梯对比': '提成阶梯对比',
  '员工姓名': '员工姓名',
  '是否需审批': '是否需审批',
  '折扣审批历史': '折扣审批历史',
  '*必填': '*必填',
  '(固定月薪)': '(固定月薪)',
  '业绩提成': '业绩提成',
  '(USD，超额累进)': '(USD，超额累进)',
  '定制单提成明细': '定制单提成明细',
  '团单提成明细': '团单提成明细',
  '业绩提成（本人 + 团队管理）': '业绩提成（本人 + 团队管理）',
  '团队管理提成（经理专属）': '团队管理提成（经理专属）',
  '团队总销售额 = 本人定制单 + 本人团单 + 其他成员定制单 + 其他成员团单': '团队总销售额 = 本人定制单 + 本人团单 + 其他成员定制单 + 其他成员团单',
  '当前团队总销售额：': '当前团队总销售额：',
  '(USD，不含经理本人)': '(USD，不含经理本人)',
  '团队管理提成明细（超额累进）': '团队管理提成明细（超额累进）',
  '跟单提成': '跟单提成',
  '跟单提成明细': '跟单提成明细',
  '阶梯：$0-$30,000 → 0.1%；$30,001-$80,000 → 0.2%；$80,001以上 → 0.3%': '阶梯：$0-$30,000 → 0.1%；$30,001-$80,000 → 0.2%；$80,001以上 → 0.3%',
  '行政提成': '行政提成',
  '(单，超额累进)': '(单，超额累进)',
  '单': '单',
  '行政提成明细': '行政提成明细',
  '阶梯：0-50单 → ¥3/单；51-100单 → ¥4/单；101单以上 → ¥6/单（超额累进）': '阶梯：0-50单 → ¥3/单；51-100单 → ¥4/单；101单以上 → ¥6/单（超额累进）',
  '(绩效奖金、大单奖励、新客奖等)': '(绩效奖金、大单奖励、新客奖等)',
  '扣减项': '扣减项',
  '出勤扣减': '出勤扣减',
  '(迟到/早退/旷工等)': '(迟到/早退/旷工等)',
  '社保扣减': '社保扣减',
  '(个人承担部分)': '(个人承担部分)',
  '公积金扣减': '公积金扣减',
  '个税扣减（应纳税所得额': '个税扣减（应纳税所得额',
  '手动输入': '手动输入',
  '其他扣减': '其他扣减',
  '(提成回滚、处罚扣款等)': '(提成回滚、处罚扣款等)',
  '定制单提成': '定制单提成',
  '团单提成': '团单提成',
  '· 当月实发工资': '· 当月实发工资',
  '税前总收入': '税前总收入',
  '合计扣减': '合计扣减',
  '提成合计 (USD)': '提成合计 (USD)',
  '人力成本在控制范围内': '人力成本在控制范围内',
  '人力成本超出红线': '人力成本超出红线',
  '人力成本占比：': '人力成本占比：',
  '（红线': '（红线',
  '实发工资 ÷ 汇率 ÷ 本人月销售额（USD）': '实发工资 ÷ 汇率 ÷ 本人月销售额（USD）',
  '行政人员按订单量计算，不计算人力成本占比': '行政人员按订单量计算，不计算人力成本占比',
  '工资明细': '工资明细',
  '收入项': '收入项',
  '团队总销售': '团队总销售',
  '单 超额累进': '单 超额累进',
  '个税扣减': '个税扣减',
  'YYYY年MM月': 'YYYY年MM月',
  '保存工资记录到数据库': '保存工资记录到数据库',
  '提成构成': '提成构成',
  '工资核算': '工资核算',
  '汇总员工当月所有收入与扣减项，计算实发工资': '汇总员工当月所有收入与扣减项，计算实发工资',
  '提成：': '提成：',
  '税前：': '税前：',
  '实发：': '实发：',
  '本人定制单 (USD)': '本人定制单 (USD)',
  '本人团单 (USD)': '本人团单 (USD)',
  '其他成员定制单 (USD)': '其他成员定制单 (USD)',
  '其他成员团单 (USD)': '其他成员团单 (USD)',
  '月负责订单金额 (USD)': '月负责订单金额 (USD)',
  '月处理订单量 (单)': '月处理订单量 (单)',
  '个税扣减 (0=自动)': '个税扣减 (0=自动)',
  '核算结果': '核算结果',
  '提成（USD）': '提成（USD）',
  '提成（CNY）': '提成（CNY）',
  '个税（自动估算）': '个税（自动估算）',
  '未命名': '未命名',
  '角色': '角色',
  '提成(CNY)': '提成(CNY)',
  '添加员工': '添加员工',
  '批量工资核算': '批量工资核算',
  '录入全员数据，一键计算当月工资并导出Excel': '录入全员数据，一键计算当月工资并导出Excel',
  '员工总数': '员工总数',
  '人': '人',
  '实发工资合计': '实发工资合计',
  '当月工资汇总表': '当月工资汇总表',
  '合计（': '合计（',
  '加载销售价格表异常:': '加载销售价格表异常:',
  '款': '款',
  '已选': '已选',
  '行': '行',
  '清除': '清除',
  '年终分红记录已保存': '年终分红记录已保存',
  '年份': '年份',
  '年度利润': '年度利润',
  '分红池': '分红池',
  '员工分红池': '员工分红池',
  '计算及发放年终分红': '计算及发放年终分红',
  '历史记录': '历史记录',
  '分红基础参数': '分红基础参数',
  '年度税后利润 (CNY)': '年度税后利润 (CNY)',
  '个人分红权重': '个人分红权重',
  '根据绩效、司龄等因素分配权重点数': '根据绩效、司龄等因素分配权重点数',
  '分红总池': '分红总池',
  '股东分红池': '股东分红池',
  '% 分配': '% 分配',
  '本人预计分红': '本人预计分红',
  '权重占比：': '权重占比：',
  '点）': '点）',
  '分红总池 = 年度税后利润 × 分红池比例': '分红总池 = 年度税后利润 × 分红池比例',
  '员工分红池 = 分红总池 × 员工分红比例': '员工分红池 = 分红总池 × 员工分红比例',
  '个人分红 = 员工分红池 ×（本人权重 ÷ 总权重）': '个人分红 = 员工分红池 ×（本人权重 ÷ 总权重）',
  '注：权重点数由管理层根据年度绩效、司龄、贡献度等综合评定，具体权重分配规则由公司另行制定。': '注：权重点数由管理层根据年度绩效、司龄、贡献度等综合评定，具体权重分配规则由公司另行制定。',
  '历史分红记录': '历史分红记录',
  '上衣/西装': '上衣/西装',
  '共享数据': '共享数据',
  '管理订单中可选的品类（单品/组合），包含中英文名称和面料用量': '管理订单中可选的品类（单品/组合），包含中英文名称和面料用量',
  '定制订单提成阶梯（业务员）': '定制订单提成阶梯（业务员）',
  '适用于单件或少量定制 MTM 订单，5档超额累进': '适用于单件或少量定制 MTM 订单，5档超额累进',
  '最小值 (USD)': '最小值 (USD)',
  '最大值 (USD)': '最大值 (USD)',
  '团单提成阶梯（业务员）': '团单提成阶梯（业务员）',
  '适用于 RTW 成衣订单，提成按折后实际总额计算': '适用于 RTW 成衣订单，提成按折后实际总额计算',
  '团队管理提成阶梯（业务经理）': '团队管理提成阶梯（业务经理）',
  '基于团队所有成员（含经理本人）的定制单+团单总销售额，超额累进': '基于团队所有成员（含经理本人）的定制单+团单总销售额，超额累进',
  '跟单员提成阶梯': '跟单员提成阶梯',
  '按月负责订单金额（USD）超额累进，提成换算为人民币后计入工资': '按月负责订单金额（USD）超额累进，提成换算为人民币后计入工资',
  '最小金额 (USD)': '最小金额 (USD)',
  '最大金额 (USD)': '最大金额 (USD)',
  '行政人员提成阶梯': '行政人员提成阶梯',
  '按月处理订单量（单）超额累进，直接以人民币计入工资': '按月处理订单量（单）超额累进，直接以人民币计入工资',
  '最小单量（单）': '最小单量（单）',
  '最大单量（单）': '最大单量（单）',
  '元/单': '元/单',
  '全额退款': '全额退款',
  '全额追回该订单已发放的提成': '全额追回该订单已发放的提成',
  '退款工单完成当月，从业务员后续提成中扣除': '退款工单完成当月，从业务员后续提成中扣除',
  '扣减提成 = 原提成 × (退款金额 ÷ 订单原总额)': '扣减提成 = 原提成 × (退款金额 ÷ 订单原总额)',
  '售后完成当月': '售后完成当月',
  '事后折扣': '事后折扣',
  '视为部分退款，同比例扣减提成': '视为部分退款，同比例扣减提成',
  '折扣审批通过当月': '折扣审批通过当月',
  '坏账': '坏账',
  '全额追回该订单提成，并额外扣减坏账金额的5%（上限月薪20%）': '全额追回该订单提成，并额外扣减坏账金额的5%（上限月薪20%）',
  '财务确认坏账当月': '财务确认坏账当月',
  '正常推送': '正常推送',
  '不推送': '不推送',
  '移除': '移除',
  '推送到特体': '推送到特体',
  '停产': '停产',
  '缺货': '缺货',
  '预订': '预订',
  '共享设计项': '共享设计项',
  '订单错误': '订单错误',
  '客户投诉': '客户投诉',
  '数据安全': '数据安全',
  '考勤': '考勤',
  '请输入处罚描述': '请输入处罚描述',
  '添加成功': '添加成功',
  '添加失败': '添加失败',
  '请先勾选违规项': '请先勾选违规项',
  '请选择处罚月份': '请选择处罚月份',
  '处罚记录保存成功': '处罚记录保存成功',
  '违规情形': '违规情形',
  '处罚金额': '处罚金额',
  '模拟': '模拟',
  '确认删除？': '确认删除？',
  '管理违规处罚规则及扣款标准': '管理违规处罚规则及扣款标准',
  '新增规则': '新增规则',
  '新增处罚规则': '新增处罚规则',
  '处罚描述': '处罚描述',
  '描述违规情形': '描述违规情形',
  '处罚金额 (CNY)': '处罚金额 (CNY)',
  '确认添加': '确认添加',
  '处罚模拟器': '处罚模拟器',
  '勾选左侧违规项，自动汇总当月扣款': '勾选左侧违规项，自动汇总当月扣款',
  '合计扣款': '合计扣款',
  '保存处罚记录': '保存处罚记录',
  '请在左侧勾选违规项': '请在左侧勾选违规项',
  '处罚执行说明': '处罚执行说明',
  '处罚按实际规则全额执行，不设额外上限': '处罚按实际规则全额执行，不设额外上限',
  '当月工资不足扣除时，顺延至下月': '当月工资不足扣除时，顺延至下月',
  '所有处罚需有记录和通知': '所有处罚需有记录和通知',
  '员工有权在3个工作日内申诉': '员工有权在3个工作日内申诉',
  '员工姓名 *': '员工姓名 *',
  '处罚月份 *': '处罚月份 *',
  '本次处罚合计': '本次处罚合计',
  '项违规': '项违规',
  '处罚历史记录': '处罚历史记录',
  '选择月份筛选': '选择月份筛选',
  '无折扣': '无折扣',
  '轻微优惠': '轻微优惠',
  '常规折扣': '常规折扣',
  '大客户折扣': '大客户折扣',
  '战略折扣': '战略折扣',
  '— 通配': '— 通配',
  '物流费用': '物流费用',
  '物流费用功能开发中': '物流费用功能开发中',
  ' 等': ' 等',
  '加载设计项...': '加载设计项...',
  '暂无设计项': '暂无设计项',
  '... 更多设计': '... 更多设计',
  '海军蓝人字纹': '海军蓝人字纹',
  '深灰大方格': '深灰大方格',
  '咖啡色纯亚麻': '咖啡色纯亚麻',
  '面料 D': '面料 D',
  '面料 E': '面料 E',
  '面料 F': '面料 F',
  '面料 G': '面料 G',
  '面料 H': '面料 H',
  '面料 I': '面料 I',
  '面料 J': '面料 J',
  '请从左侧选择设计项': '请从左侧选择设计项',
  '已锁定（与': '已锁定（与',
  '相同）': '相同）',
  '未选择': '未选择',
  '搜索编号/名称...': '搜索编号/名称...',
  '套装内所有品类使用相同面料，如需不同面料请分开下单': '套装内所有品类使用相同面料，如需不同面料请分开下单',
  '客供面料（CMT来料加工）：由客户自行提供面料，发票中面料费用为零，仅计工艺加工费。请填写每块面料的物流信息。': '客供面料（CMT来料加工）：由客户自行提供面料，发票中面料费用为零，仅计工艺加工费。请填写每块面料的物流信息。',
  '面料 #': '面料 #',
  '如：Holland & Sherry': '如：Holland & Sherry',
  '如：HS-2024-001': '如：HS-2024-001',
  '如：细条纹、人字纹': '如：细条纹、人字纹',
  '如：150': '如：150',
  '如：DHL、顺丰': '如：DHL、顺丰',
  '快递运单号': '快递运单号',
  '如：3': '如：3',
  '+ 添加面料': '+ 添加面料',
  '自由选择款式细节，完全个性化定制': '自由选择款式细节，完全个性化定制',
  '从样衣库中选择已有款式，一键下单': '从样衣库中选择已有款式，一键下单',
  '暂无设计选项': '暂无设计选项',
  '✓ 已选择': '✓ 已选择',
  '上传失败': '上传失败',
  '请至少上传一张图片': '请至少上传一张图片',
  '确认发货成功': '确认发货成功',
  '提交失败': '提交失败',
  '链接无效或已过期': '链接无效或已过期',
  '物料类型': '物料类型',
  '采购折扣价': '采购折扣价',
  '批量采购编号': '批量采购编号',
  '全部已发货': '全部已发货',
  '合并采购单': '合并采购单',
  '供应商：': '供应商：',
  '联系人：': '联系人：',
  '供应商电话：': '供应商电话：',
  '收件信息': '收件信息',
  '加工厂名': '加工厂名',
  '收件地址': '收件地址',
  '采购单：': '采购单：',
  '金额:': '金额:',
  '折扣:': '折扣:',
  '物流商': '物流商',
  '发货单号': '发货单号',
  '发货凭证': '发货凭证',
  '个采购单，': '个采购单，',
  '总金额:': '总金额:',
  '折扣总金额:': '折扣总金额:',
  '统一确认发货': '统一确认发货',
  '请选择物流商': '请选择物流商',
  '请输入发货单号': '请输入发货单号',
  '发货凭证图片': '发货凭证图片',
  '上传': '上传',
  '请输入备注（可选）': '请输入备注（可选）',
  '确认已发货': '确认已发货',
  '全部采购单已确认发货': '全部采购单已确认发货',
  '如有疑问，请联系采购方工作人员': '如有疑问，请联系采购方工作人员',
  '类型名称': '类型名称',
  '物料名称': '物料名称',
  '输入订单号搜索': '输入订单号搜索',
  '请输入物料名称': '请输入物料名称',
  '采购明细': '采购明细',
  '发货信息': '发货信息',
  '无图片': '无图片',
  '确认发货': '确认发货',
  '快速切换至其他用户账号': '快速切换至其他用户账号',
  '功能开发中...': '功能开发中...',
  '业务员（定制单）': '业务员（定制单）',
  '按单笔订单金额计算提成': '按单笔订单金额计算提成',
  '业务员（团单）': '业务员（团单）',
  '按团单总金额计算提成': '按团单总金额计算提成',
  '按单笔订单固定金额提成': '按单笔订单固定金额提成',
  '管理员/老板': '管理员/老板',
  '管理员提成配置': '管理员提成配置',
  '参考汇率（CNY/USD）': '参考汇率（CNY/USD）',
  '通用参数': '通用参数',
  '用于提成计算中 USD→CNY 转换，实际发薪以当月汇率为准': '用于提成计算中 USD→CNY 转换，实际发薪以当月汇率为准',
  '人力成本上限比例': '人力成本上限比例',
  '人力成本占销售额上限（如 8 = 8%）': '人力成本占销售额上限（如 8 = 8%）',
  '最低折扣系数': '最低折扣系数',
  '折扣参数': '折扣参数',
  '低于此折扣需要管理员审批（如 0.7 = 7折）': '低于此折扣需要管理员审批（如 0.7 = 7折）',
  '裂变提成比例': '裂变提成比例',
  '提成参数': '提成参数',
  '新客户裂变提成比例（如 0.005 = 0.5%）': '新客户裂变提成比例（如 0.005 = 0.5%）',
  '裂变提成期限（月）': '裂变提成期限（月）',
  '裂变提成计算的有效月数': '裂变提成计算的有效月数',
  '最大裂变层数': '最大裂变层数',
  '裂变提成最多计算的层级数': '裂变提成最多计算的层级数',
  '加载配置失败': '加载配置失败',
  '该参数键名已存在': '该参数键名已存在',
  '配置已保存': '配置已保存',
  '已重置为默认值，请刷新页面': '已重置为默认值，请刷新页面',
  '重置失败': '重置失败',
  '新增参数': '新增参数',
  '参数键名': '参数键名',
  '参数值': '参数值',
  '显示名称': '显示名称',
  '人民币/美元汇率': '人民币/美元汇率',
  '数字': '数字',
  '字符串': '字符串',
  '布尔值': '布尔值',
  '分组': '分组',
  '描述': '描述',
  '参数说明': '参数说明',
  '汇率、基础费率等全局配置': '汇率、基础费率等全局配置',
  '提成计算相关参数': '提成计算相关参数',
  '折扣审批和限制相关': '折扣审批和限制相关',
  '提成阶梯配置': '提成阶梯配置',
  '按角色配置不同的提成阶梯规则': '按角色配置不同的提成阶梯规则',
  '下限金额': '下限金额',
  '上限金额': '上限金额',
  '提成比例/金额': '提成比例/金额',
  '无上限': '无上限',
  '百分比(%)': '百分比(%)',
  '固定金额': '固定金额',
  '添加阶梯': '添加阶梯',
  '确定重置为默认配置吗？': '确定重置为默认配置吗？',
  '确定': '确定',
  '重置默认': '重置默认',
  '保存全部配置': '保存全部配置',
  '加载系统配置...': '加载系统配置...',
  '管理系统全局参数和提成阶梯配置': '管理系统全局参数和提成阶梯配置',
  '全局参数': '全局参数',
  '提成阶梯': '提成阶梯',
  '基础信息': '基础信息',
  '地址信息': '地址信息',
  '尺寸信息': '尺寸信息',
  '交期信息': '交期信息',
  '直接映射': '直接映射',
  '枚举映射': '枚举映射',
  '固定值': '固定值',
  '组合映射': '组合映射',
  '客户电话': '客户电话',
  '收货地址': '收货地址',
  '顾客姓名(webName)': '顾客姓名(webName)',
  '电话(webPhone)': '电话(webPhone)',
  '地址(webAddress)': '地址(webAddress)',
  '快递(webExpress)': '快递(webExpress)',
  '身高(tech1)': '身高(tech1)',
  '体重(tech11)': '体重(tech11)',
  '试衣(webQQ)': '试衣(webQQ)',
  '工艺备注(suggest)': '工艺备注(suggest)',
  '单马甲': '单马甲',
  '2件套(上衣+西裤)': '2件套(上衣+西裤)',
  '3件套(上衣+西裤+马甲)': '3件套(上衣+西裤+马甲)',
  '马甲+裤子': '马甲+裤子',
  'coat(西上装)': 'coat(西上装)',
  'topcoat(大衣)': 'topcoat(大衣)',
  'pant(西裤)': 'pant(西裤)',
  'vest(马甲)': 'vest(马甲)',
  'shirt(衬衫)': 'shirt(衬衫)',
  '1A1B(2件套)': '1A1B(2件套)',
  '1A1B1C(3件套)': '1A1B1C(3件套)',
  '1B1C(马甲+裤子)': '1B1C(马甲+裤子)',
  '自动': '自动',
  '已人工确认': '已人工确认',
  'CMT加工费 / 面料编号': 'CMT加工费 / 面料编号',
  'CMT来料加工无需选择系统面料': 'CMT来料加工无需选择系统面料',
  '保存草稿失败': '保存草稿失败',
  '搜索结果': '搜索结果',
  '作废后关联订单将恢复为未开票状态，是否继续？': '作废后关联订单将恢复为未开票状态，是否继续？',
  '取消核对': '取消核对',
  '标记为已核对': '标记为已核对',
  '导出Excel成功': '导出Excel成功',
  '导出PDF成功': '导出PDF成功',
  '已取消核对': '已取消核对',
  '已标记为已核对': '已标记为已核对',
  '已转为正式发票': '已转为正式发票',
  '正在生成Excel...': '正在生成Excel...',
  '正在生成PDF...': '正在生成PDF...',
  '确认作废': '确认作废',
  '确认作废发票': '确认作废发票',
  '确认驳回': '确认驳回',
  '确认驳回发票': '确认驳回发票',
  '驳回后关联订单将恢复为未开票状态，是否继续？': '驳回后关联订单将恢复为未开票状态，是否继续？',
  '转正式发票': '转正式发票',
  '确认保存草稿': '确认保存草稿',
  '草稿保存成功': '草稿保存成功',
  '订单出入库': '订单出入库',
  '出入库类型': '出入库类型',
  '入库': '入库',
  '出库': '出库',
  '工厂编号': '工厂编号',
  '订单编号': '订单编号',
  '备注信息': '备注信息',
  '新增记录': '新增记录',
  '编辑出入库记录': '编辑出入库记录',
  '新增出入库记录': '新增出入库记录',
  '管理订单的入库与出库记录': '管理订单的入库与出库记录',
  '请选择出入库类型': '请选择出入库类型',
  '请输入工厂编号': '请输入工厂编号',
  '请输入订单编号': '请输入订单编号',
  '请输入物流公司': '请输入物流公司',
  '请输入物流单号': '请输入物流单号',
  '请输入备注信息': '请输入备注信息',
  '0.15-0.6 双贡针': '0.15-0.6 双贡针',
  '0.15-0.9 双贡针': '0.15-0.9 双贡针',
  '0.15-0.9cm 双贡针': '0.15-0.9cm 双贡针',
  '0.15cm 贡针': '0.15cm 贡针',
  '0.3cm 贡针': '0.3cm 贡针',
  '0.6cm 贡针': '0.6cm 贡针',
  '0.9cm 贡针': '0.9cm 贡针',
  '1 个平叠锁眼 + 1 纽扣': '1 个平叠锁眼 + 1 纽扣',
  '1 个平斜锁眼 + 1 纽扣': '1 个平斜锁眼 + 1 纽扣',
  '1 个平斜锁眼+1 纽扣': '1 个平斜锁眼+1 纽扣',
  '1 个平锁眼 + 1 纽扣': '1 个平锁眼 + 1 纽扣',
  '1 个斜叠锁眼 + 1 纽扣': '1 个斜叠锁眼 + 1 纽扣',
  '2 个平叠锁眼 + 2 纽扣': '2 个平叠锁眼 + 2 纽扣',
  '2 个平斜锁眼 + 2 纽扣': '2 个平斜锁眼 + 2 纽扣',
  '2 个平斜锁眼+2 纽扣': '2 个平斜锁眼+2 纽扣',
  '2 个平锁眼 + 2 纽扣': '2 个平锁眼 + 2 纽扣',
  '2 个斜叠锁眼 + 2 纽扣': '2 个斜叠锁眼 + 2 纽扣',
  '2 件套': '2 件套',
  '2 次代用料毛样': '2 次代用料毛样',
  '20米以上价格': '20米以上价格',
  '3 个平叠锁眼+3 纽扣': '3 个平叠锁眼+3 纽扣',
  '3 个平斜锁眼+3 纽扣': '3 个平斜锁眼+3 纽扣',
  '3 个平锁眼 + 3 纽扣': '3 个平锁眼 + 3 纽扣',
  '3 个平锁眼+3 纽扣': '3 个平锁眼+3 纽扣',
  '3 个斜叠锁眼+3 纽扣': '3 个斜叠锁眼+3 纽扣',
  '3 个贴袋': '3 个贴袋',
  '3 件套': '3 件套',
  '4 个平叠锁眼+4 纽扣': '4 个平叠锁眼+4 纽扣',
  '4 个平斜锁眼+4 纽扣': '4 个平斜锁眼+4 纽扣',
  '4 个平锁眼 + 4 纽扣': '4 个平锁眼 + 4 纽扣',
  '4 个平锁眼+4 纽扣': '4 个平锁眼+4 纽扣',
  '4 个斜叠锁眼+4 纽扣': '4 个斜叠锁眼+4 纽扣',
  '5 个平叠锁眼+5 纽扣': '5 个平叠锁眼+5 纽扣',
  '5 个平斜锁眼+5 纽扣': '5 个平斜锁眼+5 纽扣',
  '5 个平锁眼 + 5 纽扣': '5 个平锁眼 + 5 纽扣',
  '5 个平锁眼+5 纽扣': '5 个平锁眼+5 纽扣',
  '5 个斜叠锁眼+5 纽扣': '5 个斜叠锁眼+5 纽扣',
  '5.5cm 袋盖': '5.5cm 袋盖',
  '6 个平叠锁眼+6 纽扣': '6 个平叠锁眼+6 纽扣',
  '6 个平斜锁眼+6 纽扣': '6 个平斜锁眼+6 纽扣',
  '6 个平锁眼 + 6 纽扣': '6 个平锁眼 + 6 纽扣',
  '6 个平锁眼+6 纽扣': '6 个平锁眼+6 纽扣',
  '6 个斜叠锁眼+6 纽扣': '6 个斜叠锁眼+6 纽扣',
  '6.5cm 袋盖': '6.5cm 袋盖',
  '60米以上价格': '60米以上价格',
  '7.5cm 袋盖': '7.5cm 袋盖',
  '8.5cm 袋盖': '8.5cm 袋盖',
  'AI 生成最终款式图': 'AI 生成最终款式图',
  'API 配置': 'API 配置',
  'API配置': 'API配置',
  'CMT工艺费（USD）': 'CMT工艺费（USD）',
  'IP 地址': 'IP 地址',
  'POLO 门襟 3.5cm（门襟 3 扣）': 'POLO 门襟 3.5cm（门襟 3 扣）',
  'POLO 门襟 3cm（门襟 3 扣）': 'POLO 门襟 3cm（门襟 3 扣）',
  'RTW成衣': 'RTW成衣',
  'RTW成衣价格表': 'RTW成衣价格表',
  'V 型开口': 'V 型开口',
  'V 领': 'V 领',
  '一字半里（包边）': '一字半里（包边）',
  '一字半里（贡针）': '一字半里（贡针）',
  '一字胸袋+下单开线袋': '一字胸袋+下单开线袋',
  '一字胸袋+下双开线袋': '一字胸袋+下双开线袋',
  '一字胸袋+下贴袋': '一字胸袋+下贴袋',
  '一字领（外弧 CUTAWAY）': '一字领（外弧 CUTAWAY）',
  '一片领': '一片领',
  '一金（住房公积金）': '一金（住房公积金）',
  '三件套西装': '三件套西装',
  '上一字胸袋+下双线袋有袋盖': '上一字胸袋+下双线袋有袋盖',
  '上一步': '上一步',
  '上下都无口袋': '上下都无口袋',
  '上传体型照': '上传体型照',
  '体型照': '体型照',
  '上传凭证': '上传凭证',
  '上传图片': '上传图片',
  '上左右一字袋+下左右一字袋': '上左右一字袋+下左右一字袋',
  '上弧形': '上弧形',
  '上衣 + 马甲': '上衣 + 马甲',
  '上衣长短习惯': '上衣长短习惯',
  '下一步': '下一步',
  '下单日期': '下单日期',
  '下单日期（B 端）': '下单日期（B 端）',
  '下口袋袋盖高度': '下口袋袋盖高度',
  '下圆青果领': '下圆青果领',
  '下弧形': '下弧形',
  '下摆型': '下摆型',
  '下载': '下载',
  '不可拆卸插片': '不可拆卸插片',
  '不合格': '不合格',
  '不合格原因': '不合格原因',
  '不合格数量': '不合格数量',
  '不试身': '不试身',
  '专业能力': '专业能力',
  '业务员': '业务员',
  '业务经理': '业务经理',
  '两件套西装': '两件套西装',
  '个人分红': '个人分红',
  '个人所得税': '个人所得税',
  '个人提成阶梯': '个人提成阶梯',
  '个人资料': '个人资料',
  '个性收费': '个性收费',
  '个性收费项配置': '个性收费项配置',
  '中圆青果领': '中圆青果领',
  '中文': '中文',
  '中文名称': '中文名称',
  '中腰': '中腰',
  '中英双语': '中英双语',
  '主题': '主题',
  '争议处理': '争议处理',
  '事事如意': '事事如意',
  '五险（保险）': '五险（保险）',
  '亚麻系列': '亚麻系列',
  '交易日期': '交易日期',
  '人民币参考': '人民币参考',
  '仅复用客户信息': '仅复用客户信息',
  '仅复用款式': '仅复用款式',
  '今日新增订单': '今日新增订单',
  '仓储物流': '仓储物流',
  '付款信息': '付款信息',
  '付款审核': '付款审核',
  '付款审核中': '付款审核中',
  '付款已确认': '付款已确认',
  '付款异常': '付款异常',
  '付款方式': '付款方式',
  '付款状态': '付款状态',
  '付款记录': '付款记录',
  '付款金额': '付款金额',
  '代用料手工毛样': '代用料手工毛样',
  '代用料毛样': '代用料毛样',
  '代采购': '代采购',
  '价格': '价格',
  '价格体系': '价格体系',
  '价格如有变动，恕不另行通知。': '价格如有变动，恕不另行通知。',
  '价格档': '价格档',
  '客供价格档': '客供价格档',
  '价格档次': '价格档次',
  '价格等级表': '价格等级表',
  '优先级': '优先级',
  '优先（10 天）': '优先（10 天）',
  '优惠活动': '优惠活动',
  '伸缩调节袢纽扣': '伸缩调节袢纽扣',
  '住房公积金': '住房公积金',
  '体型及尺寸档案': '体型及尺寸档案',
  '体型描述': '体型描述',
  '体型特征': '体型特征',
  '体重': '体重',
  '体重超出正常范围，请检查修改。': '体重超出正常范围，请检查修改。',
  '余款须在发货前结清。': '余款须在发货前结清。',
  '供应商': '供应商',
  '供应商对账单': '供应商对账单',
  '供应商管理': '供应商管理',
  '工厂映射导入': '工厂映射导入',
  '工厂映射数据管理': '工厂映射数据管理',
  '导入选项': '导入选项',
  '试运行（不写入数据库）': '试运行（不写入数据库）',
  '清空该工厂旧映射后再导入': '清空该工厂旧映射后再导入',
  'JD-HP 推送映射表': 'JD-HP 推送映射表',
  '设计选项表': '设计选项表',
  '对应文件：JD-HP推送映射完整对照表-Final.xlsx': '对应文件：JD-HP推送映射完整对照表-Final.xlsx',
  '对应文件：09_设计选项_JD_V1.5.xlsx': '对应文件：09_设计选项_JD_V1.5.xlsx',
  '请至少上传一个映射 Excel 文件': '请至少上传一个映射 Excel 文件',
  '试运行完成，请查看结果': '试运行完成，请查看结果',
  '从 Excel 批量导入设计选项与工厂工艺编码映射': '从 Excel 批量导入设计选项与工厂工艺编码映射',
  '导入结果': '导入结果',
  '当前为试运行模式，未实际写入数据库': '当前为试运行模式，未实际写入数据库',
  '映射类型': '映射类型',
  '错误信息': '错误信息',
  '侧伸缩腰': '侧伸缩腰',
  '侧开叉': '侧开叉',
  '侧松紧腰': '侧松紧腰',
  '侧缝顺色哑光色丁 1.5cm': '侧缝顺色哑光色丁 1.5cm',
  '侧缝顺色哑光色丁 2.5cm': '侧缝顺色哑光色丁 2.5cm',
  '侧缝黑色哑光色丁 1.5cm': '侧缝黑色哑光色丁 1.5cm',
  '侧缝黑色哑光色丁 2.5cm': '侧缝黑色哑光色丁 2.5cm',
  '保存': '保存',
  '保存修改': '保存修改',
  '保存失败': '保存失败',
  '保存成功': '保存成功',
  '信用卡': '信用卡',
  '信用额度': '信用额度',
  '信用额度管理': '信用额度管理',
  '修改密码': '修改密码',
  '修改设置': '修改设置',
  '修改费': '修改费',
  '修身': '修身',
  '倒缝袖（垫肩 0.1cm + 单层棉条 + 自然褶）': '倒缝袖（垫肩 0.1cm + 单层棉条 + 自然褶）',
  '倒缝袖（无垫肩 + 无棉条 + 自然褶）': '倒缝袖（无垫肩 + 无棉条 + 自然褶）',
  '假袖叉假锁眼': '假袖叉假锁眼',
  '假袖叉圆头锁眼': '假袖叉圆头锁眼',
  '假袖叉圆弧翻边（4.5cm）': '假袖叉圆弧翻边（4.5cm）',
  '假袖叉圆弧翻边（7.5cm）': '假袖叉圆弧翻边（7.5cm）',
  '假袖叉无锁眼': '假袖叉无锁眼',
  '假袖叉直翻边（4.5cm）': '假袖叉直翻边（4.5cm）',
  '假袖叉直翻边（7.5cm）': '假袖叉直翻边（7.5cm）',
  '停用': '停用',
  '催款通知': '催款通知',
  '充值 / 退款金额': '充值 / 退款金额',
  '充值记录': '充值记录',
  '光门襟 3.5cm': '光门襟 3.5cm',
  '光门襟 3cm': '光门襟 3cm',
  '克重': '克重',
  '免熨系列': '免熨系列',
  '免费系列': '免费系列',
  '入门档': '入门档',
  '全体员工总权重': '全体员工总权重',
  '全勤': '全勤',
  '全屏': '全屏',
  '全手工': '全手工',
  '全手工全麻衬厚胸衬': '全手工全麻衬厚胸衬',
  '全手工全麻衬薄胸衬': '全手工全麻衬薄胸衬',
  '全松紧腰': '全松紧腰',
  '全松紧（前门襟无松紧）': '全松紧（前门襟无松紧）',
  '全衬': '全衬',
  '全裤袢 10 个 1cm': '全裤袢 10 个 1cm',
  '全裤袢 2cm': '全裤袢 2cm',
  '全裤袢 6 个 1cm': '全裤袢 6 个 1cm',
  '全裤袢 7 个 1cm': '全裤袢 7 个 1cm',
  '全裤袢 8 个 1cm': '全裤袢 8 个 1cm',
  '全贡针': '全贡针',
  '全部': '全部',
  '全部收起': '全部收起',
  '全部已读': '全部已读',
  '全里': '全里',
  '全麻衬厚胸衬': '全麻衬厚胸衬',
  '全麻衬薄胸衬': '全麻衬薄胸衬',
  '公司仓库': '公司仓库',
  '公告': '公告',
  '共': '共',
  '关税': '关税',
  '关联单号': '关联单号',
  '关联售后工单': '关联售后工单',
  '关联工厂': '关联工厂',
  '关闭': '关闭',
  '其他': '其他',
  '其他奖金': '其他奖金',
  '其他成员团单合计': '其他成员团单合计',
  '其他成员定制单合计': '其他成员定制单合计',
  '其他扣款': '其他扣款',
  '其他服装': '其他服装',
  '其他费用': '其他费用',
  '其它费用': '其它费用',
  '其它费用/关税': '其它费用/关税',
  '内容': '内容',
  '内折 5cm': '内折 5cm',
  '内折 7cm': '内折 7cm',
  '内滚条': '内滚条',
  '内袋款式': '内袋款式',
  '内袖口撞色': '内袖口撞色',
  '内贡针及贡针线': '内贡针及贡针线',
  '内过肩撞色': '内过肩撞色',
  '内门襟撞色': '内门襟撞色',
  '内领+内袖口+内门襟撞色': '内领+内袖口+内门襟撞色',
  '内领+内袖口撞色': '内领+内袖口撞色',
  '内领底居中': '内领底居中',
  '内领撞色': '内领撞色',
  '冬季': '冬季',
  '净尺寸': '净尺寸',
  '准直胸袋': '准直胸袋',
  '减少': '减少',
  '减少品类信息将丢失': '减少品类信息将丢失',
  '凭证/参考号': '凭证/参考号',
  '凭证截图': '凭证截图',
  '出生日期': '出生日期',
  '出货期': '出货期',
  '出货通知': '出货通知',
  '分红年份': '分红年份',
  '分红池比例': '分红池比例',
  '切角 1 眼 2 扣': '切角 1 眼 2 扣',
  '切角 2 用': '切角 2 用',
  '切角 2 眼 2 扣': '切角 2 眼 2 扣',
  '创建失败': '创建失败',
  '创建新订单': '创建新订单',
  '创建日期': '创建日期',
  '创建时间': '创建时间',
  '创建订单': '创建订单',
  '创建订单过程中，系统会自动保存您的进度': '创建订单过程中，系统会自动保存您的进度',
  '初审通过': '初审通过',
  '删除': '删除',
  '删除失败': '删除失败',
  '删除订单': '删除订单',
  '利润汇总': '利润汇总',
  '刷新': '刷新',
  '刷新重试': '刷新重试',
  '刺绣位置': '刺绣位置',
  '刺绣内容': '刺绣内容',
  '刺绣备注': '刺绣备注',
  '刺绣姓名缩写': '刺绣姓名缩写',
  '刺绣字体': '刺绣字体',
  '刺绣设计': '刺绣设计',
  '刺绣高度': '刺绣高度',
  '前后全里': '前后全里',
  '前后半里': '前后半里',
  '前挺缝线': '前挺缝线',
  '前浪': '前浪',
  '前片全里': '前片全里',
  '前片半里': '前片半里',
  '前片设计': '前片设计',
  '前片贴布': '前片贴布',
  '前端分类项配置': '前端分类项配置',
  '前端渲染发生错误': '前端渲染发生错误',
  '前胸宽': '前胸宽',
  '前腰节': '前腰节',
  '前腰节长': '前腰节长',
  '前衣长': '前衣长',
  '前长': '前长',
  '前领 1 个纽扣': '前领 1 个纽扣',
  '前领 2 个纽扣': '前领 2 个纽扣',
  '剪刀型': '剪刀型',
  '加入购物车': '加入购物车',
  '加急单数量': '加急单数量',
  '加急费': '加急费',
  '加急（7 天）': '加急（7 天）',
  '加载中…': '加载中…',
  '包装升级': '包装升级',
  '千克': '千克',
  '半圆形半里（包边）': '半圆形半里（包边）',
  '半圆形半里（贡针）': '半圆形半里（贡针）',
  '半手工半麻衬厚胸衬': '半手工半麻衬厚胸衬',
  '半手工半麻衬薄胸衬': '半手工半麻衬薄胸衬',
  '半手工无结构无胸衬': '半手工无结构无胸衬',
  '半衬': '半衬',
  '半贡针': '半贡针',
  '半麻衬厚胸衬': '半麻衬厚胸衬',
  '半麻衬薄胸衬': '半麻衬薄胸衬',
  '单 6 扣': '单 6 扣',
  '单上衣': '单上衣',
  '单价': '单价',
  '单价（USD）': '单价（USD）',
  '单位': '单位',
  '单大衣': '单大衣',
  '单开线竖口袋': '单开线竖口袋',
  '单开线袋+锁眼钉扣': '单开线袋+锁眼钉扣',
  '单开线袋（无眼无扣）': '单开线袋（无眼无扣）',
  '单排 1 粒对拉扣': '单排 1 粒对拉扣',
  '单排 1 粒扣': '单排 1 粒扣',
  '单排 2 粒扣': '单排 2 粒扣',
  '单排 3 扣': '单排 3 扣',
  '单排 3 扣 2': '单排 3 扣 2',
  '单排 3 粒扣': '单排 3 粒扣',
  '单排 4 扣': '单排 4 扣',
  '单排 5 扣': '单排 5 扣',
  '单独发': '单独发',
  '单独开票': '单独开票',
  '单省道': '单省道',
  '单线袋': '单线袋',
  '单线袋（1.2cm）': '单线袋（1.2cm）',
  '单衬衫': '单衬衫',
  '单褶向内': '单褶向内',
  '单褶向内+手工套结': '单褶向内+手工套结',
  '单褶向外': '单褶向外',
  '单褶向外+手工套结': '单褶向外+手工套结',
  '单西裙': '单西裙',
  '单西裤': '单西裤',
  '单边宝剑头调节袢': '单边宝剑头调节袢',
  '单边小弧形调节袢': '单边小弧形调节袢',
  '单边廓尔格腰': '单边廓尔格腰',
  '卡袋上订商标 + 面料标': '卡袋上订商标 + 面料标',
  '卡袋上订商标+面料标': '卡袋上订商标+面料标',
  '厘米': '厘米',
  '原金额': '原金额',
  '参考值': '参考值',
  '参考汇率': '参考汇率',
  '双开叉无防风条': '双开叉无防风条',
  '双开叉防风条': '双开叉防风条',
  '双开线竖口袋': '双开线竖口袋',
  '双开线袋+圆扣袢+锁眼钉扣': '双开线袋+圆扣袢+锁眼钉扣',
  '双开线袋+锁眼钉扣': '双开线袋+锁眼钉扣',
  '双开线袋（无眼无扣）': '双开线袋（无眼无扣）',
  '双排 2 扣 1': '双排 2 扣 1',
  '双排 4 扣 2': '双排 4 扣 2',
  '双排 4 扣 2+尖下摆': '双排 4 扣 2+尖下摆',
  '双排 5 扣 3 斜门襟': '双排 5 扣 3 斜门襟',
  '双排 6 扣 1': '双排 6 扣 1',
  '双排 6 扣 2': '双排 6 扣 2',
  '双排 6 扣 2+尖下摆': '双排 6 扣 2+尖下摆',
  '双排 6 扣 3': '双排 6 扣 3',
  '双排 6 扣 3 斜门襟+尖下摆': '双排 6 扣 3 斜门襟+尖下摆',
  '双排 6 扣 3+尖下摆': '双排 6 扣 3+尖下摆',
  '双排 8 扣 4': '双排 8 扣 4',
  '双排 8 扣 4+尖下摆': '双排 8 扣 4+尖下摆',
  '双省道': '双省道',
  '双线大袋（有袋盖）+ 一字票袋（无袋盖）': '双线大袋（有袋盖）+ 一字票袋（无袋盖）',
  '双线大袋（有袋盖）+ 双线票袋（有袋盖）': '双线大袋（有袋盖）+ 双线票袋（有袋盖）',
  '双线大袋（直角袋盖）+双线票袋（直角袋盖）': '双线大袋（直角袋盖）+双线票袋（直角袋盖）',
  '双线袋': '双线袋',
  '双线袋 + 小圆直袋盖': '双线袋 + 小圆直袋盖',
  '双线袋无袋盖': '双线袋无袋盖',
  '双线袋（无盖）+ 双线票袋（无盖）': '双线袋（无盖）+ 双线票袋（无盖）',
  '双褶向内': '双褶向内',
  '双褶向内+手工套结': '双褶向内+手工套结',
  '双褶向外+手工套结': '双褶向外+手工套结',
  '双褶外': '双褶外',
  '双边廓尔格腰': '双边廓尔格腰',
  '发票列表': '发票列表',
  '发票号': '发票号',
  '总金额合计': '总金额合计',
  '共 {n} 张': '共 {n} 张',
  '发票数': '发票数',
  '发票记录': '发票记录',
  '发货': '发货',
  '发货中': '发货中',
  '发货单': '发货单',
  '发货管理': '发货管理',
  '发起售后': '发起售后',
  '发送失败': '发送失败',
  '发送状态': '发送状态',
  '发送给供应商': '发送给供应商',
  '取消': '取消',
  '取消后订单将无法恢复': '取消后订单将无法恢复',
  '取消订单': '取消订单',
  '取消订单失败，请联系客服。': '取消订单失败，请联系客服。',
  '取消选择': '取消选择',
  '口袋': '口袋',
  '古巴领': '古巴领',
  '可拆卸插片': '可拆卸插片',
  '可用': '可用',
  '可用余额': '可用余额',
  '可用额度': '可用额度',
  '右 3': '右 3',
  '右前 1 个裤袢 1cm': '右前 1 个裤袢 1cm',
  '右前 1 个裤袢 2cm': '右前 1 个裤袢 2cm',
  '右前片下腰口': '右前片下腰口',
  '右前腰部（第 4 个纽扣右侧）': '右前腰部（第 4 个纽扣右侧）',
  '右单开线袋+锁眼钉扣': '右单开线袋+锁眼钉扣',
  '右单开线袋（无眼无扣）': '右单开线袋（无眼无扣）',
  '右双开线袋+桃型袋盖': '右双开线袋+桃型袋盖',
  '右双开线袋+菱形袋盖': '右双开线袋+菱形袋盖',
  '右双开线袋+锁眼钉扣': '右双开线袋+锁眼钉扣',
  '右双开线袋（无眼无扣）': '右双开线袋（无眼无扣）',
  '右开线袋+圆扣袢+锁眼钉扣': '右开线袋+圆扣袢+锁眼钉扣',
  '右手腕': '右手腕',
  '右挂面袋上居中': '右挂面袋上居中',
  '右腰线上双线袋+右袋布内': '右腰线上双线袋+右袋布内',
  '右腰线上双线袋+左袋布内': '右腰线上双线袋+左袋布内',
  '右腰缝上一字袋+右袋布内': '右腰缝上一字袋+右袋布内',
  '右腰缝上一字袋+左袋布内': '右腰缝上一字袋+左袋布内',
  '右腰里刺绣': '右腰里刺绣',
  '右腰里订商标': '右腰里订商标',
  '右腰里订面料标': '右腰里订面料标',
  '右腰顶开缝袋': '右腰顶开缝袋',
  '右表袋+桃型袋盖+锁眼钉扣': '右表袋+桃型袋盖+锁眼钉扣',
  '右表袋+菱形袋盖+锁眼钉扣': '右表袋+菱形袋盖+锁眼钉扣',
  '右袖口': '右袖口',
  '右袖长': '右袖长',
  '右里袋上居中': '右里袋上居中',
  '右驳头眼顺边绣': '右驳头眼顺边绣',
  '合体': '合体',
  '合体要求': '合体要求',
  '合作年限': '合作年限',
  '合作状态': '合作状态',
  '合作等级': '合作等级',
  '合作门店': '合作门店',
  '合并发票': '合并发票',
  '合并开票': '合并开票',
  '合格': '合格',
  '合格数量': '合格数量',
  '同上衣里布': '同上衣里布',
  '同大身': '同大身',
  '同步失败': '同步失败',
  '同西服上衣': '同西服上衣',
  '后中衩': '后中衩',
  '后中长': '后中长',
  '后台日期': '后台日期',
  '后尖角贴袋': '后尖角贴袋',
  '后开叉型': '后开叉型',
  '后开衩': '后开衩',
  '后片省': '后片省',
  '后片设计': '后片设计',
  '后端服务返回错误': '后端服务返回错误',
  '后背内工字褶': '后背内工字褶',
  '后背双褶': '后背双褶',
  '后背双褶+双省': '后背双褶+双省',
  '后背宽': '后背宽',
  '后背明工字褶': '后背明工字褶',
  '后背明工字褶+双省': '后背明工字褶+双省',
  '后背用料': '后背用料',
  '后腰开口': '后腰开口',
  '后腰节': '后腰节',
  '后腰节长': '后腰节长',
  '后衣长': '后衣长',
  '后表袋+桃型袋盖+暗锁眼钉扣': '后表袋+桃型袋盖+暗锁眼钉扣',
  '后表袋+菱形袋盖+暗锁眼钉扣': '后表袋+菱形袋盖+暗锁眼钉扣',
  '后领底尼上口居中': '后领底尼上口居中',
  '后领底尼下口居中': '后领底尼下口居中',
  '启用': '启用',
  '告警': '告警',
  '员工': '员工',
  '员工分红比例': '员工分红比例',
  '员工工资汇总': '员工工资汇总',
  '品牌': '品牌',
  '品牌名称': '品牌名称',
  '品类': '品类',
  '品类选择': '品类选择',
  '品类配置': '品类配置',
  '品质': '品质',
  '响应速度': '响应速度',
  '售后': '售后',
  '售后信息': '售后信息',
  '售后工单': '售后工单',
  '售后申请失败，请稍后重试。': '售后申请失败，请稍后重试。',
  '售后管理': '售后管理',
  '售后记录': '售后记录',
  '商标': '商标',
  '商标 + 领标': '商标 + 领标',
  '商标+领标': '商标+领标',
  '商标及码标都订后复势': '商标及码标都订后复势',
  '商标在右': '商标在右',
  '商标在左': '商标在左',
  '商标订下里襟': '商标订下里襟',
  '商标订卡袋上': '商标订卡袋上',
  '商标订后复势': '商标订后复势',
  '商标订后复势+面料标订下里襟': '商标订后复势+面料标订下里襟',
  '四季': '四季',
  '团单提成率': '团单提成率',
  '团队管理提成': '团队管理提成',
  '团队管理提成率': '团队管理提成率',
  '国家/地区': '国家/地区',
  '图案': '图案',
  '图片': '图片',
  '图片上传失败，请检查文件格式和大小。': '图片上传失败，请检查文件格式和大小。',
  '圆头 5cm+暗钩': '圆头 5cm+暗钩',
  '圆头 5cm+锁眼钉扣': '圆头 5cm+锁眼钉扣',
  '圆形牛仔袋（又名月牙袋）': '圆形牛仔袋（又名月牙袋）',
  '圆形青果领': '圆形青果领',
  '圆摆': '圆摆',
  '圆角 1 眼 2 扣': '圆角 1 眼 2 扣',
  '圆角 2 用': '圆角 2 用',
  '圆角 2 眼 2 扣': '圆角 2 眼 2 扣',
  '圆角立领': '圆角立领',
  '圆角领': '圆角领',
  '圆贴布中褶': '圆贴布中褶',
  '圆贴布大褶': '圆贴布大褶',
  '圆贴布小褶（塔克）': '圆贴布小褶（塔克）',
  '圆贴布无褶': '圆贴布无褶',
  '在右袋布内': '在右袋布内',
  '在左右袋布内': '在左右袋布内',
  '在左袋布内': '在左袋布内',
  '在线门店': '在线门店',
  '地址': '地址',
  '城市': '城市',
  '基准价': '基准价',
  '基本信息': '基本信息',
  '基本工资': '基本工资',
  '基础价格': '基础价格',
  '基础价格表': '基础价格表',
  '基础数据管理': '基础数据管理',
  '增加': '增加',
  '处理': '处理',
  '处理中': '处理中',
  '处理失败': '处理失败',
  '处理方式': '处理方式',
  '处罚规则': '处罚规则',
  '备注': '备注',
  '备货': '备货',
  '备货中': '备货中',
  '复制旧订单': '复制旧订单',
  '复制订单': '复制订单',
  '复制链接': '复制链接',
  '复审通过': '复审通过',
  '复用全部信息': '复用全部信息',
  '复用旧订单': '复用旧订单',
  '夏季': '夏季',
  '外翻 3.5cm': '外翻 3.5cm',
  '外翻 3cm': '外翻 3cm',
  '外翻 5.5cm': '外翻 5.5cm',
  '外翻 5cm': '外翻 5cm',
  '外翻 6cm': '外翻 6cm',
  '外裤长': '外裤长',
  '外贡针线': '外贡针线',
  '外过肩撞色': '外过肩撞色',
  '外领面居中': '外领面居中',
  '大 U 型': '大 U 型',
  '大八字领': '大八字领',
  '大圆型下摆': '大圆型下摆',
  '大挂面': '大挂面',
  '大挂面无里（包边）': '大挂面无里（包边）',
  '大挂面无里（贡针）': '大挂面无里（贡针）',
  '大挂面（适合无里布工艺）': '大挂面（适合无里布工艺）',
  '大腿围': '大腿围',
  '大衣': '大衣',
  '天': '天',
  '天然混纺系列': '天然混纺系列',
  '奖励通知': '奖励通知',
  '奢华档': '奢华档',
  '奢华档（高）': '奢华档（高）',
  '女': '女',
  '婚礼系列': '婚礼系列',
  '子账号': '子账号',
  '字体颜色': '字体颜色',
  '存储地点': '存储地点',
  '完成': '完成',
  '完成录入待提交': '完成录入待提交',
  '定制单提成率': '定制单提成率',
  '定制设计': '定制设计',
  '宝剑头 5cm+暗钩': '宝剑头 5cm+暗钩',
  '宝剑头 5cm+锁眼钉扣': '宝剑头 5cm+锁眼钉扣',
  '宝剑头挂面': '宝剑头挂面',
  '实发工资': '实发工资',
  '实发提成': '实发提成',
  '实际完成': '实际完成',
  '审批人': '审批人',
  '审批备注': '审批备注',
  '审批状态': '审批状态',
  '审核订单': '审核订单',
  '审核通过': '审核通过',
  '审核驳回': '审核驳回',
  '客供图片': '客供图片',
  '客供里布': '客供里布',
  '客户': '客户',
  '客户/门店': '客户/门店',
  '客户信息&款式设计': '客户信息&款式设计',
  '客户名称': '客户名称',
  '客户基本信息': '客户基本信息',
  '客户姓名': '客户姓名',
  '客户报价单': '客户报价单',
  '客户标签': '客户标签',
  '客户状态': '客户状态',
  '客户编号': '客户编号',
  '宴会系列': '宴会系列',
  '宽松': '宽松',
  '寄出日期': '寄出日期',
  '密码': '密码',
  '密码重置失败': '密码重置失败',
  '密钥': '密钥',
  '对账单': '对账单',
  '对账截止日': '对账截止日',
  '对账起始日': '对账起始日',
  '导入': '导入',
  '导出': '导出',
  '导出列表': '导出列表',
  '导出发票': '导出发票',
  '小 U 型': '小 U 型',
  '小圆头 5cm+暗钩': '小圆头 5cm+暗钩',
  '小圆头 5cm+锁眼钉扣': '小圆头 5cm+锁眼钉扣',
  '小圆青果领': '小圆青果领',
  '小腿围': '小腿围',
  '小腿高度': '小腿高度',
  '尖角下摆': '尖角下摆',
  '尖青果领（JD 尖青果领）': '尖青果领（JD 尖青果领）',
  '屈身体': '屈身体',
  '工作台': '工作台',
  '工厂': '工厂',
  '工厂A': '工厂A',
  '工厂B': '工厂B',
  '工厂供应商': '工厂供应商',
  '工厂信息': '工厂信息',
  '工厂单号': '工厂单号',
  '模糊查询': '模糊查询',
  '门店编号/工厂单号/面料号': '门店编号/工厂单号/面料号',
  '工厂原始编号': '工厂原始编号',
  '工厂名称': '工厂名称',
  '工厂已确认': '工厂已确认',
  '工厂待审核': '工厂待审核',
  '工厂成本': '工厂成本',
  '工厂成本配置': '工厂成本配置',
  '工厂状态': '工厂状态',
  '工字褶': '工字褶',
  '工艺': '工艺',
  '工艺配置': '工艺配置',
  '左 1 右 2': '左 1 右 2',
  '左 1 右 3': '左 1 右 3',
  '左 2 右 1': '左 2 右 1',
  '左 2 右 2': '左 2 右 2',
  '左 3': '左 3',
  '左 3 右 1': '左 3 右 1',
  '左切角胸袋': '左切角胸袋',
  '左切角胸袋+切角袋盖+锁眼钉扣': '左切角胸袋+切角袋盖+锁眼钉扣',
  '左前片下腰口': '左前片下腰口',
  '左前腰部（第 4 个纽扣左侧）': '左前腰部（第 4 个纽扣左侧）',
  '左单开线袋+锁眼钉扣': '左单开线袋+锁眼钉扣',
  '左单开线袋（无眼无扣）': '左单开线袋（无眼无扣）',
  '左双开线袋+圆扣袢+锁眼钉扣': '左双开线袋+圆扣袢+锁眼钉扣',
  '左双开线袋+桃型袋盖': '左双开线袋+桃型袋盖',
  '左双开线袋+菱形袋盖': '左双开线袋+菱形袋盖',
  '左双开线袋+锁眼钉扣': '左双开线袋+锁眼钉扣',
  '左双开线袋（无眼无扣）': '左双开线袋（无眼无扣）',
  '左右切角胸袋': '左右切角胸袋',
  '左右切角胸袋+切角袋盖+锁眼钉扣': '左右切角胸袋+切角袋盖+锁眼钉扣',
  '左右圆胸袋': '左右圆胸袋',
  '左右圆角胸袋+圆角袋盖+锁眼钉扣': '左右圆角胸袋+圆角袋盖+锁眼钉扣',
  '左右宝剑头调节袢': '左右宝剑头调节袢',
  '左右小弧形调节袢': '左右小弧形调节袢',
  '左右尖角胸袋': '左右尖角胸袋',
  '左右工字褶贴袋': '左右工字褶贴袋',
  '左右工字褶贴袋（无袋盖）': '左右工字褶贴袋（无袋盖）',
  '左右工字褶贴袋（桃型袋盖+钉扣）': '左右工字褶贴袋（桃型袋盖+钉扣）',
  '左右工字褶贴袋（直袋盖）': '左右工字褶贴袋（直袋盖）',
  '左右方角胸袋': '左右方角胸袋',
  '左右方角胸袋+切角袋盖+锁眼钉扣': '左右方角胸袋+切角袋盖+锁眼钉扣',
  '左右方角胸袋+尖角袋盖+锁眼钉扣': '左右方角胸袋+尖角袋盖+锁眼钉扣',
  '左右方角胸袋+方角袋盖+锁眼钉扣': '左右方角胸袋+方角袋盖+锁眼钉扣',
  '左右暗风琴褶贴袋': '左右暗风琴褶贴袋',
  '左右暗风琴褶贴袋（无袋盖）': '左右暗风琴褶贴袋（无袋盖）',
  '左右暗风琴褶贴袋（桃型袋盖+钉扣）': '左右暗风琴褶贴袋（桃型袋盖+钉扣）',
  '左右暗风琴褶贴袋（直袋盖）': '左右暗风琴褶贴袋（直袋盖）',
  '左右驳头眼': '左右驳头眼',
  '左商标+右面料标': '左商标+右面料标',
  '左商标+右面料标+领标': '左商标+右面料标+领标',
  '左商标右面料标': '左商标右面料标',
  '左圆胸袋': '左圆胸袋',
  '左圆角胸袋+圆角袋盖+锁眼钉扣': '左圆角胸袋+圆角袋盖+锁眼钉扣',
  '左尖角胸袋': '左尖角胸袋',
  '左工字褶贴袋': '左工字褶贴袋',
  '左工字褶贴袋（无袋盖）': '左工字褶贴袋（无袋盖）',
  '左工字褶贴袋（桃型袋盖+钉扣）': '左工字褶贴袋（桃型袋盖+钉扣）',
  '左工字褶贴袋（直袋盖）': '左工字褶贴袋（直袋盖）',
  '左手腕': '左手腕',
  '左挂面袋上居中': '左挂面袋上居中',
  '左方角胸袋': '左方角胸袋',
  '左方角胸袋+切角袋盖+锁眼钉扣': '左方角胸袋+切角袋盖+锁眼钉扣',
  '左方角胸袋+尖角袋盖+锁眼钉扣': '左方角胸袋+尖角袋盖+锁眼钉扣',
  '左方角胸袋+方角袋盖+锁眼钉扣': '左方角胸袋+方角袋盖+锁眼钉扣',
  '左暗风琴褶贴袋': '左暗风琴褶贴袋',
  '左暗风琴褶贴袋（无袋盖）': '左暗风琴褶贴袋（无袋盖）',
  '左暗风琴褶贴袋（桃型袋盖+钉扣）': '左暗风琴褶贴袋（桃型袋盖+钉扣）',
  '左暗风琴褶贴袋（直袋盖）': '左暗风琴褶贴袋（直袋盖）',
  '左标准明贴袋（无袋盖）': '左标准明贴袋（无袋盖）',
  '左标准明贴袋（桃形袋盖+钉扣）': '左标准明贴袋（桃形袋盖+钉扣）',
  '左标准明贴袋（桃形袋盖）': '左标准明贴袋（桃形袋盖）',
  '左标准明贴袋（直袋盖）': '左标准明贴袋（直袋盖）',
  '左胸前': '左胸前',
  '左胸弧形贴袋': '左胸弧形贴袋',
  '左胸弧形贴袋（无袋盖）': '左胸弧形贴袋（无袋盖）',
  '左腰里刺绣': '左腰里刺绣',
  '左腰里订商标': '左腰里订商标',
  '左腰里订面料标': '左腰里订面料标',
  '左袖口': '左袖口',
  '左袖长': '左袖长',
  '左里袋上居中': '左里袋上居中',
  '左面料标+右商标': '左面料标+右商标',
  '左面料标右商标': '左面料标右商标',
  '左领尖绣字（顺边缘）': '左领尖绣字（顺边缘）',
  '左驳头眼顺边绣': '左驳头眼顺边绣',
  '已付款': '已付款',
  '已付金额': '已付金额',
  '已发放': '已发放',
  '已发货': '已发货',
  '已发货数量': '已发货数量',
  '已发货订单': '已发货订单',
  '已发送': '已发送',
  '已取消': '已取消',
  '已完成': '已完成',
  '已完成订单': '已完成订单',
  '已审核': '已审核',
  '已提交': '已提交',
  '已提交订单': '已提交订单',
  '已收货': '已收货',
  '已查看': '已查看',
  '已用额度': '已用额度',
  '已申请': '已申请',
  '已确认': '已确认',
  '已签收': '已签收',
  '已读': '已读',
  '已质检': '已质检',
  '已送达': '已送达',
  '已选择': '已选择',
  '已采购': '已采购',
  '已驳回': '已驳回',
  '已通过': '已通过',
  'AI 建议': 'AI 建议',
  '常规': '常规',
  '常规加厚肩（垫肩 1.2cm + 有棉条）': '常规加厚肩（垫肩 1.2cm + 有棉条）',
  '常规款': '常规款',
  '常规纽扣': '常规纽扣',
  '常规肩（垫肩 0.8cm + 有棉条）': '常规肩（垫肩 0.8cm + 有棉条）',
  '常规薄肩（垫肩 0.5cm + 有棉条）': '常规薄肩（垫肩 0.5cm + 有棉条）',
  '常规超薄肩（垫肩 0.1cm + 有棉条）': '常规超薄肩（垫肩 0.1cm + 有棉条）',
  '常规里袋 + 一字笔袋': '常规里袋 + 一字笔袋',
  '常规里袋 + 一字笔袋 + 卡袋': '常规里袋 + 一字笔袋 + 卡袋',
  '常规里袋 + 水滴笔袋': '常规里袋 + 水滴笔袋',
  '常规里袋 + 水滴笔袋 + 卡袋': '常规里袋 + 水滴笔袋 + 卡袋',
  '常规里袋+一字笔袋': '常规里袋+一字笔袋',
  '常规里袋+一字笔袋+卡袋': '常规里袋+一字笔袋+卡袋',
  '常规里袋+水滴笔袋': '常规里袋+水滴笔袋',
  '常规里袋+水滴笔袋+卡袋': '常规里袋+水滴笔袋+卡袋',
  '幅宽(cm)': '幅宽(cm)',
  '平台服务费': '平台服务费',
  '平腰头+暗钩': '平腰头+暗钩',
  '平腰头+锁眼钉扣': '平腰头+锁眼钉扣',
  '平袋盖（直角）': '平袋盖（直角）',
  '平角青果领': '平角青果领',
  '平驳领': '平驳领',
  '年度税后利润': '年度税后利润',
  '库存不足，请选择其他物料或联系客服。': '库存不足，请选择其他物料或联系客服。',
  '库存流水': '库存流水',
  '库存管理': '库存管理',
  '库存调整': '库存调整',
  '应付总金额': '应付总金额',
  '应发工资': '应发工资',
  '度假系列': '度假系列',
  '开始生产前需支付50%定金。': '开始生产前需支付50%定金。',
  '异常': '异常',
  '异常冻结': '异常冻结',
  '异常订单': '异常订单',
  '弧形工字褶贴袋': '弧形工字褶贴袋',
  '弧形工字褶贴袋（桃型袋盖）': '弧形工字褶贴袋（桃型袋盖）',
  '弧形工字褶贴袋（直袋盖）': '弧形工字褶贴袋（直袋盖）',
  '弧形戗驳领': '弧形戗驳领',
  '弧形暗风琴褶贴袋': '弧形暗风琴褶贴袋',
  '弧形暗风琴褶贴袋（桃型袋盖）': '弧形暗风琴褶贴袋（桃型袋盖）',
  '弧形暗风琴褶贴袋（直袋盖）': '弧形暗风琴褶贴袋（直袋盖）',
  '弧形胸袋': '弧形胸袋',
  '弧形贴袋': '弧形贴袋',
  '弧形贴袋+ 右袋中袋': '弧形贴袋+ 右袋中袋',
  '弧形贴袋（时尚贴袋）': '弧形贴袋（时尚贴袋）',
  '弯挂面': '弯挂面',
  '当前在线门店': '当前在线门店',
  '当前库存': '当前库存',
  '当前页面': '当前页面',
  '录入失败': '录入失败',
  '待付款': '待付款',
  '待付金额': '待付金额',
  '待初审': '待初审',
  '待初审订单': '待初审订单',
  '待办': '待办',
  '待发货': '待发货',
  '待处理': '待处理',
  '待处理售后': '待处理售后',
  '待复审': '待复审',
  '待复审订单': '待复审订单',
  '待审核': '待审核',
  '待审核订单': '待审核订单',
  '待审核订单总数': '待审核订单总数',
  '待推送': '待推送',
  '待推送订单': '待推送订单',
  '待提交订单': '待提交订单',
  '待确认': '待确认',
  '待确认付款': '待确认付款',
  '待终审': '待终审',
  '待终审订单': '待财务审核订单',
  '待财务审核': '待财务审核',
  '待质检': '待质检',
  '待采购': '待采购',
  '待采购面料': '待采购面料',
  '心型': '心型',
  '忘记密码': '忘记密码',
  '快速搜索': '快速搜索',
  '性别': '性别',
  '总肩宽': '总肩宽',
  '您有未保存的更改，是否继续编辑？': '您有未保存的更改，是否继续编辑？',
  '意式圆形 1 扣': '意式圆形 1 扣',
  '意式圆形 2 扣': '意式圆形 2 扣',
  '意式直型 1 扣': '意式直型 1 扣',
  '意式直型 2 扣': '意式直型 2 扣',
  '意式长双宝剑头+锁眼钉扣': '意式长双宝剑头+锁眼钉扣',
  '意式长圆头+锁眼钉扣': '意式长圆头+锁眼钉扣',
  '意式长方头+锁眼钉扣': '意式长方头+锁眼钉扣',
  '成分': '成分',
  '成本分析': '成本分析',
  '成本明细': '成本明细',
  '成本预警': '成本预警',
  '成衣商城': '成衣商城',
  '成衣尺寸': '成衣尺寸',
  '审核成衣尺寸': '审核成衣尺寸',
  '我的客户': '我的客户',
  '我的物料': '我的物料',
  '我的订单': '我的订单',
  '我的设计专员': '我的设计专员',
  '我的账号': '我的账号',
  '所属门店': '所属门店',
  '所有价格以美元（USD）计算，自报价日起30天内有效。': '所有价格以美元（USD）计算，自报价日起30天内有效。',
  '所有服装均为量身定制，不接受退换。': '所有服装均为量身定制，不接受退换。',
  '所有订单': '所有订单',
  '所有订单管理': '所有订单管理',
  '所选物料在当前工厂不可用。': '所选物料在当前工厂不可用。',
  '手动发送公告': '手动发送公告',
  '手动同步状态': '手动同步状态',
  '手工同步状态': '手工同步状态',
  '手工圆头锁眼': '手工圆头锁眼',
  '手工米兰眼不开刀': '手工米兰眼不开刀',
  '手工米兰眼开刀': '手工米兰眼开刀',
  '手工调价': '手工调价',
  '打印': '打印',
  '扣减': '扣减',
  '扣款合计': '扣款合计',
  '批量价格表': '批量价格表',
  '批量发送邮件': '批量发送邮件',
  '批量导出': '批量导出',
  '批量打印面单': '批量打印面单',
  '批量折扣': '批量折扣',
  '批量操作': '批量操作',
  '投产工厂': '投产工厂',
  '投诉与反馈': '投诉与反馈',
  '投诉与反馈邮箱': '投诉与反馈邮箱',
  '折扣': '折扣',
  'RTW批量折扣': 'RTW批量折扣',
  '数量区间': '数量区间',
  '折': '折',
  '手续费': '手续费',
  '转账手续费': '转账手续费',
  '报价工具': '报价工具',
  '报价总额（USD）': '报价总额（USD）',
  '报价日期': '报价日期',
  '报废': '报废',
  '报表中心': '报表中心',
  '拖拽排序': '拖拽排序',
  '挂面款式': '挂面款式',
  '按业务员': '按业务员',
  '按件': '按件',
  '按功能分类': '按功能分类',
  '按单': '按单',
  '按周': '按周',
  '按图设计': '按图设计',
  '按图设计款': '按图设计款',
  '按场合分类': '按场合分类',
  '按天': '按天',
  '按字': '按字',
  '按字母': '按字母',
  '按季节分类': '按季节分类',
  '按月': '按月',
  '按订单': '按订单',
  '按门店': '按门店',
  '挺缝线压线 0.2cm': '挺缝线压线 0.2cm',
  '挺胸体': '挺胸体',
  '接口地址': '接口地址',
  '接收角色': '接收角色',
  '推送': '推送',
  '推送失败': '推送失败',
  '推送工厂': '推送工厂',
  '批量推送工厂': '批量推送工厂',
  '批量生成采购单': '批量生成采购单',
  '条订单': '条订单',
  '面料明细预览': '面料明细预览',
  '成功生成': '成功生成',
  '条采购记录': '条采购记录',
  '条订单生成失败': '条订单生成失败',
  '只能推送待推送状态的订单': '只能推送待推送状态的订单',
  '成功推送': '成功推送',
  '条订单到工厂': '条订单到工厂',
  '条订单推送失败': '条订单推送失败',
  '确认推送': '确认推送',
  '选择工厂': '选择工厂',
  '推送成功': '推送成功',
  '提交': '提交',
  '提交订单': '提交订单',
  '提成合计': '提成合计',
  '提成明细': '提成明细',
  '提成规则配置': '提成规则配置',
  '提成金额': '提成金额',
  '提示：如果是数据库表不存在等后端错误，请检查后端服务是否已正确初始化数据库。': '提示：如果是数据库表不存在等后端错误，请检查后端服务是否已正确初始化数据库。',
  '搜索': '搜索',
  '搜索编号 / 颜色': '搜索编号 / 颜色',
  '摆围': '摆围',
  '撞色设计': '撞色设计',
  '撞色面料': '撞色面料',
  '操作': '操作',
  '操作人': '操作人',
  '操作内容': '操作内容',
  '操作失败': '操作失败',
  '操作成功': '操作成功',
  '操作日志': '操作日志',
  '操作时间': '操作时间',
  '支纱': '支纱',
  '收支明细': '收支明细',
  '收货单': '收货单',
  '收货地点': '收货地点',
  '收货管理': '收货管理',
  '收费系列': '收费系列',
  '放松量': '放松量',
  '数据看板': '数据看板',
  '数量': '数量',
  '整个袖口撞色': '整个袖口撞色',
  '整个领子和袖口撞色': '整个领子和袖口撞色',
  '整个领子撞色': '整个领子撞色',
  '左对齐': '左对齐',
  '居中': '居中',
  '右对齐': '右对齐',
  '文字': '文字',
  '料卡': '料卡',
  '斜双开线口袋': '斜双开线口袋',
  '斜插袋': '斜插袋',
  '斜袋': '斜袋',
  '斜袋：单线袋': '斜袋：单线袋',
  '斜袋：双线大袋（有袋盖）+一字票袋（无袋盖）': '斜袋：双线大袋（有袋盖）+一字票袋（无袋盖）',
  '斜袋：双线大袋（有袋盖）+双线票袋（无袋盖）': '斜袋：双线大袋（有袋盖）+双线票袋（无袋盖）',
  '斜袋：双线大袋（有袋盖）+双线票袋（有袋盖）': '斜袋：双线大袋（有袋盖）+双线票袋（有袋盖）',
  '斜袋：双线大袋（直角袋盖）+双线票袋（直角袋盖）': '斜袋：双线大袋（直角袋盖）+双线票袋（直角袋盖）',
  '斜袋：双线袋+小圆直袋盖': '斜袋：双线袋+小圆直袋盖',
  '斜袋：双线袋无袋盖': '斜袋：双线袋无袋盖',
  '斜袋：双线袋（无盖）+双线票袋（无盖）': '斜袋：双线袋（无盖）+双线票袋（无盖）',
  '斜袋：平袋盖（直角）': '斜袋：平袋盖（直角）',
  '斜角青果领': '斜角青果领',
  '斜里襟+内小圆头裤袢': '斜里襟+内小圆头裤袢',
  '斜里襟+内小宝剑头裤袢': '斜里襟+内小宝剑头裤袢',
  '斜里襟+内小方头裤袢': '斜里襟+内小方头裤袢',
  '断货': '断货',
  '新品上架': '新品上架',
  '新增付款记录': '新增付款记录',
  '新增客户': '新增客户',
  '新增尺寸': '新增尺寸',
  '新增返修单': '新增返修单',
  '新建订单': '新建订单',
  '新款发布': '新款发布',
  '新金额': '新金额',
  '无': '无',
  '无刺绣': '无刺绣',
  '无叉': '无叉',
  '无口袋': '无口袋',
  '无开口': '无开口',
  '无开衩': '无开衩',
  '无弧度戗驳领（JD 直戗驳领）': '无弧度戗驳领（JD 直戗驳领）',
  '无挺缝线': '无挺缝线',
  '无插片': '无插片',
  '无数据': '无数据',
  '无标': '无标',
  '无款式配置': '无款式配置',
  '无省': '无省',
  '无结构无胸衬': '无结构无胸衬',
  '无背带扣': '无背带扣',
  '无胸袋': '无胸袋',
  '无胸袋+下单开线袋': '无胸袋+下单开线袋',
  '无胸袋+下双开线袋': '无胸袋+下双开线袋',
  '无胸袋+下贴袋': '无胸袋+下贴袋',
  '无腰带': '无腰带',
  '无腰设计': '无腰设计',
  '无色丁': '无色丁',
  '无表袋': '无表袋',
  '无衬': '无衬',
  '无袋': '无袋',
  '无袋盖': '无袋盖',
  '无袖叉': '无袖叉',
  '无裤袢': '无裤袢',
  '无褶': '无褶',
  '无褶双省': '无褶双省',
  '无褶无褶': '无褶无褶',
  '无贡针': '无贡针',
  '无里布': '无里布',
  '无锁眼无纽扣': '无锁眼无纽扣',
  '无驳头眼': '无驳头眼',
  '日常通知': '日常通知',
  '日志管理': '日志管理',
  '时尚档': '时尚档',
  '时尚档（高）': '时尚档（高）',
  '时间/维度': '时间/维度',
  '明门襟 3.5cm': '明门襟 3.5cm',
  '明门襟 3cm': '明门襟 3cm',
  '春秋': '春秋',
  '是否余料': '是否余料',
  '是否加急': '是否加急',
  '加急状态': '加急状态',
  '显示 / 隐藏': '显示 / 隐藏',
  '普通': '普通',
  '普通工字褶贴袋': '普通工字褶贴袋',
  '普通工字褶贴袋（桃型袋盖）': '普通工字褶贴袋（桃型袋盖）',
  '普通工字褶贴袋（直袋盖）': '普通工字褶贴袋（直袋盖）',
  '普通暗风琴褶贴袋': '普通暗风琴褶贴袋',
  '普通暗风琴褶贴袋（桃型袋盖）': '普通暗风琴褶贴袋（桃型袋盖）',
  '普通暗风琴褶贴袋（直袋盖）': '普通暗风琴褶贴袋（直袋盖）',
  '普通贴袋': '普通贴袋',
  '普通贴袋+右袋中袋': '普通贴袋+右袋中袋',
  '暂存': '暂存',
  '暂存单数量': '暂存单数量',
  '暂存订单': '暂存订单',
  '暂无付款记录': '暂无付款记录',
  '暂无发票记录': '暂无发票记录',
  '暂无同步记录': '暂无同步记录',
  '暂无售后记录': '暂无售后记录',
  '暂无在线门店': '暂无在线门店',
  '暂无客户，点击 “新增客户” 创建。': '暂无客户，点击 “新增客户” 创建。',
  '暂无数据': '暂无数据',
  '暂无订单': '暂无订单',
  '暂无订单，点击 “创建新订单” 开始。': '暂无订单，点击 “创建新订单” 开始。',
  '暂无通知': '暂无通知',
  '暗门襟 3.5cm': '暗门襟 3.5cm',
  '暗门襟 3cm': '暗门襟 3cm',
  '更多': '更多',
  '更多设计': '更多设计',
  '更新失败': '更新失败',
  '更新订单': '更新订单',
  '最新面料': '最新面料',
  '最近下单日期': '最近下单日期',
  '最近订单': '最近订单',
  '月份': '月份',
  '月处理订单量': '月处理订单量',
  '月牙袋+右双线零钱袋': '月牙袋+右双线零钱袋',
  '月牙袋+右零钱贴袋': '月牙袋+右零钱贴袋',
  '月负责订单金额': '月负责订单金额',
  '月销售额': '月销售额',
  '有效期至': '有效期至',
  '长期有效': '长期有效',
  '有背带扣': '有背带扣',
  '有货': '有货',
  '服务暂时不可用，请稍后重试。': '服务暂时不可用，请稍后重试。',
  '服务项目': '服务项目',
  '未付款': '未付款',
  '未付款提醒': '未付款提醒',
  '未分配': '未分配',
  '未发送': '未发送',
  '未找到结果，请尝试其他关键词。': '未找到结果，请尝试其他关键词。',
  '未来之星': '未来之星',
  '未知': '未知',
  '未读': '未读',
  '本人团单销售额': '本人团单销售额',
  '本人定制单销售额': '本人定制单销售额',
  '本人权重点数': '本人权重点数',
  '本布光样': '本布光样',
  '本布光样手工': '本布光样手工',
  '本布手工毛样': '本布手工毛样',
  '本布毛样': '本布毛样',
  '本月新单': '本月新单',
  '本期余额': '本期余额',
  '机器假眼不开刀': '机器假眼不开刀',
  '机器假眼开刀': '机器假眼开刀',
  '机器圆头锁眼不开刀': '机器圆头锁眼不开刀',
  '机器圆头锁眼开刀': '机器圆头锁眼开刀',
  '权限': '权限',
  '权限分配': '权限分配',
  '条': '条',
  '条款与条件': '条款与条件',
  '来图设计': '来图设计',
  '来料加工': '来料加工',
  '来料加工价格': '来料加工价格',
  '来料加工价格表': '来料加工价格表',
  '查看': '查看',
  '查看全部通知': '查看全部通知',
  '查看发票': '查看发票',
  '查看合并发票': '查看合并发票',
  '查看订单': '查看订单',
  '查看详情': '查看详情',
  '标准价格表': '标准价格表',
  '标准体': '标准体',
  '标准八字领': '标准八字领',
  '标准圆角': '标准圆角',
  '标准工艺': '标准工艺',
  '标准腰带': '标准腰带',
  '标准贡针': '标准贡针',
  '标准（14 天）': '标准（14 天）',
  '标签搜索': '标签搜索',
  '标记异常': '标记异常',
  '标题': '标题',
  '样本册': '样本册',
  '核对并提交': '核对并提交',
  '档位面料价（USD/m）': '档位面料价（USD/m）',
  '检索标签': '检索标签',
  '款号': '款号',
  '款式名称': '款式名称',
  '款式配置': '款式配置',
  '款式配置汇总': '款式配置汇总',
  '款式风格': '款式风格',
  '正常': '正常',
  '正常腰头': '正常腰头',
  '正式': '正式',
  '正面图': '正面图',
  '此字段为必填项。': '此字段为必填项。',
  '每件': '每件',
  '每单': '每单',
  '每字': '每字',
  '毛利': '毛利',
  '毛利率': '毛利率',
  '毛边 10cm': '毛边 10cm',
  '毛边 7cm': '毛边 7cm',
  '汇款': '汇款',
  '汗贴造型': '汗贴造型',
  '沟通': '沟通',
  '沟通态度': '沟通态度',
  '法式切角': '法式切角',
  '法式圆角': '法式圆角',
  '法式斜里襟': '法式斜里襟',
  '法式直角': '法式直角',
  '注册时间': '注册时间',
  '活动系列': '活动系列',
  '活跃': '活跃',
  '测试连接': '测试连接',
  '海鸥型': '海鸥型',
  '消息中心': '消息中心',
  '消息评论': '消息评论',
  '消费': '消费',
  '消费者管理': '消费者管理',
  '消费金额': '消费金额',
  '添加体型特征': '添加体型特征',
  '清除缓存': '清除缓存',
  '温莎领（内弧）': '温莎领（内弧）',
  '灰色里布': '灰色里布',
  '灰色防滑腰里': '灰色防滑腰里',
  '烟斗型': '烟斗型',
  '熨烫挺缝线': '熨烫挺缝线',
  '版型': '版型',
  '版型 / 款式库': '版型 / 款式库',
  '版型/款式库': '版型/款式库',
  '版型参数': '版型参数',
  '物料供应商': '物料供应商',
  '物料分类': '物料分类',
  '物料寄出管理': '物料寄出管理',
  '物料明细': '物料明细',
  '物料管理': '物料管理',
  '物料编号': '物料编号',
  '物流公司': '物流公司',
  '物流单号': '物流单号',
  '物流单号格式错误。': '物流单号格式错误。',
  '物流方式': '物流方式',
  '物流费': '物流费',
  '物流轨迹': '物流轨迹',
  '特急（5 天）': '特急（5 天）',
  '特殊纽扣': '特殊纽扣',
  '特殊设计': '特殊设计',
  '特殊设计费': '特殊设计费',
  '额外面料费': '额外面料费',
  '特殊里衬': '特殊里衬',
  '状态': '状态',
  '状态变更': '状态变更',
  '状态变更时间线': '状态变更时间线',
  '状态同步记录': '状态同步记录',
  '状态映射': '状态映射',
  '现款设计': '现款设计',
  '现金': '现金',
  '生产中': '生产中',
  '推送中': '推送中',
  '生产中数量': '生产中数量',
  '生产中订单': '生产中订单',
  '生产中订单总数': '生产中订单总数',
  '生成发票': '生成发票',
  '批量复制': '批量复制',
  '批量复制订单': '批量复制订单',
  '确认复制': '确认复制',
  '将把选中的': '将把选中的',
  '个订单复制成新的草稿订单（订单号与出货期重新生成，其余信息完整复制）。完成后可在全部订单列表中逐单检查或编辑。是否继续？': '个订单复制成新的草稿订单（订单号与出货期重新生成，其余信息完整复制）。完成后可在全部订单列表中逐单检查或编辑。是否继续？',
  '个订单，均为草稿状态': '个订单，均为草稿状态',
  '批量复制完成（部分失败）': '批量复制完成（部分失败）',
  '生成报价单': '生成报价单',
  '用户': '用户',
  '用户名': '用户名',
  '用户名或密码错误。': '用户名或密码错误。',
  '用户管理': '用户管理',
  '申请售后': '申请售后',
  '申请折扣率': '申请折扣率',
  '申请时间': '申请时间',
  '电子邮件': '电子邮件',
  '电话': '电话',
  '男': '男',
  '男女': '男女',
  '界面风格配置': '界面风格配置',
  '登出': '登出',
  '登录': '登录',
  '登录失败': '登录失败',
  '登录成功': '登录成功',
  '门店账号不能登录管理后台': '门店账号不能登录管理后台',
  '白色无防滑腰里': '白色无防滑腰里',
  '白色里布': '白色里布',
  '白色防滑腰里': '白色防滑腰里',
  '皮鞋': '皮鞋',
  '盘亏': '盘亏',
  '盘盈': '盘盈',
  '目标工厂': '目标工厂',
  '直下摆': '直下摆',
  '直属上级': '直属上级',
  '直开口': '直开口',
  '直开口+手工套结': '直开口+手工套结',
  '直挂面': '直挂面',
  '直挂面 + 小宝剑头': '直挂面 + 小宝剑头',
  '直挂面+小宝剑头': '直挂面+小宝剑头',
  '直摆': '直摆',
  '直摆+五角布贴': '直摆+五角布贴',
  '直袋': '直袋',
  '直角 1 眼 2 扣': '直角 1 眼 2 扣',
  '直角 2 眼 2 扣': '直角 2 眼 2 扣',
  '直角两用': '直角两用',
  '直角立体贴袋 + 桃型袋盖': '直角立体贴袋 + 桃型袋盖',
  '直角立体贴袋 + 直袋盖': '直角立体贴袋 + 直袋盖',
  '直角立体贴袋+桃型袋盖': '直角立体贴袋+桃型袋盖',
  '直角立体贴袋+直袋盖': '直角立体贴袋+直袋盖',
  '直贴布中褶': '直贴布中褶',
  '直贴布大褶': '直贴布大褶',
  '直贴布小褶（塔克）': '直贴布小褶（塔克）',
  '直门襟': '直门襟',
  '真实姓名': '真实姓名',
  '真袖叉': '真袖叉',
  '真袖叉圆弧翻边（4.5cm）': '真袖叉圆弧翻边（4.5cm）',
  '真袖叉圆弧翻边（7.5cm）': '真袖叉圆弧翻边（7.5cm）',
  '真袖叉直翻边（4.5cm）': '真袖叉直翻边（4.5cm）',
  '真袖叉直翻边（7.5cm）': '真袖叉直翻边（7.5cm）',
  '短款': '短款',
  '短袖': '短袖',
  '短袖假翻边': '短袖假翻边',
  '短袖内折边': '短袖内折边',
  '码标订后复势': '码标订后复势',
  '硬衬': '硬衬',
  '确定删除该记录吗？此操作不可撤销。': '确定删除该记录吗？此操作不可撤销。',
  '确认': '确认',
  '确认到账': '确认到账',
  '确认取消订单？': '确认取消订单？',
  '确认取消该订单？取消后无法恢复。': '确认取消该订单？取消后无法恢复。',
  '确认提交': '确认提交',
  '确认提成': '确认提成',
  '确认收货': '确认收货',
  '确认收货？此操作不可撤销。': '确认收货？此操作不可撤销。',
  '确认订单': '确认订单',
  '确认订单后，生产周期为4–6周。': '确认订单后，生产周期为4–6周。',
  '磅': '磅',
  '礼服系列': '礼服系列',
  '礼服门襟 3.5cm（4 个 STUDS）': '礼服门襟 3.5cm（4 个 STUDS）',
  '礼服门襟 3.5cm（所有都是 STUDS）': '礼服门襟 3.5cm（所有都是 STUDS）',
  '礼服门襟 3cm（4 个 STUDS）': '礼服门襟 3cm（4 个 STUDS）',
  '礼服门襟 3cm（所有都是 STUDS）': '礼服门襟 3cm（所有都是 STUDS）',
  '礼服领': '礼服领',
  '社会保险': '社会保险',
  '禁忌 / 特殊要求': '禁忌 / 特殊要求',
  '禁用': '禁用',
  '穿着风格偏好': '穿着风格偏好',
  '筛选': '筛选',
  '米数': '米数',
  '粘合衬厚胸衬': '粘合衬厚胸衬',
  '粘合衬薄胸衬': '粘合衬薄胸衬',
  '粘衬': '粘衬',
  '精准算料': '精准算料',
  '系列': '系列',
  '系统': '系统',
  '系统发生错误': '系统发生错误',
  '系统图片': '系统图片',
  '系统更新': '系统更新',
  '系统消息': '系统消息',
  '管理系统消息通知及公告发布': '管理系统消息通知及公告发布',
  '消息发送成功': '消息发送成功',
  '消息详情': '消息详情',
  '消息列表': '消息列表',
  '消息统计': '消息统计',
  '消息统计概览': '消息统计概览',
  '消息类型': '消息类型',
  '发送': '发送',
  '发送公告': '发送公告',
  '发送对象': '发送对象',
  '封面': '封面',
  '设为封面': '设为封面',
  '无季节': '无季节',
  '点缩略图右上角星标可指定该页作为样本册封面，默认第1页': '点缩略图右上角星标可指定该页作为样本册封面，默认第1页',
  '正文图片': '正文图片',
  '添加图片': '添加图片',
  '上传封面': '上传封面',
  '替换封面': '替换封面',
  '上传成功': '上传成功',
  '用户 ID': '用户 ID',
  '请输入门店 ID': '请输入门店 ID',
  '请输入用户 ID': '请输入用户 ID',
  '请输入公告标题': '请输入公告标题',
  '请输入公告内容': '请输入公告内容',
  '全部标记为已读': '全部标记为已读',
  '标记全部已读': '标记全部已读',
  '加载中': '加载中',
  '全部用户': '全部用户',
  '指定用户': '指定用户',
  '待办消息': '待办消息',
  '告警消息': '告警消息',
  '未读消息': '未读消息',
  '目标': '目标',
  '系统设置': '系统设置',
  '系统面料': '系统面料',
  '紧急': '紧急',
  '紧身': '紧身',
  '累计消费金额': '累计消费金额',
  '累计订单': '累计订单',
  '纽扣': '纽扣',
  '线号': '线号',
  '组件堆栈详情（开发人员查看）': '组件堆栈详情（开发人员查看）',
  '织法/特征': '织法/特征',
  '终端消费者': '终端消费者',
  '经典尖领': '经典尖领',
  '经典戗驳领': '经典戗驳领',
  '结果': '结果',
  '结算': '结算',
  '绩效': '绩效',
  '编辑': '编辑',
  '编辑价格体系': '编辑价格体系',
  '网络错误': '网络错误',
  '网络错误，请检查连接后重试。': '网络错误，请检查连接后重试。',
  '羊毛系列': '羊毛系列',
  '美元金额': '美元金额',
  '考勤扣款': '考勤扣款',
  '考核指标': '考核指标',
  '耸肩袖（标配垫肩 + 有棉条）': '耸肩袖（标配垫肩 + 有棉条）',
  '联系人': '联系人',
  '联系电话': '联系电话',
  '肚围': '肚围',
  '股东分红比例': '股东分红比例',
  '肥大': '肥大',
  '肩型': '肩型',
  '肩宽': '肩宽',
  '背带扣': '背带扣',
  '背面图': '背面图',
  '胸围': '胸围',
  '胸袋上刺绣': '胸袋上刺绣',
  '脚口': '脚口',
  '脚口型': '脚口型',
  '腰围': '腰围',
  '腰面+侧缝顺色哑光色丁 1.5cm': '腰面+侧缝顺色哑光色丁 1.5cm',
  '腰面+侧缝顺色哑光色丁 2.5cm': '腰面+侧缝顺色哑光色丁 2.5cm',
  '腰面+侧缝黑色哑光色丁 1.5cm': '腰面+侧缝黑色哑光色丁 1.5cm',
  '腰面+侧缝黑色哑光色丁 2.5cm': '腰面+侧缝黑色哑光色丁 2.5cm',
  '腰面顺色哑光色丁': '腰面顺色哑光色丁',
  '腰面黑色哑光色丁': '腰面黑色哑光色丁',
  '腿根围': '腿根围',
  '膝围': '膝围',
  '膝盖围': '膝盖围',
  '臀围': '臀围',
  '自动调整刺绣高度': '自动调整刺绣高度',
  '节节高升': '节节高升',
  '英尺': '英尺',
  '英文': '英文',
  '草稿': '草稿',
  '获取订单数据失败': '获取订单数据失败',
  '藏青里布': '藏青里布',
  '行政人员': '行政人员',
  '行政提成（元/单）': '行政提成（元/单）',
  '表袋设计': '表袋设计',
  '衬衫': '衬衫',
  '衬衫下摆造型': '衬衫下摆造型',
  '衬衫其它设计': '衬衫其它设计',
  '衬衫刺绣位置': '衬衫刺绣位置',
  '衬衫商标': '衬衫商标',
  '衬衫撞色': '衬衫撞色',
  '衬衫胸袋设计': '衬衫胸袋设计',
  '衬衫袖口设计': '衬衫袖口设计',
  '衬衫设计': '衬衫设计',
  '衬衫门襟设计': '衬衫门襟设计',
  '袖口': '袖口',
  '袖口款式': '袖口款式',
  '袖口钉扣线': '袖口钉扣线',
  '袖口锁眼线': '袖口锁眼线',
  '袖口高度': '袖口高度',
  '袖型': '袖型',
  '袖笼合缝': '袖笼合缝',
  '袖肥': '袖肥',
  '袖里': '袖里',
  '袖长': '袖长',
  '裤侧缝贡针': '裤侧缝贡针',
  '裤侧袋': '裤侧袋',
  '裤内长': '裤内长',
  '裤后口袋': '裤后口袋',
  '裤子刺绣位置': '裤子刺绣位置',
  '裤子撞色部位': '裤子撞色部位',
  '裤子款式习惯': '裤子款式习惯',
  '裤子订扣线': '裤子订扣线',
  '裤子订标位置': '裤子订标位置',
  '裤子贡针': '裤子贡针',
  '裤子锁眼线': '裤子锁眼线',
  '裤脚': '裤脚',
  '裤腰头': '裤腰头',
  '裤腰里': '裤腰里',
  '裤腰面': '裤腰面',
  '裤腰高': '裤腰高',
  '裤褶': '裤褶',
  '裤调节袢': '裤调节袢',
  '裤里位置': '裤里位置',
  '裤里布': '裤里布',
  '裤长': '裤长',
  '裤门襟': '裤门襟',
  '西装上衣': '西装上衣',
  '西裤': '西裤',
  '西裤 + 马甲': '西裤 + 马甲',
  '要求交期': '要求交期',
  '规格': '规格',
  '角色管理': '角色管理',
  '警戒库存': '警戒库存',
  '计算公式': '计算公式',
  '计算失败': '计算失败',
  '计费单位': '计费单位',
  '计费方式': '计费方式',
  '订单不存在或已删除': '订单不存在或已删除',
  '订单中心': '订单中心',
  '订单价格表': '订单价格表',
  '订单创建成功': '订单创建成功',
  '订单取消': '订单取消',
  '订单号': '订单号',
  '订单总额': '订单总额',
  '订单报表': '订单报表',
  '订单提交失败，请稍后重试。': '订单提交失败，请稍后重试。',
  '订单数量': '订单数量',
  '订单流水': '订单流水',
  '订单消耗': '订单消耗',
  '订单状态': '订单状态',
  '订单确认': '订单确认',
  '订单记录': '订单记录',
  '订单详情': '订单详情',
  '订单详情时间': '订单详情时间',
  '订单金额': '订单金额',
  '订单需求': '订单需求',
  '订单面料': '订单面料',
  '订单驳回': '订单驳回',
  '订标位置': '订标位置',
  '订标线': '订标线',
  '订标线颜色': '订标线颜色',
  '让步接收': '让步接收',
  '记录时间': '记录时间',
  '设为常用': '设为常用',
  '设计师评分': '设计师评分',
  '设计风格': '设计风格',
  '试身要求': '试身要求',
  '试身尺寸': '试身尺寸',
  '试身费': '试身费',
  '该操作当前订单状态不允许。': '该操作当前订单状态不允许。',
  '语言': '语言',
  '语言配置': '语言配置',
  '请仔细核对订单信息，提交后将进入审核流程': '请仔细核对订单信息，提交后将进入审核流程',
  '请假扣款': '请假扣款',
  '请填写驳回原因。': '请填写驳回原因。',
  '请求失败，请稍后重试': '请求失败，请稍后重试',
  '请确认所有信息后再提交。': '请确认所有信息后再提交。',
  '请输入凭证或参考号': '请输入凭证或参考号',
  '请输入密码': '请输入密码',
  '请输入新金额': '请输入新金额',
  '请输入用户名': '请输入用户名',
  '请输入调价原因': '请输入调价原因',
  '请输入驳回原因': '请输入驳回原因',
  '请选择一个订单复制。': '请选择一个订单复制。',
  '请选择付款方式': '请选择付款方式',
  '请选择目标工厂': '请选择目标工厂',
  '请选择门店': '请选择门店',
  '调价原因': '调价原因',
  '调价金额不能大于订单总额。': '调价金额不能大于订单总额。',
  '调整原因': '调整原因',
  '调整失败': '调整失败',
  '调整记录': '调整记录',
  '调整额度': '调整额度',
  '负责门店': '负责门店',
  '贡针位置': '贡针位置',
  '贡针针宽': '贡针针宽',
  '财务审核通过': '财务审核通过',
  '财务待确认': '财务待确认',
  '财务管理': '财务管理',
  '账单管理': '账单管理',
  '账号余额': '账号余额',
  '账号余额明细': '账号余额明细',
  '账号已锁定，请 1 小时后重试。': '账号已锁定，请 1 小时后重试。',
  '账户余额': '账户余额',
  '货期': '货期',
  '质检员': '质检员',
  '质检管理': '质检管理',
  '质检记录录入成功': '质检记录录入成功',
  '质检通过': '质检通过',
  '购买记录': '购买记录',
  '购物车': '购物车',
  '超时提醒': '超时提醒',
  '超时时间': '超时时间',
  '跟单员': '跟单员',
  '跟单提成率': '跟单提成率',
  '身高': '身高',
  '身高超出正常范围，请检查修改。': '身高超出正常范围，请检查修改。',
  '转移原因': '转移原因',
  '转移工厂': '转移工厂',
  '软衬': '软衬',
  '辅料': '辅料',
  '辅料编号/里布/纽扣': '辅料编号/里布/纽扣',
  '辅料采购标记': '辅料采购标记',
  '辅料采购备注': '辅料采购备注',
  '标记已采购': '标记已采购',
  '标记不可延期的出货期': '标记不可延期的出货期',
  '标记失败': '标记失败',
  '保存标记': '保存标记',
  '已采': '已采',
  '待采': '待采',
  '不可延期': '不可延期',
  '暂无备注': '暂无备注',
  '请输入辅料采购备注（里布/纽扣等）': '请输入辅料采购备注（里布/纽扣等）',
  '选择出货期': '选择出货期',
  '已标记不可延期': '已标记不可延期',
  '辅料采购标记已保存': '辅料采购标记已保存',
  '缺少订单ID': '缺少订单ID',
  '已标记为已采购': '已标记为已采购',
  '输入量体数据': '输入量体数据',
  '运费': '运费',
  '运输中': '运输中',
  '运输要求': '运输要求',
  '返修': '返修',
  '返修中': '返修中',
  '返修内容': '返修内容',
  '返修出货期': '返修出货期',
  '返修单数量': '返修单数量',
  '返修完成': '返修完成',
  '返修订单': '返修订单',
  '返回': '返回',
  '返回上一步': '返回上一步',
  '返回修改': '返回修改',
  '返回订单列表': '返回订单列表',
  '返回首页': '返回首页',
  '返工': '返工',
  '返现': '返现',
  '违规项数': '违规项数',
  '退出全屏': '退出全屏',
  '退出登录': '退出登录',
  '退款': '退款',
  '选择款式': '选择款式',
  '通底贴布中褶': '通底贴布中褶',
  '通底贴布大褶': '通底贴布大褶',
  '通底贴布小褶（塔克）': '通底贴布小褶（塔克）',
  '通底贴布无褶': '通底贴布无褶',
  '通档': '通档',
  '通用模版配置': '通用模版配置',
  '通知中心': '通知中心',
  '通过': '通过',
  '那不勒斯肩（垫肩 0.1cm + 单层棉条 + 小碎褶）': '那不勒斯肩（垫肩 0.1cm + 单层棉条 + 小碎褶）',
  '那不勒斯肩（无垫肩 + 无棉条 + 小碎褶）': '那不勒斯肩（无垫肩 + 无棉条 + 小碎褶）',
  '邮箱': '邮箱',
  '邮编': '邮编',
  '部位': '部位',
  '部分付款': '部分付款',
  '部分付款记录': '部分付款记录',
  '部分发货': '部分发货',
  '部分退款': '部分退款',
  '配饰': '配饰',
  '采购入库': '采购入库',
  '采购单号': '采购单号',
  '采购单状态': '采购单状态',
  '采购申请': '采购申请',
  '采购申请提交成功。': '采购申请提交成功。',
  '采购目的': '采购目的',
  '采购管理': '采购管理',
  '采购类型': '采购类型',
  '采购记录': '采购记录',
  '里布': '里布',
  '里布材质': '里布材质',
  '里袋撞色': '里袋撞色',
  '里门襟竖向刺绣': '里门襟竖向刺绣',
  '重新推送': '重新推送',
  '重置': '重置',
  '重置筛选': '重置筛选',
  '重试': '重试',
  '重试次数': '重试次数',
  '量体人': '量体人',
  '量体定制': '量体定制',
  '量体尺寸': '量体尺寸',
  '量体日期': '量体日期',
  '金属裤钩': '金属裤钩',
  '金额': '金额',
  '金额汇总': '金额汇总',
  '银行转账': '银行转账',
  '销售业绩统计': '销售业绩统计',
  '销售价格体系配置': '销售价格体系配置',
  '销售价格表': '销售价格表',
  '销售价（USD）': '销售价（USD）',
  '销售报表': '销售报表',
  '错缝上袖': '错缝上袖',
  '错误信息：': '错误信息：',
  '长圆头廓尔格腰头（单向）': '长圆头廓尔格腰头（单向）',
  '长圆头拉廓尔格腰头（双向）': '长圆头拉廓尔格腰头（双向）',
  '长小圆头廓尔格腰头（单向）': '长小圆头廓尔格腰头（单向）',
  '长小圆头拉廓尔格腰头（双向）': '长小圆头拉廓尔格腰头（双向）',
  '长款': '长款',
  '长袖': '长袖',
  '长青系列': '长青系列',
  '门幅': '门幅',
  '门店': '门店',
  '门店 ID': '门店 ID',
  '门店信息': '门店信息',
  '门店列表': '门店列表',
  '门店名称': '门店名称',
  '门店对账单': '门店对账单',
  '门店管理': '门店管理',
  '门店编号': '门店编号',
  '门店订单管理系统': '门店订单管理系统',
  '门店详情': '门店详情',
  '备忘录': '备忘录',
  '新增备忘': '新增备忘',
  '备忘类别': '备忘类别',
  '备忘主题': '备忘主题',
  '备忘内容': '备忘内容',
  '记录日期': '记录日期',
  '暂无备忘记录': '暂无备忘记录',
  '无主题': '无主题',
  '请选择备忘类别': '请选择备忘类别',
  '请输入备忘主题': '请输入备忘主题',
  '请输入备忘内容': '请输入备忘内容',
  '请输入回访记录、寄出物品记录等内容': '请输入回访记录、寄出物品记录等内容',
  '请选择记录日期': '请选择记录日期',
  '最多上传20张图片，单张不超过10MB': '最多上传20张图片，单张不超过10MB',
  '专业度': '专业度',
  '融洽度': '融洽度',
  '回款率': '回款率',
  '回到页头': '回到页头',
  '面辅料': '面辅料',
  '不良信息': '不良信息',
  '其它备注': '其它备注',
  '门襟+袋侧缝+裤侧缝贡针': '门襟+袋侧缝+裤侧缝贡针',
  '门襟+袋侧缝贡针': '门襟+袋侧缝贡针',
  '门襟扣数': '门襟扣数',
  '门襟钉扣线': '门襟钉扣线',
  '门襟锁眼线': '门襟锁眼线',
  '问题解决': '问题解决',
  '防静电浅色条': '防静电浅色条',
  '防静电深色条': '防静电深色条',
  '随货发': '随货发',
  '零剪价格': '零剪价格',
  '需修改': '需修改',
  '需处理': '需处理',
  '面料': '面料',
  '撞色缎': '撞色缎',
  '方巾': '方巾',
  '拉链': '拉链',
  '装饰条': '装饰条',
  '水晶': '水晶',
  '松紧带': '松紧带',
  '其它': '其它',
  '面料名称': '面料名称',
  '客供面料': '客供面料',
  '面料品牌': '面料品牌',
  '面料编号': '面料编号',
  '面料号': '面料号',
  '收货工厂': '收货工厂',
  '面料纹路': '面料纹路',
  '面料幅宽（cm）': '面料幅宽（cm）',
  '运输公司名称': '运输公司名称',
  '运单号': '运单号',
  '寄件日期': '寄件日期',
  '面料图案': '面料图案',
  '面料图片': '面料图片',
  '面料库存': '面料库存',
  '面料归类规则': '面料归类规则',
  '面料成本': '面料成本',
  '面料标 + 领标': '面料标 + 领标',
  '面料标+领标': '面料标+领标',
  '面料标在右': '面料标在右',
  '面料标在左': '面料标在左',
  '面料标订下里襟': '面料标订下里襟',
  '面料标订后复势': '面料标订后复势',
  '面料标订后复势+商标订下里襟': '面料标订后复势+商标订下里襟',
  '面料款式数': '面料款式数',
  '面料选择': '面料选择',
  '面料颜色': '面料颜色',
  '页面出错了': '页面出错了',
  '项': '项',
  '顺丰国际': '顺丰国际',
  '顺色无防滑腰里': '顺色无防滑腰里',
  '顺色防滑腰里': '顺色防滑腰里',
  '顺面料色': '顺面料色',
  '预计交期': '预计交期',
  '预计发货日期': '预计发货日期',
  '预计完成日期': '预计完成日期',
  '领、袖衬': '领、袖衬',
  '领围': '领围',
  '领型': '领型',
  '领型设计': '领型设计',
  '领子+驳头': '领子+驳头',
  '领子+驳头+下口袋牙边': '领子+驳头+下口袋牙边',
  '领子+驳头+下口袋牙边+外翻袖口': '领子+驳头+下口袋牙边+外翻袖口',
  '领子+驳头+下口袋牙边+胸口袋': '领子+驳头+下口袋牙边+胸口袋',
  '领尖双层订暗扣': '领尖双层订暗扣',
  '领尖小袢订暗扣': '领尖小袢订暗扣',
  '领尖款式': '领尖款式',
  '领尖订明扣': '领尖订明扣',
  '领尖长': '领尖长',
  '领带': '领带',
  '领底尼': '领底尼',
  '领座设计': '领座设计',
  '领结': '领结',
  '领针锁圆头眼': '领针锁圆头眼',
  '颜色': '颜色',
  '颜色/色系': '颜色/色系',
  '位置': '位置',
  '高度': '高度',
  '图片刺绣': '图片刺绣',
  '颜色详细描述': '颜色详细描述',
  '额外奖励': '额外奖励',
  '额外收费': '额外收费',
  '首扣距离': '首扣距离',
  '首页': '首页',
  '马甲': '马甲',
  '马甲下摆设计': '马甲下摆设计',
  '马甲侧叉': '马甲侧叉',
  '马甲口袋': '马甲口袋',
  '马甲后背腰带': '马甲后背腰带',
  '马甲后领': '马甲后领',
  '马甲商标': '马甲商标',
  '马甲设计': '马甲设计',
  '马甲贡针': '马甲贡针',
  '马甲贡针线': '马甲贡针线',
  '马甲门襟扣数': '马甲门襟扣数',
  '马甲驳头型': '马甲驳头型',
  '马甲驳头宽度': '马甲驳头宽度',
  '马蹄脚口': '马蹄脚口',
  '驳回': '驳回',
  '添加关联订单': '添加关联订单',
  '请输入订单号': '请输入订单号',
  '已添加关联订单': '已添加关联订单',
  '仅可添加同门店、未开票、未付款且已审核的订单。新行运费/关税/折扣默认为0，手续费自动计算。': '仅可添加同门店、未开票、未付款且已审核的订单。新行运费/关税/折扣默认为0，手续费自动计算。',
  '驳回订单': '驳回订单',
  '驳头': '驳头',
  '驳头+下口袋牙边': '驳头+下口袋牙边',
  '驳头+下口袋牙边+胸袋': '驳头+下口袋牙边+胸袋',
  '驳头型': '驳头型',
  '驳头宽': '驳头宽',
  '驳头眼锁眼线': '驳头眼锁眼线',
  '驳头眼长度': '驳头眼长度',
  '高端档': '高端档',
  '高端档（高）': '高端档（高）',
  '高级工艺': '高级工艺',
  '黑名单': '黑名单',
  '黑色无防滑腰里': '黑色无防滑腰里',
  '黑色里布': '黑色里布',
  '黑色防滑腰里': '黑色防滑腰里',
  '默认合缝上袖': '默认合缝上袖',
  '默认工厂': '默认工厂',
  '默认左驳头眼': '默认左驳头眼',
  '龙角型': '龙角型',
  '刺绣': '刺绣',
  '运输方式': '运输方式',
  '正常14天': '正常14天',
  '优先10天': '优先10天',
  '加急7天': '加急7天',
  '加急5天': '加急5天',
  '标准成衣试身': '标准成衣试身',
  '无需试身': '无需试身',
  '试身回': '试身回',
  '手工试毛样': '手工试毛样',
  '顺丰': '顺丰',
  '代理': '代理',
  'CMT加工费': 'CMT加工费',
  'RTW数量折扣': 'RTW数量折扣',
  '优惠合计': '优惠合计',
  '个性收费合计': '个性收费合计',
  '个性收费项': '个性收费项',
  '个行项目': '个行项目',
  '个订单': '个订单',
  '个订单生成发票': '个订单生成发票',
  '临时': '临时',
  '临时面料已添加': '临时面料已添加',
  '件': '件',
  '估算': '估算',
  '全部门店': '全部门店',
  '内部备注（不显示在报价单）': '内部备注（不显示在报价单）',
  '加载中...': '加载中...',
  '单价 (USD)': '单价 (USD)',
  '发票已生成': '发票已生成',
  '发票总额': '发票总额',
  '发票日期': '发票日期',
  '发票生成': '发票生成',
  '发票生成成功': '发票生成成功',
  '发票编号': '发票编号',
  '合计': '合计',
  '名称': '名称',
  '品类数：': '品类数：',
  '基于订单生成发票，可调整单价': '基于订单生成发票，可调整单价',
  '填写后自动作为当前行面料': '填写后自动作为当前行面料',
  '备注（内部用，不显示在报价单）': '备注（内部用，不显示在报价单）',
  '如：S / M / L / XL': '如：S / M / L / XL',
  '如：TEMP-001': '如：TEMP-001',
  '如：共5位客户，面料已确认，需加急...': '如：共5位客户，面料已确认，需加急...',
  '如：深蓝色 / 细条纹 / 客户A': '如：深蓝色 / 细条纹 / 客户A',
  '如：深蓝色羊毛': '如：深蓝色羊毛',
  '如：自定义品牌': '如：自定义品牌',
  '客户：': '客户：',
  '客户看到：品类 + 工艺 + 单价 + 数量 + 小计': '客户看到：品类 + 工艺 + 单价 + 数量 + 小计',
  '客户门店': '客户门店',
  '导入订单信息失败': '导入订单信息失败',
  '将为': '将为',
  '小计': '小计',
  '已开票': '已开票',
  '已选收费项': '已选收费项',
  '总套数：': '总套数：',
  '总额': '总额',
  '报价模式': '报价模式',
  '报价汇总': '报价汇总',
  '报价计算成功': '报价计算成功',
  '搜索订单号/客户名...': '搜索订单号/客户名...',
  '搜索订单号/客户名/门店编号/备注': '搜索订单号/客户名/门店编号/备注',
  '搜索订单号/客户名/门店编号/门店名称/备注': '搜索订单号/客户名/门店编号/门店名称/备注',
  '搜索门店名称或编号...': '搜索门店名称或编号...',
  '数量（件）': '数量（件）',
  '数量折扣': '数量折扣',
  '数量折扣：': '数量折扣：',
  '新加': '新加',
  '新增临时面料': '新增临时面料',
  '新建门店': '新建门店',
  '更换订单': '更换订单',
  '最近使用': '最近使用',
  '服装基础价格': '服装基础价格',
  '服装小计': '服装小计',
  '未开票': '未开票',
  '标准报价': '标准报价',
  '混合订单': '混合订单',
  '添加品类行': '添加品类行',
  '物流': '物流',
  '生成发票失败': '生成发票失败',
  '生成失败': '生成失败',
  '码数（选填）': '码数（选填）',
  '确认生成': '确认生成',
  '确认生成发票': '确认生成发票',
  '确认选择': '确认选择',
  '绑定订单号': '绑定订单号',
  '耗料量（米）': '耗料量（米）',
  '联系邮箱': '联系邮箱',
  '获取订单失败': '获取订单失败',
  '获取订单详情失败': '获取订单详情失败',
  '订单': '订单',
  '订单信息已导入': '订单信息已导入',
  '订单明细': '订单明细',
  '订单类型': '订单类型',
  '请为每个订单行绑定真实订单号': '请为每个订单行绑定真实订单号',
  '请先填写下方临时面料信息': '请先填写下方临时面料信息',
  '请先选择门店': '请先选择门店',
  '请先选择门店客户': '请先选择门店客户',
  '请完善品类信息': '请完善品类信息',
  '请至少选择一个订单': '请至少选择一个订单',
  '请输入面料编号': '请输入面料编号',
  '请选择': '请选择',
  '请选择...': '请选择...',
  '请选择价格档': '请选择价格档',
  '请选择门店，然后选择未开票的订单': '请选择门店，然后选择未开票的订单',
  '输入地址': '输入地址',
  '输入编号/品牌/颜色搜索...': '输入编号/品牌/颜色搜索...',
  '输入联系人姓名': '输入联系人姓名',
  '输入联系电话': '输入联系电话',
  '输入门店名称': '输入门店名称',
  '输入门店编号': '输入门店编号',
  '返回门店选择': '返回门店选择',
  '适用范围：开发 / 财务 / 业务团队': '适用范围：开发 / 财务 / 业务团队',
  '选择门店': '选择门店',
  '已选门店': '已选门店',
  '暂未选择门店': '暂未选择门店',
  '透明报价': '透明报价',
  '量体定制 (MTM)': '量体定制 (MTM)',
  '门店创建成功': '门店创建成功',
  '门店客户': '门店客户',
  '附加费用': '附加费用',
  '附加费用合计': '附加费用合计',
  '面料编号已存在': '面料编号已存在',
  '必填': '必填',
  'CMT仅含工艺费 (USD)': 'CMT仅含工艺费 (USD)',
  'CMT — 仅含工艺费，不含面料成本。以下价格仅涵盖裁剪、缝制及整烫工艺费用，客户须自行提供所有面料，面料成本不包含在此报价中。': 'CMT — 仅含工艺费，不含面料成本。以下价格仅涵盖裁剪、缝制及整烫工艺费用，客户须自行提供所有面料，面料成本不包含在此报价中。',
  'CMT 价格表': 'CMT 价格表',
  'USD · 含面料及工艺费，不含关税': 'USD · 含面料及工艺费，不含关税',
  '上衣+马甲': '上衣+马甲',
  '个性收费表': '个性收费表',
  '个性收费项目': '个性收费项目',
  '付款条款': '付款条款',
  '价格区间': '价格区间',
  '分享': '分享',
  '分享功能开发中': '分享功能开发中',
  '分享报价单': '分享报价单',
  '分享链接有效期 30 天，外部客户无需登录即可查看': '分享链接有效期 30 天，外部客户无需登录即可查看',
  '分类': '分类',
  '刷新预览': '刷新预览',
  '加工费 (USD)': '加工费 (USD)',
  '加载失败': '加载失败',
  '重新加载': '重新加载',
  '加载客户列表失败': '加载客户列表失败',
  '加载报价单': '加载报价单',
  '加载报价单失败': '加载报价单失败',
  '单价(USD)': '单价(USD)',
  '历史': '历史',
  '发票不存在或已被删除': '发票不存在或已被删除',
  '发票总金额已包含PayPal手续费和运费，不包含进口关税。': '发票总金额已包含PayPal手续费和运费，不包含进口关税。',
  '发票明细': '发票明细',
  '含面料及工艺费，不含关税': '含面料及工艺费，不含关税',
  '客户信息已更新': '客户信息已更新',
  '客户信息已设置': '客户信息已设置',
  '客户已选择': '客户已选择',
  '客户未设置': '客户未设置',
  '客户 / 门店': '客户 / 门店',
  '导出 Excel': '导出 Excel',
  '导出Excel': '导出Excel',
  '导出Excel功能开发中': '导出Excel功能开发中',
  '导出Excel失败': '导出Excel失败',
  '导出 PDF': '导出 PDF',
  '导出PDF': '导出PDF',
  '导出PDF功能开发中': '导出PDF功能开发中',
  '导出PDF失败': '导出PDF失败',
  '已从面料库存导入': '已从面料库存导入',
  '开始生产前需支付 50% 定金。': '开始生产前需支付 50% 定金。',
  '形式发票': '形式发票',
  '成衣 (RTW)': '成衣 (RTW)',
  '我们的交付时间为收到订单、付款并确认一切正确后的15天内。特殊设计和手工工艺将在3周内完成。运输时间根据物流公司约为4天。': '我们的交付时间为收到订单、付款并确认一切正确后的15天内。特殊设计和手工工艺将在3周内完成。运输时间根据物流公司约为4天。',
  '所有价格以美元（USD）计算，自报价日起 30 天内有效。': '所有价格以美元（USD）计算，自报价日起 30 天内有效。',
  '打印 / 存PDF': '打印 / 存PDF',
  '报价单': '报价单',
  '报价单生成': '报价单生成',
  '报价总额': '报价总额',
  '报价查看': '报价查看',
  '报价自报价日起30天内有效。所有价格均以美元计算，除非另有说明，不含进口关税及税费。': '报价自报价日起30天内有效。所有价格均以美元计算，除非另有说明，不含进口关税及税费。',
  '搜索客户名称...': '搜索客户名称...',
  '收到服装后请及时确认。如有任何问题请在7天内联系我们。超过7天我们将视为服装合格，不可退换。': '收到服装后请及时确认。如有任何问题请在7天内联系我们。超过7天我们将视为服装合格，不可退换。',
  '收到服装后请及时确认，如有任何问题请在7天内联系我们。超过7天我们将视为服装合格，不可退换。': '收到服装后请及时确认，如有任何问题请在7天内联系我们。超过7天我们将视为服装合格，不可退换。',
  '新建客户': '新建客户',
  '无效的分享链接或链接已过期': '无效的分享链接或链接已过期',
  '显示列': '显示列',
  '显示工艺': '显示工艺',
  '暂无 CMT 价格数据': '暂无 CMT 价格数据',
  '暂无个性收费项目': '暂无个性收费项目',
  '暂无客户数据': '暂无客户数据',
  '暂无报价数据': '暂无报价数据',
  '未找到报价数据，请先保存报价': '未找到报价数据，请先保存报价',
  '本报价属机密文件，仅供指定收件人参考，未经授权不得对外泄露。': '本报价属机密文件，仅供指定收件人参考，未经授权不得对外泄露。',
  '条记录': '条记录',
  '条面料': '条面料',
  '个品牌': '个品牌',
  '基础报价单': '基础报价单',
  '历史报价单': '历史报价单',
  '请先选择面料': '请先选择面料',
  '来料加工 (CMT)': '来料加工 (CMT)',
  '来料加工（CMT）价格表': '来料加工（CMT）价格表',
  '标准交期为收到定金后25-35个工作日，加急订单视情况而定。': '标准交期为收到定金后25-35个工作日，加急订单视情况而定。',
  '生成分享链接失败': '生成分享链接失败',
  '确认新建': '确认新建',
  '确认订单后，生产周期为 4–6 周。': '确认订单后，生产周期为 4–6 周。',
  '确认订单需支付50%定金，剩余款项在发货前结清。': '确认订单需支付50%定金，剩余款项在发货前结清。',
  '获取详情失败': '获取详情失败',
  '西裙': '西裙',
  '设置客户信息': '设置客户信息',
  '请先保存报价单': '请先保存报价单',
  '转为发票': '转为发票',
  '输入客户名称': '输入客户名称',
  '输入邮箱地址': '输入邮箱地址',
  '返回价格计算器': '返回价格计算器',
  '返回发票列表': '返回发票列表',
  '返回报价单': '返回报价单',
  '进口关税、清关费用及当地税费由买方承担，除非另有书面协议。': '进口关税、清关费用及当地税费由买方承担，除非另有书面协议。',
  '选择客户': '选择客户',
  '链接已复制': '链接已复制',
  '附加费用（物流/关税等）': '附加费用（物流/关税等）',
  '面料供应受布料库存限制，如所选面料无货，我方保留建议同等替代品的权利。': '面料供应受布料库存限制，如所选面料无货，我方保留建议同等替代品的权利。',
  '面料报价': '面料报价',
  '面料编号 / 品牌': '面料编号 / 品牌',
  '个品类': '个品类',
  '价格计算器': '价格计算器',
  '保存并生成报价单': '保存并生成报价单',
  '保存草稿': '保存草稿',
  '功能开发中': '功能开发中',
  '加载': '加载',
  '历史草稿': '历史草稿',
  '导入订单': '导入订单',
  '导入订单失败': '导入订单失败',
  '成衣': '成衣',
  '保存报价单': '保存报价单',
  '保存报价单失败': '保存报价单失败',
  '显示RTW批量折扣': '显示RTW批量折扣',
  '报价单已保存': '报价单已保存',
  '暂无草稿': '暂无草稿',
  '暂无草稿/提交状态的订单': '暂无草稿/提交状态的订单',
  '生成分享链接': '生成分享链接',
  '草稿已保存': '草稿已保存',
  '草稿已删除': '草稿已删除',
  '草稿已加载': '草稿已加载',
  '获取订单列表失败': '获取订单列表失败',
  '订单导入成功，已填充报价参数': '订单导入成功，已填充报价参数',
  '该订单没有明细项': '该订单没有明细项',
  '编号': '编号',
  '客供纽扣': '客供纽扣',
  '纹路/花色': '纹路/花色',
  '幅宽（cm）': '幅宽（cm）',
  '选择同步数据库': '选择同步数据库',
  '同步到品类项': '同步到品类项',
  '同步选项到品类项': '同步选项到品类项',
  '源数据库': '源数据库',
  '目标分类项': '目标分类项',
  '请选择目标分类项': '请选择目标分类项',
  '目标设计项': '目标设计项',
  '选择要同步的设计项（可多选）': '选择要同步的设计项（可多选）',
  '源选项': '源选项',
  '无源选项': '无源选项',
  '已选择 {{count}} 个目标设计项，将同步源数据库中编码对应的设计项选项，重复编码的选项将自动跳过': '已选择 {{count}} 个目标设计项，将同步源数据库中编码对应的设计项选项，重复编码的选项将自动跳过',
  '同步成功，共 {{count}} 个设计项，新增 {{added}} 个选项': '同步成功，共 {{count}} 个设计项，新增 {{added}} 个选项',
  '没有成功同步的设计项，请检查源品类中是否存在对应编码的设计项': '没有成功同步的设计项，请检查源品类中是否存在对应编码的设计项',
  '请至少选择一个目标设计项': '请至少选择一个目标设计项',
  '订单信息': '订单信息',
  '金额信息': '金额信息',
  '选择同步仓库': '选择同步仓库',
  '管理仓库': '管理仓库',
  '同步仓库管理': '同步仓库管理',
  '仓库列表': '仓库列表',
  '仓库名称': '仓库名称',
  '仓库编码': '仓库编码',
  '暂无仓库': '暂无仓库',
  '选项管理': '选项管理',
  '新建选项': '新建选项',
  '编辑选项': '编辑选项',
  '请先选择左侧仓库': '请先选择左侧仓库',
  '源仓库': '源仓库',
  '将同步仓库中的选项到目标设计项，重复编码的选项将自动跳过': '将同步仓库中的选项到目标设计项，重复编码的选项将自动跳过',
  '请选择同步仓库': '请选择同步仓库',
  '没有成功同步的设计项，请检查仓库中是否存在选项': '没有成功同步的设计项，请检查仓库中是否存在选项',
  '无权限访问工作台': '无权限访问工作台',
  '当前账号没有权限访问首页，请联系管理员': '当前账号没有权限访问首页，请联系管理员',
  '服务器暂时不可用，请稍后重试': '服务器暂时不可用，请稍后重试',
  '服务器内部错误，请联系管理员': '服务器内部错误，请联系管理员',
  '请求接口不存在': '请求接口不存在',
  '发票管理': '发票管理',
  '门店账号': '门店账号',
  '客户注册审核': '客户注册审核',
  '通过并分配门店': '通过并分配门店',
  '修改门店': '修改门店',
  '确认拒绝该账号？': '确认拒绝该账号？',
  '请选择或输入门店': '请选择或输入门店',
  '门店来源': '门店来源',
  '选择已有门店': '选择已有门店',
  '输入新门店': '输入新门店',
  '新门店名称': '新门店名称',
  '请输入新门店名称，不存在则自动创建': '请输入新门店名称，不存在则自动创建',
  '当前门店': '当前门店',
  '待创建': '待创建',
  '搜索用户名/姓名/电话/邮箱': '搜索用户名/姓名/电话/邮箱',
  '价格体系配置': '价格体系配置',
  '基础订单配置': '基础订单配置',
  '团队管理': '团队管理',
  '团队成员管理': '团队成员管理',
  '团队订单': '团队订单',
  '提成计算器': '提成计算器',
  '工资计算器': '工资计算器',
  '工资汇总': '工资汇总',
  '年终分红': '年终分红',
  '折扣审批': '折扣审批',
  '角色权限': '角色权限',
  '切换用户': '切换用户',
  '系统配置': '系统配置',
  '生产完成': '生产完成',
  '作废': '作废',
  '系统里布': '系统里布',
  '系统纽扣': '系统纽扣',
  '3粒': '3粒',
  '5粒': '5粒',
  '6粒': '6粒',
  'A字裙': 'A字裙',
  '上衣设计': '上衣设计',
  '上衣设计尺寸': '上衣设计尺寸',
  '中长款': '中长款',
  '中长裙': '中长裙',
  '亚麻': '亚麻',
  '低腰': '低腰',
  '半身裙': '半身裙',
  '单开衩': '单开衩',
  '单扣袖口': '单扣袖口',
  '单褶': '单褶',
  '厚羊毛': '厚羊毛',
  '及膝': '及膝',
  '双开线袋': '双开线袋',
  '双开衩': '双开衩',
  '双褶': '双褶',
  '大衣设计': '大衣设计',
  '大衣设计尺寸': '大衣设计尺寸',
  '工艺类型': '工艺类型',
  '带盖口袋': '带盖口袋',
  '平脚': '平脚',
  '平驳头': '平驳头',
  '戗驳头': '戗驳头',
  '标准领': '标准领',
  '棕色法兰绒': '棕色法兰绒',
  '法式袖口': '法式袖口',
  '深藏青羊毛': '深藏青羊毛',
  '深藏青羊毛裙料': '深藏青羊毛裙料',
  '深藏青羊毛裤料': '深藏青羊毛裤料',
  '温莎领': '温莎领',
  '灰色精纺': '灰色精纺',
  '牛角扣': '牛角扣',
  '珍珠母贝': '珍珠母贝',
  '白色纯棉': '白色纯棉',
  '百褶裙': '百褶裙',
  '真丝红色': '真丝红色',
  '短裙': '短裙',
  '纽扣数': '纽扣数',
  '纽扣领': '纽扣领',
  '羊绒': '羊绒',
  '翻边': '翻边',
  '蓝色纯棉': '蓝色纯棉',
  '衬衫设计尺寸': '衬衫设计尺寸',
  '裙型': '裙型',
  '裙子': '裙子',
  '裙装设计尺寸': '裙装设计尺寸',
  '裙长': '裙长',
  '裤装设计尺寸': '裤装设计尺寸',
  '西服上衣': '西服上衣',
  '西裤+马甲': '西裤+马甲',
  '西裤设计': '西裤设计',
  '贴袋': '贴袋',
  '铅笔裙': '铅笔裙',
  '长度': '长度',
  '长裙': '长裙',
  '青果领': '青果领',
  '马甲专用料': '马甲专用料',
  '马甲设计尺寸': '马甲设计尺寸',
  '高腰': '高腰',
  '待采面料': '待采面料',
  '邮寄面料': '邮寄面料',
  '米': '米',
  '顺丰快递': '顺丰快递',
  '平肩': '平肩',
  '溜肩': '溜肩',
  '衣长': '衣长',
  '图文': '图文',
  '码': '码',
  '英寸': '英寸',
  '颗': '颗',
  '包': '包',
  '订单列表': '订单列表',
  '本月订单量': '本月订单量',
  '门店本月订单汇总': '门店本月订单汇总',
  '设计师本月订单汇总': '设计师本月订单汇总',
  '上月设计师订单汇总': '上月设计师订单汇总',
  '浏览报价': '浏览报价',
  '查看账单': '查看账单',
  '离线': '离线',
  '在线客户': '在线客户',
  '加载基础数据失败': '加载基础数据失败',
  '档位': '档位',
  '销售额区间 (USD)': '销售额区间 (USD)',
  '提成比例': '提成比例',
  '该档最大提成': '该档最大提成',
  '各档提成分布': '各档提成分布',
  '提成阶梯参考表': '提成阶梯参考表',
  '成员A': '成员A',
  '成员B': '成员B',
  '业务经理提成计算器': '业务经理提成计算器',
  '团队管理提成阶梯': '团队管理提成阶梯',
  '团队月销售额区间 (USD)': '团队月销售额区间 (USD)',
  '管理提成比例': '管理提成比例',
  '定制订单（业务员）': '定制订单（业务员）',
  '定制订单提成计算': '定制订单提成计算',
  '团单（业务员）': '团单（业务员）',
  '团单提成计算': '团单提成计算',
  '输入销售额，实时计算各档提成金额，超额累进分段计算': '输入销售额，实时计算各档提成金额，超额累进分段计算',
  '姓名': '姓名',
  '类型': '类型',
  '原价': '原价',
  '折后价': '折后价',
  '待审批': '待审批',
  '已拒绝': '已拒绝',
  '全部状态': '全部状态',
  '暂无记录': '暂无记录',
  '需要审批': '需要审批',
  '无需审批': '无需审批',
  '删除成功': '删除成功',
  '状态已更新': '状态已更新',
  '确定删除？': '确定删除？',
  '可选备注': '可选备注',
  '提成损失': '提成损失',
  '原价提成': '原价提成',
  '折后提成': '折后提成',
  '管理折扣申请及审批流程': '管理折扣申请及审批流程',
  '需要审批，折扣过低': '需要审批，折扣过低',
  '无需审批，折扣合规': '无需审批，折扣合规',
  '保存折扣审批记录': '保存折扣审批记录',
  '确认保存': '确认保存',
  '修改记录': '修改记录',
  '暂无修改记录': '暂无修改记录',
  '编辑历史': '编辑历史',
  '编辑前快照': '编辑前快照',
  '修改前': '修改前',
  '修改后': '修改后',
  '款式项': '款式项',
  '暂无变更': '暂无变更',
  '交付物流': '交付物流',
  '交货天数': '交货天数',
  '交货日期': '交货日期',
  '快递方式': '快递方式',
  '送货地址': '送货地址',
  '试身': '试身',
  '个性定制': '个性定制',
  '折扣金额': '折扣金额',
  '正在导出...': '正在导出...',
  '订单提醒': '订单提醒',
  '系统升级': '系统升级',
  '待办事宜': '待办事宜',
  '发票更新': '发票更新',
  '催款提醒': '催款提醒',
  '折扣消息': '折扣消息',
  '限时折扣': '限时折扣',
  '日常消息': '日常消息',
  '模板管理': '模板管理',
  '模板已保存': '模板已保存',
  '模板已载入': '模板已载入',
  '载入模板': '载入模板',
  '消息模板管理': '消息模板管理',
  '模板标题': '模板标题',
  '模板内容': '模板内容',
  '删除模板': '删除模板',
  '保存模板': '保存模板',
  '该类型暂无模板': '该类型暂无模板',
  '已配置': '已配置',
  '确认删除该模板?': '确认删除该模板?',
  '发送消息': '发送消息',
  '请输入消息标题': '请输入消息标题',
  '请输入内容': '请输入内容',
  '例如：您的订单已进入生产阶段': '例如：您的订单已进入生产阶段',
  '审核操作': '审核操作',
  '耗料计算': '耗料计算',
  '尺寸加放': '尺寸加放',
  '面料编号及默认用量': '面料编号及默认用量',
  '耗料': '耗料',
  '面料价格档': '面料价格档',
  '重新计算价格': '重新计算价格',
  '价格已重新计算': '价格已重新计算',
  '重新计算失败': '重新计算失败',
  '请先填写面料价格档': '请先填写面料价格档',
  // 加放规则维护
  '加放规则维护': '加放规则维护',
  '版型库': '版型库',
  '尺码表': '尺码表',
  '加放规则': '加放规则',
  '版型名称': '版型名称',
  '版型编码': '版型编码',
  '参考款式图': '参考款式图',
  '参考款式图 URL(每行一个)': '参考款式图 URL(每行一个)',
  '新增版型': '新增版型',
  '编辑版型': '编辑版型',
  '来源': '来源',
  '全部品类': '全部品类',
  '规格编码': '规格编码',
  '主索引尺寸': '主索引尺寸',
  '体型码': '体型码',
  '选择版型查看尺码点': '选择版型查看尺码点',
  '请选择版型': '请选择版型',
  '西服上衣加放(常规)': '西服上衣加放(常规)',
  '西服上衣加放(大肚)': '西服上衣加放(大肚)',
  '马甲加放': '马甲加放',
  '西裤加放(基础)': '西裤加放(基础)',
  '西裤褶型/腰高调整': '西裤褶型/腰高调整',
  '衬衫加放(在西服成品上追加)': '衬衫加放(在西服成品上追加)',
  '大衣加放(在虚拟西服上追加)': '大衣加放(在虚拟西服上追加)',
  '合体度': '合体度',
  '紧身裤褶调整(臀围)': '紧身裤褶调整(臀围)',
  '其它合体度褶调整(臀围)': '其它合体度褶调整(臀围)',
  '大腿褶加量': '大腿褶加量',
  '立裆褶加量': '立裆褶加量',
  '腰高立裆加量': '腰高立裆加量',
  '以下规则来源于《审单操作说明.md v4.3》，暂为程序内硬编码；后续可迁移到数据库配置。':
    '以下规则来源于《审单操作说明.md v4.3》，暂为程序内硬编码；后续可迁移到数据库配置。',
  '大肚体形判定：西服上衣胸围-肚围<0；马甲胸围-肚围<8；或 BMI≥28。判为大肚时切换到大肚规则表。':
    '大肚体形判定：西服上衣胸围-肚围<0；马甲胸围-肚围<8；或 BMI≥28。判为大肚时切换到大肚规则表。',
  '半 cm 取整：所有推算结果向下取到最接近的 0.5cm。':
    '半 cm 取整：所有推算结果向下取到最接近的 0.5cm。',
  '本订单小计': '本订单小计',
  '回收站': '回收站',
  '永久删除': '永久删除',
  '删除时间': '删除时间',
  '删除人': '删除人',
  '仅管理员可访问': '仅管理员可访问',
  '搜索订单号/客户/门店': '搜索订单号/客户/门店',
  '搜索发票号/门店': '搜索发票号/门店',
  '恢复': '恢复',
  '已恢复': '已恢复',
  '已永久删除': '已永久删除',
  '恢复失败': '恢复失败',
  '确认恢复此订单？': '确认恢复此订单？',
  '确认恢复此发票？': '确认恢复此发票？',
  '永久删除后无法恢复，确认？': '永久删除后无法恢复，确认？',
  '已采购的记录不可删除': '已采购的记录不可删除',
  '关键词搜索': '关键词搜索',
  '门店编号/发票编号/关联订单号': '门店编号/发票编号/关联订单号',
  '发票详情': '发票详情',
  '已付清': '已付清',
  '部分支付': '部分支付',
  '未支付': '未支付',
  '关联订单数量': '关联订单数量',
  '待申请采购': '待申请采购',
  '投产日期': '投产日期',
  '待付款金额': '待付款金额',
  '跟单': '跟单',
  '工厂已备货，无需采购': '工厂已备货，无需采购',
  '价格待确认：未设置面料价格档，当前基础价格不可信，请联系业务员设置价格档后重新计算': '价格待确认：未设置面料价格档，当前基础价格不可信，请联系业务员设置价格档后重新计算',
  '价格待确认，未设置价格档': '价格待确认，未设置价格档',
  '发票总额（最终对客金额）': '发票总额（最终对客金额）',
  '费用明细': '费用明细',
  '基础价': '基础价',
  '附加费': '附加费',
  '该订单发票金额': '该订单发票金额',
  '关联发票总金额': '关联发票总金额',
  '含该发票所有订单': '含该发票所有订单',
  '价格待确认：未设置面料价格档，当前价格仅含加工费，请设置价格档后重新计算': '价格待确认：未设置面料价格档，当前价格仅含加工费，请设置价格档后重新计算',
  '合并生成采购单': '合并生成采购单',
  '合并汇总': '合并汇总',
  '汇总数量': '汇总数量',
  '请选择（可选）': '请选择（可选）',
  '没有可合并采购的订单': '没有可合并采购的订单',
  '张合并采购单': '张合并采购单',
  '张生成失败': '张生成失败',
  '未过初审': '未过初审',
  '已经申请采购': '已经申请采购',
  '门店/面料编号不一致，已跳过': '门店/面料编号不一致，已跳过',
  '条合并汇总记录': '条合并汇总记录',
  '将合并为': '将合并为',
  '可合并': '可合并',
  '请选择工厂供应商': '请选择工厂供应商',
  '上架时间': '上架时间',
  '季度': '季度',
  '标签': '标签',
  '全部标签': '全部标签',
  '适合品类': '适合品类',
  '款面料': '款面料',
  '批量打标签': '批量打标签',
  '异议备注': '异议备注',
  '最多4张': '最多4张',
  '异议情况备注结算（点下方「保存」后写入当月工资表）': '异议情况备注结算（点下方「保存」后写入当月工资表）',
  '样本册管理': '样本册管理',
  '追加': '追加',
  '替换': '替换',
  '设置方式': '设置方式',
  '请选择标签': '请选择标签',
  '设置失败': '设置失败',
  '已为': '已为',
  '款面料设置标签': '款面料设置标签',
  '请选择具体面料（样本册合并行不支持批量标签）': '请选择具体面料（样本册合并行不支持批量标签）',
  '未知面料': '未知面料',
  '订单数': '订单数',
  '按门店+面料自动分组': '按门店+面料自动分组',
  '以下订单未纳入合并': '以下订单未纳入合并',
  '合并订单明细': '合并订单明细',
  '（共': '（共',
  '个订单）': '个订单）',
  '未设置': '未设置',
  '请为以下分组选择工厂供应商': '请为以下分组选择工厂供应商',
  '用量': '用量',
  '编辑用量': '编辑用量',
  '点击编辑用量': '点击编辑用量',
  '请输入用量': '请输入用量',
  '用量已保存': '用量已保存',
  'Excel清单': 'Excel清单',
  'season': 'season',
  'zip内文件名=面料编码，如 66012-01.jpg；上限500M': 'zip内文件名=面料编码，如 66012-01.jpg；上限500M',
  '上传并预览': '上传并预览',
  '下载模板': '下载模板',
  '人工填写': '人工填写',
  '仅图片': '仅图片',
  '仅更新图片': '仅更新图片',
  '价格档变动': '价格档变动',
  '依据': '依据',
  '信息': '信息',
  '入库失败': '入库失败',
  '入库完成': '入库完成',
  '其中跨档': '其中跨档',
  '写入失败': '写入失败',
  '写入编号': '写入编号',
  '动作': '动作',
  '原价格档': '原价格档',
  '可生成': '可生成',
  '图片匹配': '图片匹配',
  '填写信息并上传': '填写信息并上传',
  '多余': '多余',
  '如 NOBILITY 经典系列；不存在将自动创建样册': '如 NOBILITY 经典系列；不存在将自动创建样册',
  '如 SS2026 / FW2026': '如 SS2026 / FW2026',
  '存在价格档变动，请先勾选确认': '存在价格档变动，请先勾选确认',
  '存在跨价格档变动，将影响客户报价，请逐条核对后勾选确认': '存在跨价格档变动，将影响客户报价，请逐条核对后勾选确认',
  '季节(选填)': '季节(选填)',
  '季节字段': '季节字段',
  '导入完成': '导入完成',
  '导入模式': '导入模式',
  '导入记录': '导入记录',
  '将调价': '将调价',
  '已入库': '已入库',
  '已写入': '已写入',
  '已更新': '已更新',
  '建议编号': '建议编号',
  '张': '张',
  '总行数': '总行数',
  '成功': '成功',
  '或按品牌': '或按品牌',
  '执行失败': '执行失败',
  '执行调价': '执行调价',
  '批次号': '批次号',
  '批次明细': '批次明细',
  '批量调价': '批量调价',
  '数值': '数值',
  '新价': '新价',
  '新价格档': '新价格档',
  '新增': '新增',
  '新增+更新': '新增+更新',
  '无可写入编号': '无可写入编号',
  '时间': '时间',
  '更新': '更新',
  '本样册编号': '本样册编号',
  '条将发生价格档迁移': '条将发生价格档迁移',
  '条编号？仅更新编号列，不影响现有功能': '条编号？仅更新编号列，不影响现有功能',
  '样册': '样册',
  '样册名称': '样册名称',
  '样册导入': '样册导入',
  '样册导入与价格档维护': '样册导入与价格档维护',
  '样册编号': '样册编号',
  '档变动': '档变动',
  '模式': '模式',
  '模板下载失败': '模板下载失败',
  '现有编号': '现有编号',
  '生成编号建议': '生成编号建议',
  '确认写入': '确认写入',
  '确认应用价格档变动': '确认应用价格档变动',
  '确认执行批量调价？': '确认执行批量调价？',
  '编码': '编码',
  '范围内面料': '范围内面料',
  '行/增/改/败': '行/增/改/败',
  '行号': '行号',
  '覆盖': '覆盖',
  '覆盖更新价格': '覆盖更新价格',
  '解析失败': '解析失败',
  '请先勾选确认价格档变动': '请先勾选确认价格档变动',
  '请先选择Excel文件': '请先选择Excel文件',
  '请填写数值': '请填写数值',
  '明细': '明细',
  '调价只按零剪价重算价格档；仅当调价导致价格档变化时才需要二次确认（价格档影响客户报价）': '调价只按零剪价重算价格档；仅当调价导致价格档变化时才需要二次确认（价格档影响客户报价）',
  '跨价格档': '跨价格档',
  '跳过': '跳过',
  '选择Excel': '选择Excel',
  '选择ZIP': '选择ZIP',
  '选择品牌': '选择品牌',
  '选择样册(二选一)': '选择样册(二选一)',
  '部分失败': '部分失败',
  '错误': '错误',
  '零剪价=固定价': '零剪价=固定价',
  '零剪价增减(元)': '零剪价增减(元)',
  '零剪价浮动%': '零剪价浮动%',
  '需人工': '需人工',
  '面料样册批量上架 / 季度调价 / 编号规范': '面料样册批量上架 / 季度调价 / 编号规范',
  '面料编码': '面料编码',
  '预览失败': '预览失败',
  '预览影响': '预览影响',
  '预览确认': '预览确认',
  '失败': '失败',
  '图片压缩包(选填)': '图片压缩包(选填)',
  '有': '有',
  '写入': '写入',
  '确认入库': '确认入库',
  '上传一张布卡照片，测试标签编码/价格能否被识别；识别不到编码的照片需重拍（对焦编码、正方形构图、无反光）': '上传一张布卡照片，测试标签编码/价格能否被识别；识别不到编码的照片需重拍（对焦编码、正方形构图、无反光）',
  '不可用：未识别到编码，请重拍': '不可用：未识别到编码，请重拍',
  '保留': '保留',
  '可用：识别到编码': '可用：识别到编码',
  '定稿失败': '定稿失败',
  '幅宽': '幅宽',
  '开始测试': '开始测试',
  '开始识别': '开始识别',
  '拆页失败': '拆页失败',
  '拍照测试': '拍照测试',
  '拍照识别': '拍照识别',
  '拍照识别测试': '拍照识别测试',
  '校对完成，生成预览': '校对完成，生成预览',
  '置信度': '置信度',
  '至少保留一行有效编码': '至少保留一行有效编码',
  '色号': '色号',
  '识别中': '识别中',
  '识别失败': '识别失败',
  '识别完成': '识别完成',
  '识别校对': '识别校对',
  '请选择PDF或图片包': '请选择PDF或图片包',
  '选择样册PDF/图片ZIP': '选择样册PDF/图片ZIP',
  '选择照片': '选择照片',
  '零剪价': '零剪价',
  '页': '页',
  '页提取到编码': '页提取到编码',
  '上传中': '上传中',
  '反面模式：当前页的编码/参数取自下一页照片顶部的标签；每页照片将裁掉顶部标签区，只保留布料': '反面模式：当前页的编码/参数取自下一页照片顶部的标签；每页照片将裁掉顶部标签区，只保留布料',
  '反面模式：最后一行（末页）的参数无法从下一页获得，请人工补填或取消勾选': '反面模式：最后一行（末页）的参数无法从下一页获得，请人工补填或取消勾选',
  '图': '图',
  '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；坐标按百分比应用到整本每一页': '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；坐标按百分比应用到整本每一页',
  '已按标准裁剪整本': '已按标准裁剪整本',
  '应用整本': '应用整本',
  '标签位置': '标签位置',
  '标签在反面(出现在下一页照片顶部)': '标签在反面(出现在下一页照片顶部)',
  '标签在正面(本页)': '标签在正面(本页)',
  '裁剪失败': '裁剪失败',
  '设置截取标准': '设置截取标准',
  '设置截取标准（以第1页为参考，应用到整本）': '设置截取标准（以第1页为参考，应用到整本）',
  '请先框选布料区域': '请先框选布料区域',
  '重新设置截取标准': '重新设置截取标准',
  '页提取到标签编码': '页提取到标签编码',
  '编辑品牌': '编辑品牌',
  '品牌名': '品牌名',
  '选择供应商': '选择供应商',
  '请输入品牌名': '请输入品牌名',
  '品牌已保存': '品牌已保存',
  '封面上传成功': '封面上传成功',
  '暂无封面': '暂无封面',
  '所选面料暂无价格数据': '所选面料暂无价格数据',
  '所选面料缺少面料编号': '所选面料缺少面料编号',
  '合作折扣 / 客户等级': '合作折扣 / 客户等级',
  '0.85 表示 8.5 折；此处设置会保存到该门店的折扣记录': '0.85 表示 8.5 折；此处设置会保存到该门店的折扣记录',
  '可选': '可选',
  '复制失败，请手动选择链接复制': '复制失败，请手动选择链接复制',
  '导出CMT价格表 Excel': '导出CMT价格表 Excel',
  '导出CMT价格表 PDF': '导出CMT价格表 PDF',
  '导出个性收费表 Excel': '导出个性收费表 Excel',
  '导出个性收费表 PDF': '导出个性收费表 PDF',
  '正在汇总': '正在汇总',
  '条记录，请稍候…': '条记录，请稍候…',
  '请不要刷新页面，稍后会自动进入报价单页面': '请不要刷新页面，稍后会自动进入报价单页面',
  '正在生成文件，请稍候…': '正在生成文件，请稍候…',
  '记录较多时需要一点时间，请不要刷新页面': '记录较多时需要一点时间，请不要刷新页面',
  '正在导出': '正在导出',
  '，请稍候…': '，请稍候…',
  '耗时较长时请不要刷新页面': '耗时较长时请不要刷新页面',
  '导出超时，请减少数据量后重试': '导出超时，请减少数据量后重试',
  '汇总超时，请减少选择的数据量后重试': '汇总超时，请减少选择的数据量后重试',
  '正在导出 PDF，请稍候…': '正在导出 PDF，请稍候…',
  '正在导出 Excel，请稍候…': '正在导出 Excel，请稍候…',
  '该月已单独设置': '该月已单独设置',
  '该月未单独设置，当前使用默认': '该月未单独设置，当前使用默认',
  '可点击上传，也可直接粘贴截图或拖拽图片到此处': '可点击上传，也可直接粘贴截图或拖拽图片到此处',
  '暂无图片': '暂无图片',
  '已发放该月工资并冻结记录': '已发放该月工资并冻结记录',
  '取消发放': '取消发放',
  '取消发放后该月解除冻结、员工不可见，可重新编辑后再发放。是否继续？': '取消发放后该月解除冻结、员工不可见，可重新编辑后再发放。是否继续？',
  '确认取消发放': '确认取消发放',
  '已取消发放，该月恢复可编辑': '已取消发放，该月恢复可编辑',
  '取消失败': '取消失败',
  '该月工资已发放并冻结。系统管理员可修改个别人，保存后将重新冻结，并要求该员工重新签收。': '该月工资已发放并冻结。系统管理员可修改个别人，保存后将重新冻结，并要求该员工重新签收。',
  '该月工资已发放并冻结，不可修改。如需调整请先取消发放。': '该月工资已发放并冻结，不可修改。如需调整请先取消发放。',
  '该月工资已冻结。系统管理员可修改个别人，保存后将重新冻结，并要求该员工重新签收。': '该月工资已冻结。系统管理员可修改个别人，保存后将重新冻结，并要求该员工重新签收。',
  '该月工资已冻结，不可修改。如需调整请先解除冻结。': '该月工资已冻结，不可修改。如需调整请先解除冻结。',
  '解除冻结': '解除冻结',
  '确认解除冻结': '确认解除冻结',
  '解除冻结后该月恢复实时计算与可编辑（不会发放给员工）。是否继续？': '解除冻结后该月恢复实时计算与可编辑（不会发放给员工）。是否继续？',
  '基数': '基数',
  '手工': '手工',
  // ===== 样册 PDF 导入 / 导出 / 产地支纱（2026-09）=====
  '产地': '产地',
  '请选择产地': '请选择产地',
  '中国': '中国',
  '英国': '英国',
  '意大利': '意大利',
  '日本': '日本',
  '韩国': '韩国',
  '如 Super 120s': '如 Super 120s',
  '面料标签上的支数，如 Super 100s / Super 120s': '面料标签上的支数，如 Super 100s / Super 120s',
  '导出样本册 PDF': '导出样本册 PDF',
  '导出样本册PDF': '导出样本册PDF',
  'PDF 已开始下载': 'PDF 已开始下载',
  'PDF 生成失败': 'PDF 生成失败',
  'PDF 上传失败': 'PDF 上传失败',
  'PDF页': 'PDF页',
  '只看异常': '只看异常',
  '换图': '换图',
  '图片已替换': '图片已替换',
  '缺图': '缺图',
  '有图': '有图',
  '无图': '无图',
  '全选所有册子': '全选所有册子',
  '清空': '清空',
  '册': '册',
  '本': '本',
  '约': '约',
  '款单独面料': '款单独面料',
  '请至少勾选一个样本册或面料': '请至少勾选一个样本册或面料',
  '确认导出': '确认导出',
  '可整品牌全选、跨品牌多选，也可展开册子勾选任意面料；导出为一个 PDF（每册带封面页，面料页左下角印编号/克重/成分）。': '可整品牌全选、跨品牌多选，也可展开册子勾选任意面料；导出为一个 PDF（每册带封面页，面料页左下角印编号/克重/成分）。',
  '该册下暂无面料': '该册下暂无面料',
  '选择面料': '选择面料',
  '收起面料': '收起面料',
  '上传样册 PDF…': '上传样册 PDF…',
  '识别面料编码': '识别面料编码',
  '按面料编码匹配…': '按面料编码匹配…',
  '样册PDF(选填)': '样册PDF(选填)',
  '封面图(选填)': '封面图(选填)',
  '选择PDF': '选择PDF',
  '上传整本样册 PDF：系统自动拆页并按「面料编码」与表格逐行匹配；上限1G': '上传整本样册 PDF：系统自动拆页并按「面料编码」与表格逐行匹配；上限1G',
  '样本册封面；不传则用 PDF 首页（无编码的封面页）自动生成方图': '样本册封面；不传则用 PDF 首页（无编码的封面页）自动生成方图',
  '供应商隶属品牌：选择供应商后，品牌下拉只显示其名下品牌': '供应商隶属品牌：选择供应商后，品牌下拉只显示其名下品牌',
  '全部供应商': '全部供应商',
  '选择已有册子 或 输入新名称': '选择已有册子 或 输入新名称',
  '该品牌下暂无册子，直接输入新名称即可新建': '该品牌下暂无册子，直接输入新名称即可新建',
  '【更新】从下拉里点选已有册子；【新建】直接输入一个不存在的名称。名称必须完全一致才认得出是同一本': '【更新】从下拉里点选已有册子；【新建】直接输入一个不存在的名称。名称必须完全一致才认得出是同一本',
  '将新建样本册': '将新建样本册',
  '将更新已有样本册': '将更新已有样本册',
  '统一格式：SS/AW + 完整年份，如 SS2026、AW2026': '统一格式：SS/AW + 完整年份，如 SS2026、AW2026',
  '新增品牌': '新增品牌',
  '新增失败': '新增失败',
  '品牌已新增': '品牌已新增',
  '请输入品牌名称': '请输入品牌名称',
  '输入新品牌名称': '输入新品牌名称',
  '该品牌已存在': '该品牌已存在',
  '设置截取标准（方图）': '设置截取标准（方图）',
  '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；框会锁定为正方形，坐标按百分比应用到整本每一页': '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；框会锁定为正方形，坐标按百分比应用到整本每一页',
  '文件内有': '文件内有',
  '个重复面料编码，已合并为一行（后出现的有值字段覆盖前一行，空值不覆盖）': '个重复面料编码，已合并为一行（后出现的有值字段覆盖前一行，空值不覆盖）',
  '个重复面料编码，已按「后出现的有值字段覆盖前一行」合并': '个重复面料编码，已按「后出现的有值字段覆盖前一行」合并',
  '行未匹配到 PDF 页图，已在预览中高亮': '行未匹配到 PDF 页图，已在预览中高亮',
  '该品牌下暂无样本册': '该品牌下暂无样本册',
  '暂无样本册': '暂无样本册',
  '下载PDF': '下载PDF',
  '「无图」「档变动」的行会高亮；所有字段可直接点击单元格修改，改完自动保存': '「无图」「档变动」的行会高亮；所有字段可直接点击单元格修改，改完自动保存',
  // ===== Excel/PDF 二选一（2026-09-12）=====
  'Excel清单(与PDF至少传一个)': 'Excel清单(与PDF至少传一个)',
  '样册PDF(与Excel至少传一个)': '样册PDF(与Excel至少传一个)',
  '请至少上传 Excel 清单 或 样册 PDF': '请至少上传 Excel 清单 或 样册 PDF',
  '未上传 Excel 时自动为「仅更新图片」：只按编码替换图片，不改动任何字段': '未上传 Excel 时自动为「仅更新图片」：只按编码替换图片，不改动任何字段',
  '本次将执行：全量上架 —— 按 Excel 更新字段，并用 PDF 按面料编码匹配图片': '本次将执行：全量上架 —— 按 Excel 更新字段，并用 PDF 按面料编码匹配图片',
  '本次将执行：只更新参数 —— 按 Excel 更新价格等字段，不涉及图片': '本次将执行：只更新参数 —— 按 Excel 更新价格等字段，不涉及图片',
  '本次将执行：仅更新图片 —— 按 PDF 识别到的面料编码替换图片，不改动任何字段（需面料已存在）': '本次将执行：仅更新图片 —— 按 PDF 识别到的面料编码替换图片，不改动任何字段（需面料已存在）',
  // ===== 2026-09-12 样册导入向导改版（流式上传 / 识别校对 / 正反面裁剪 / 批量调价多选） =====
  'OCR 原始文字（用于判断标签是否拍全、是否需要调整拍摄/裁剪）': 'OCR 原始文字（用于判断标签是否拍全、是否需要调整拍摄/裁剪）',
  '① 选择要识别的页面': '① 选择要识别的页面',
  '② 识别面料编码': '② 识别面料编码',
  '上传并开始识别': '上传并开始识别',
  '上传整本样册 PDF：系统自动拆页并按「面料编码」与表格逐行匹配；上限1G，大文件走流式上传不占内存': '上传整本样册 PDF：系统自动拆页并按「面料编码」与表格逐行匹配；上限1G，大文件走流式上传不占内存',
  '下一步：生成预览': '下一步：生成预览',
  '不选=全部品牌': '不选=全部品牌',
  '不选=所选品牌下全部样本册': '不选=所选品牌下全部样本册',
  '仅反面已设置': '仅反面已设置',
  '仅正面已设置': '仅正面已设置',
  '会话已过期': '会话已过期',
  '全不选': '全不选',
  '全选': '全选',
  '全部品牌': '全部品牌',
  '务必先完成识别再裁剪：裁剪只是给面料图取图用，标签须在裁剪前就被识别到': '务必先完成识别再裁剪：裁剪只是给面料图取图用，标签须在裁剪前就被识别到',
  '反面': '反面',
  '只选中间页(跳过首尾)': '只选中间页(跳过首尾)',
  '品牌（可多选）': '品牌（可多选）',
  '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；框锁定为正方形，按百分比应用到本册所有': '在图片上按住鼠标拖框，圈出布料区域（裁掉标签/反光/桌角等）；框锁定为正方形，按百分比应用到本册所有',
  '处理中，请勿刷新或关闭页面': '处理中，请勿刷新或关闭页面',
  '尚未框选': '尚未框选',
  '尚未识别到任何面料编码，请先完成识别': '尚未识别到任何面料编码，请先完成识别',
  '已上传': '已上传',
  '已恢复上次导入，可继续识别或裁剪': '已恢复上次导入，可继续识别或裁剪',
  '已按标准裁剪': '已按标准裁剪',
  '已放弃该会话，页图已清理': '已放弃该会话，页图已清理',
  '已识别': '已识别',
  '已识别出': '已识别出',
  '应用': '应用',
  '应用到本册': '应用到本册',
  '开始识别选中页': '开始识别选中页',
  '拆分样册页面': '拆分样册页面',
  '拆页完成，共': '拆页完成，共',
  '拆页等待超时，可稍后从「继续上次导入」恢复': '拆页等待超时，可稍后从「继续上次导入」恢复',
  '放弃': '放弃',
  '放弃该会话？已拆好的页图会被删除': '放弃该会话？已拆好的页图会被删除',
  '未识别到': '未识别到',
  '未识别到的页不会参与匹配（该页图不会被使用）。可手工补填编码，或点「重识别」重试——重试不需要重新上传 PDF。中途可随时离开，下次从「继续上次导入」恢复。': '未识别到的页不会参与匹配（该页图不会被使用）。可手工补填编码，或点「重识别」重试——重试不需要重新上传 PDF。中途可随时离开，下次从「继续上次导入」恢复。',
  '未识别到编码': '未识别到编码',
  '未识别到，可手工填写': '未识别到，可手工填写',
  '本样本册': '本样本册',
  '样本册（可多选，随品牌联动）': '样本册（可多选，随品牌联动）',
  '检测到未完成的导入会话': '检测到未完成的导入会话',
  '正面': '正面',
  '正面/反面均已设置': '正面/反面均已设置',
  '步骤：① 勾选面料页（默认已跳过首页封面/尾页）② 测试识别确认无误 ③ 整本识别 ④ 人工校对编码 ⑤ 设置裁剪区域（识别在前、裁剪在后）': '步骤：① 勾选面料页（默认已跳过首页封面/尾页）② 测试识别确认无误 ③ 整本识别 ④ 人工校对编码 ⑤ 设置裁剪区域（识别在前、裁剪在后）',
  '测试识别': '测试识别',
  '测试识别第': '测试识别第',
  '测试识别第 1 页': '测试识别第 1 页',
  '生成预览': '生成预览',
  '生成预览…': '生成预览…',
  '看原文': '看原文',
  '第': '第',
  '等': '等',
  '继续上次导入': '继续上次导入',
  '范围': '范围',
  '裁剪效果预览': '裁剪效果预览',
  '裁剪预览·反面': '裁剪预览·反面',
  '裁剪预览·正面': '裁剪预览·正面',
  '解析出的面料编码': '解析出的面料编码',
  '识别与裁剪': '识别与裁剪',
  '识别到的面料编码': '识别到的面料编码',
  '识别完成：命中': '识别完成：命中',
  '识别超时，可重试': '识别超时，可重试',
  '请先上传样册 PDF': '请先上传样册 PDF',
  '请先勾选要识别的页面': '请先勾选要识别的页面',
  '请先完成识别，再设置裁剪区域（识别在前、裁剪在后，否则会把标签一起裁掉导致识别为空）': '请先完成识别，再设置裁剪区域（识别在前、裁剪在后，否则会把标签一起裁掉导致识别为空）',
  '请先选择品牌或样本册': '请先选择品牌或样本册',
  '请选择品牌或样本册': '请选择品牌或样本册',
  '请选择季节': '请选择季节',
  '超时/失败': '超时/失败',
  '重识别': '重识别',
  '页的编码': '页的编码',
  '页码': '页码',
  '页识别超时/失败，可点该行「重识别」重试，无需重新上传': '页识别超时/失败，可点该行「重识别」重试，无需重新上传',
  '页，已自动跳过首页/尾页': '页，已自动跳过首页/尾页',
  '预览确认入库': '预览确认入库',
  '（无文字）': '（无文字）',
  // ===== 2026-09-12 样册导入 5 步流程 / Excel 独立 tab / 图文比对 =====
  'Excel 清单': 'Excel 清单',
  'Excel导入模式': 'Excel导入模式',
  'Excel清单(选填)': 'Excel清单(选填)',
  'Excel清单导入': 'Excel清单导入',
  'OCR 原始文字': 'OCR 原始文字',
  'PDF：整本样册，自动拆页；ZIP：每张图一页（文件名=面料编码）。上限1G，大文件走流式上传': 'PDF：整本样册，自动拆页；ZIP：每张图一页（文件名=面料编码）。上限1G，大文件走流式上传',
  '【更新】从下拉里点选已有册子；【新建】直接输入一个不存在的名称': '【更新】从下拉里点选已有册子；【新建】直接输入一个不存在的名称',
  '上传图片包…': '上传图片包…',
  '上传并确认页图': '上传并确认页图',
  '下一步：写入': '下一步：写入',
  '不勾选时：只更新已有面料，其余跳过': '不勾选时：只更新已有面料，其余跳过',
  '仅更新已有面料（库中没有的跳过）': '仅更新已有面料（库中没有的跳过）',
  '价格档按零剪价自动重算；若导致跨档，必须逐条核对并勾选确认后才会写入': '价格档按零剪价自动重算；若导致跨档，必须逐条核对并勾选确认后才会写入',
  '保存并退出': '保存并退出',
  '允许新增：Excel 里有、库里没有的面料编码，自动按本样本册新建': '允许新增：Excel 里有、库里没有的面料编码，自动按本样本册新建',
  '先选「标签在正面还是反面」——反面时，每页面料的编码印在下一页顶部，系统会去下一页取；再确认下方要识别的页': '先选「标签在正面还是反面」——反面时，每页面料的编码印在下一页顶部，系统会去下一页取；再确认下方要识别的页',
  '参数取自第': '参数取自第',
  '反面（编码在下一页顶部）': '反面（编码在下一页顶部）',
  '可随时离开，下次从「继续上次导入」恢复': '可随时离开，下次从「继续上次导入」恢复',
  '图文比对': '图文比对',
  '图片已换，但重识别超时，可点「重识别」重试': '图片已换，但重识别超时，可点「重识别」重试',
  '如这些是新品面料，请勾选上方「允许新增」后重新预览': '如这些是新品面料，请勾选上方「允许新增」后重新预览',
  '导入方式': '导入方式',
  '尚未识别到任何面料编码，请先完成识别或手工补填': '尚未识别到任何面料编码，请先完成识别或手工补填',
  '左列是这一行的面料图；右侧参数可直接改。整行展开可编辑全部字段。缺编码的行可手工补填或点「重识别」。': '左列是这一行的面料图；右侧参数可直接改。整行展开可编辑全部字段。缺编码的行可手工补填或点「重识别」。',
  '已上传，请确认页图与标签位置': '已上传，请确认页图与标签位置',
  '已恢复上次导入进度': '已恢复上次导入进度',
  '已放弃该会话': '已放弃该会话',
  '已暂存': '已暂存',
  '已自动勾选': '已自动勾选',
  '已重识别第': '已重识别第',
  '库中没有的面料编码自动新增（不勾则仅更新已有）': '库中没有的面料编码自动新增（不勾则仅更新已有）',
  '当前：仅更新已有面料': '当前：仅更新已有面料',
  '待人工': '待人工',
  '按标签位置重选': '按标签位置重选',
  '按面料编码更新已有记录：只改 Excel 里有值的字段，库中不存在的编码默认跳过': '按面料编码更新已有记录：只改 Excel 里有值的字段，库中不存在的编码默认跳过',
  '换图失败': '换图失败',
  '更新 + 新增（库中没有的面料自动新建）': '更新 + 新增（库中没有的面料自动新建）',
  '未暂存': '未暂存',
  '本次将执行：以 PDF 识别结果为准（识别 → 人工比对 → 写入并保存图片）': '本次将执行：以 PDF 识别结果为准（识别 → 人工比对 → 写入并保存图片）',
  '本次将执行：只按 Excel 更新字段，不涉及图片': '本次将执行：只按 Excel 更新字段，不涉及图片',
  '本次将执行：按 Excel 更新字段，并用 PDF 页图按面料编码匹配图片': '本次将执行：按 Excel 更新字段，并用 PDF 页图按面料编码匹配图片',
  '条？': '条？',
  '标签在': '标签在',
  '样册PDF 或 图片包': '样册PDF 或 图片包',
  '模板': '模板',
  '正在识别面料标签…': '正在识别面料标签…',
  '正面（编码在本页）': '正面（编码在本页）',
  '生成预览失败': '生成预览失败',
  '目标样册': '目标样册',
  '看大图': '看大图',
  '确认写入这': '确认写入这',
  '自动识别': '自动识别',
  '行因「仅更新」被跳过（库中无此编码）': '行因「仅更新」被跳过（库中无此编码）',
  '行有编码': '行有编码',
  '裁剪预览': '裁剪预览',
  '识别到的参数（点右侧「上一步」可回去修改）': '识别到的参数（点右侧「上一步」可回去修改）',
  '识别结果': '识别结果',
  '该行没有来源页，请手工填写': '该行没有来源页，请手工填写',
  '请至少上传 样册PDF/图片包 或 Excel 清单': '请至少上传 样册PDF/图片包 或 Excel 清单',
  '请选择 Excel 文件': '请选择 Excel 文件',
  '请选择样本册': '请选择样本册',
  '选择PDF或ZIP': '选择PDF或ZIP',
  '选择样本册': '选择样本册',
  '配 Excel 时：按面料编码把 PDF 页图匹配到 Excel 行；不配 Excel 时：完全以 PDF 识别结果为准': '配 Excel 时：按面料编码把 PDF 页图匹配到 Excel 行；不配 Excel 时：完全以 PDF 识别结果为准',
  '重识别失败': '重识别失败',
  '面料样册批量上架 / 季度调价': '面料样册批量上架 / 季度调价',
  '页图片已替换，正在重新识别': '页图片已替换，正在重新识别',
  '页图确认': '页图确认',
  '页识别超时/失败，可点该行「重识别」重试': '页识别超时/失败，可点该行「重识别」重试',
  '页，可手动增减': '页，可手动增减',
  // ===== 2026-09-12 价格档跨档涨跌标记 =====
  '档位变动': '档位变动',
  '涨': '涨',
  '跌': '跌',
  '变动日期': '变动日期',
  // ===== 2026-09-12 Excel 清单导入：样本册/品牌选填 =====
  '样本册(选填)': '样本册(选填)',
  '不选=只按面料编码更新': '不选=只按面料编码更新',
  '不选=取表格里的品牌': '不选=取表格里的品牌',
  '勾选「允许新增」时必须选择样本册（新增的面料要归属到某本册子）': '勾选「允许新增」时必须选择样本册（新增的面料要归属到某本册子）',
  '样本册和品牌都可以不选——表格里已有品牌列时会自动取用。价格档按零剪价自动重算；若导致跨档，必须逐条核对并勾选确认后才会写入': '样本册和品牌都可以不选——表格里已有品牌列时会自动取用。价格档按零剪价自动重算；若导致跨档，必须逐条核对并勾选确认后才会写入',
  // ===== 2026-09-12 Excel 未识别表头提示 =====
  '表格里有': '表格里有',
  '列没被识别，这些列的内容不会被导入': '列没被识别，这些列的内容不会被导入',
  '请对照模板使用规范表头（例如「克重」「幅宽(cm)」）': '请对照模板使用规范表头（例如「克重」「幅宽(cm)」）',
  // ===== 2026-09-13 预览表列级「不导入」勾选 =====
  '取消勾选后，这一列不会写入数据库（也不会覆盖库中已有的值）': '取消勾选后，这一列不会写入数据库（也不会覆盖库中已有的值）',
  '列已取消勾选，不会写入数据库：': '列已取消勾选，不会写入数据库：',
  '全部恢复': '全部恢复',

  // ===== 2026-09-12 不导入勾选 + 裁剪正方形修复 =====
  '上一页': '上一页',
  '下一页': '下一页',
  '不导入': '不导入',
  '全部不导入': '全部不导入',
  '全部导入': '全部导入',
  '务必先完成识别再裁剪：裁剪只是给面料图取图，标签要在裁剪之前就被识别到': '务必先完成识别再裁剪：裁剪只是给面料图取图，标签要在裁剪之前就被识别到',
  '参照页': '参照页',
  '在图片上按住鼠标拖框，圈出布料区域（去掉标签/反光/桌角）。框锁定为正方形，按比例套用到本册每一页': '在图片上按住鼠标拖框，圈出布料区域（去掉标签/反光/桌角）。框锁定为正方形，按比例套用到本册每一页',
  '将导入': '将导入',
  '左上角': '左上角',
  '左侧为原图取景预览；点「应用并裁剪」后可看到实际裁剪结果': '左侧为原图取景预览；点「应用并裁剪」后可看到实际裁剪结果',
  '左列是这一行的面料图；右侧参数可直接改。整行展开可编辑全部字段。封面页/识别错的行可勾「不导入」，不会进库也不会删数据。': '左列是这一行的面料图；右侧参数可直接改。整行展开可编辑全部字段。封面页/识别错的行可勾「不导入」，不会进库也不会删数据。',
  '已排除': '已排除',
  '已裁剪，右侧为裁剪结果': '已裁剪，右侧为裁剪结果',
  '应用并裁剪': '应用并裁剪',
  '当前已保存的标准会应用到本册对应页面': '当前已保存的标准会应用到本册对应页面',
  '当前已保存的标准会应用到本册每一页': '当前已保存的标准会应用到本册每一页',
  '框选边长': '框选边长',
  '正方形': '正方形',
  '没有可导入的行：请先完成识别、填写编码，或取消「不导入」的勾选': '没有可导入的行：请先完成识别、填写编码，或取消「不导入」的勾选',
  '裁剪结果（正方形 1:1）': '裁剪结果（正方形 1:1）',
  '设置截取标准（拖框圈出布料区，应用到整本）': '设置截取标准（拖框圈出布料区，应用到整本）',
  '请先在图片上框选布料区域': '请先在图片上框选布料区域',
  // ===== 2026-09-12 向导数据改为 state 承载 =====
  '请先回第①步选择品牌并填写样册名称': '请先回第①步选择品牌并填写样册名称',
  // ===== 2026-09-13 撤回推送按工厂处理 =====
  '确认撤回推送吗？有对接接口的工厂会同时删除工厂端订单；无接口的工厂只回滚本地状态，需你到工厂后台手动删除。': '确认撤回推送吗？有对接接口的工厂会同时删除工厂端订单；无接口的工厂只回滚本地状态，需你到工厂后台手动删除。',
  // ===== 2026-09-14 个人资料+修改密码 =====
  '密码修改成功': '密码修改成功',
  '密码修改失败': '密码修改失败',
  '旧密码': '旧密码',
  '请输入旧密码': '请输入旧密码',
  '请输入新密码': '请输入新密码',
  '确认新密码': '确认新密码',
  '请再次输入新密码': '请再次输入新密码',
  '入库日期': '入库日期',
  '出库日期': '出库日期',
  '入库运单号': '入库运单号',
  '出库运单号': '出库运单号',
  '查看发票详情': '查看发票详情',
  '物流信息': '物流信息',
  '出入库日期': '出入库日期',
  '暂无': '暂无',
  // ===== 2026-09-21 客户列表负责人 =====
  '当前负责人': '当前负责人',
  // ===== 2026-09-21 i18n 补全：英文界面原先回退显示中文的 749 个 key =====
  '其它订单': '其它订单',
  '复制当前品类（成衣尺寸—>审核尺寸)': '复制当前品类（成衣尺寸—>审核尺寸)',
  '不推送工厂，点击推送': '不推送工厂，点击推送',
  '待付': '待付',
  '推送工厂，点击取消': '推送工厂，点击取消',
  '个人提成': '个人提成',
  '公积金': '公积金',
  '合作折扣': '合作折扣',
  '品类/面料': '品类/面料',
  '提成(USD)': '提成(USD)',
  '补货中': '补货中',
  '关联失败': '关联失败',
  '切换为自动计算': '切换为自动计算',
  '初始密码': '初始密码',
  '合并失败': '合并失败',
  '团队提成': '团队提成',
  '客户等级': '客户等级',
  '岗位': '岗位',
  '应发': '应发',
  '应扣': '应扣',
  '手动输入手续费': '手动输入手续费',
  '拆分发票': '拆分发票',
  '拆分失败': '拆分失败',
  '物料单号': '物料单号',
  '确认关联': '确认关联',
  '西服': '西服',
  '预估总金额': '预估总金额',
  '个人业绩': '个人业绩',
  '个人业绩(USD)': '个人业绩(USD)',
  '以上': '以上',
  '元/月': '元/月',
  '入职时间': '入职时间',
  '养老': '养老',
  '出勤': '出勤',
  '创建用户失败': '创建用户失败',
  '创建门店失败': '创建门店失败',
  '医疗': '医疗',
  '团队业绩': '团队业绩',
  '失业': '失业',
  '客供面料（待采）': '客供面料（待采）',
  '比例': '比例',
  '系统登录账号（自动生成）': '系统登录账号（自动生成）',
  '缺勤扣款': '缺勤扣款',
  '联系人姓名': '联系人姓名',
  '英文名（可选）': '英文名（可选）',
  '请先生成采购链接': '请先生成采购链接',
  '跟单/行政': '跟单/行政',
  '转交失败': '转交失败',
  'API密钥': 'API密钥',
  'HP工艺项': 'HP工艺项',
  'Webhook配置': 'Webhook配置',
  '上衣': '上衣',
  '业务员账号/姓名': '业务员账号/姓名',
  '业务提成': '业务提成',
  '个留在新发票': '个留在新发票',
  '个税': '个税',
  '个订单关联到本发票？关联后将重算发票金额与未付金额。': '个订单关联到本发票？关联后将重算发票金额与未付金额。',
  '个订单将拆出，剩余': '个订单将拆出，剩余',
  '主发票': '主发票',
  '五险一金缴纳比例': '五险一金缴纳比例',
  '产品名称': '产品名称',
  '仍要删除': '仍要删除',
  '供应商名称': '供应商名称',
  '供应商地址': '供应商地址',
  '保存折扣失败': '保存折扣失败',
  '入账状态': '入账状态',
  '共 {n} 条': '共 {n} 条',
  '关联成功': '关联成功',
  '其它提成': '其它提成',
  '再次推送将创建新的工厂单号，并覆盖原始单号！！': '再次推送将创建新的工厂单号，并覆盖原始单号！！',
  '删除后不可恢复。': '删除后不可恢复。',
  '删除后订单将移入回收站': '删除后订单将移入回收站',
  '勾选要拆分出去的订单（至少1个，且须保留至少1个）。拆分后原发票删除，生成两张新发票。': '勾选要拆分出去的订单（至少1个，且须保留至少1个）。拆分后原发票删除，生成两张新发票。',
  '反查失败': '反查失败',
  '发放失败': '发放失败',
  '发现的问题': '发现的问题',
  '发票合并成功': '发票合并成功',
  '发票总金额': '发票总金额',
  '发票拆分成功': '发票拆分成功',
  '只能上传图片': '只能上传图片',
  '品类费用': '品类费用',
  '团队业绩汇总': '团队业绩汇总',
  '备忘词': '备忘词',
  '备注信息，可对门店客户也可对内显示': '备注信息，可对门店客户也可对内显示',
  '备注：': '备注：',
  '如：面料-VBC蓝色净色': '如：面料-VBC蓝色净色',
  '客供纽扣（待采）': '客供纽扣（待采）',
  '客供里布（待采）': '客供里布（待采）',
  '小计(USD)': '小计(USD)',
  '工资条': '工资条',
  '已付': '已付',
  '已入账': '已入账',
  '已入账发票明细': '已入账发票明细',
  '已入账总额': '已入账总额',
  '提成基数总额': '提成基数总额',
  '已关联订单': '已关联订单',
  '已分发': '已分发',
  '已推送过，仅管理员可重复推送': '已推送过，仅管理员可重复推送',
  '已移除': '已移除',
  '应发小计': '应发小计',
  '应扣小计': '应扣小计',
  '建议改为「禁用」，保留映射数据备查。': '建议改为「禁用」，保留映射数据备查。',
  '当前工厂单号': '当前工厂单号',
  '彻底删除': '彻底删除',
  '待分发': '待分发',
  '成衣订单销售提成': '成衣订单销售提成',
  '我方选项名称': '我方选项名称',
  '我方选项编码': '我方选项编码',
  '我的档案': '我的档案',
  '手机号': '手机号',
  '推送 Key': '推送 Key',
  '推送时间': '推送时间',
  '推送模式': '推送模式',
  '推送部位': '推送部位',
  '搜索订单号 / 客户姓名': '搜索订单号 / 客户姓名',
  '数据异常，请财务/系统管理员人工修复': '数据异常，请财务/系统管理员人工修复',
  '新增可关联订单': '新增可关联订单',
  '新增提成规则': '新增提成规则',
  '暂无可添加的订单': '暂无可添加的订单',
  '最多10张': '最多10张',
  '最多10张图片': '最多10张图片',
  '未入账': '未入账',
  '本月无已入账订单': '本月无已入账订单',
  '模版名称': '模版名称',
  '添加其它类型订单': '添加其它类型订单',
  '添加其它订单': '添加其它订单',
  '点击可预览': '点击可预览',
  '物料供应商（可选）': '物料供应商（可选）',
  '物流费为必填项，不能为0': '物流费为必填项，不能为0',
  '确认再次推送': '确认再次推送',
  '确认再次推送？': '确认再次推送？',
  '确认合并': '确认合并',
  '确认将选中的': '确认将选中的',
  '确认拆分': '确认拆分',
  '确认转交': '确认转交',
  '禁用（推荐）': '禁用（推荐）',
  '签收失败': '签收失败',
  '管理我方设计选项与工厂工艺编码的映射关系': '管理我方设计选项与工厂工艺编码的映射关系',
  '系统默认语言': '系统默认语言',
  '结算月': '结算月',
  '编辑档案': '编辑档案',
  '缺勤天数': '缺勤天数',
  '耗时(ms)': '耗时(ms)',
  '至少保留一个订单在原发票中': '至少保留一个订单在原发票中',
  '设计选项加载中，网络异常或加载延长，请稍后！': '设计选项加载中，网络异常或加载延长，请稍后！',
  '请至少选择一个要拆出的订单': '请至少选择一个要拆出的订单',
  '请输入邮箱': '请输入邮箱',
  '请选择一张作为主发票（保留其发票编号），其余发票将被合并后删除。': '请选择一张作为主发票（保留其发票编号），其余发票将被合并后删除。',
  '请选择业务员': '请选择业务员',
  '请选择主发票': '请选择主发票',
  '请选择单位': '请选择单位',
  '请选择客户等级': '请选择客户等级',
  '请选择物料类别': '请选择物料类别',
  '超时时间(秒)': '超时时间(秒)',
  '身份证号': '身份证号',
  '转交后，新订单将自动归属新业务员；旧订单提成不受影响': '转交后，新订单将自动归属新业务员；旧订单提成不受影响',
  '转交门店': '转交门店',
  '选择业务员': '选择业务员',
  '选择新业务员': '选择新业务员',
  '部分订单关联失败': '部分订单关联失败',
  '采购日期止': '采购日期止',
  '采购日期起': '采购日期起',
  '采购申请日期止': '采购申请日期止',
  '采购申请日期起': '采购申请日期起',
  '重新计算': '重新计算',
  '重置密码 / 绑定业务员': '重置密码 / 绑定业务员',
  '金额(USD)': '金额(USD)',
  '发票金额(USD)': '发票金额(USD)',
  '提成基数(USD)': '提成基数(USD)',
  '门店号': '门店号',
  '门店客户账号创建成功，登录账号：': '门店客户账号创建成功，登录账号：',
  '门店转交成功': '门店转交成功',
  '验证失败': '验证失败',
  ' + 其他成员 $': ' + 其他成员 $',
  '0=自动': '0=自动',
  '15 天': '15 天',
  '30 天': '30 天',
  '60 天': '60 天',
  '7 天': '7 天',
  '90 天': '90 天',
  'API地址': 'API地址',
  'API基础地址': 'API基础地址',
  'API对接配置': 'API对接配置',
  'API秘钥/密码': 'API秘钥/密码',
  'CMT 加工费': 'CMT 加工费',
  'HP尺寸调整映射（JSON）': 'HP尺寸调整映射（JSON）',
  'measurements 中的字段名，为空时使用字段代码': 'measurements 中的字段名，为空时使用字段代码',
  '· 与业务员相同阶梯': '· 与业务员相同阶梯',
  '· 全员业绩合计用于计算团队管理提成': '· 全员业绩合计用于计算团队管理提成',
  '一键全选': '一键全选',
  '一键勾选/取消全部待付订单': '一键勾选/取消全部待付订单',
  '一键发放该月工资给所有人': '一键发放该月工资给所有人',
  '一键设置所有人基数': '一键设置所有人基数',
  '三件套': '三件套',
  '上传中...': '上传中...',
  '上月暂无数据': '上月暂无数据',
  '上海最低基数参考（实时按左侧参数计算）：': '上海最低基数参考（实时按左侧参数计算）：',
  '下单日期止': '下单日期止',
  '下单日期起': '下单日期起',
  '下摆围': '下摆围',
  '下载图片': '下载图片',
  '不匹配字段': '不匹配字段',
  '业务员提成计算': '业务员提成计算',
  '业务员账号名（绑定到该业务员名下）': '业务员账号名（绑定到该业务员名下）',
  '两件套': '两件套',
  '个人': '个人',
  '个人业绩覆盖(USD)': '个人业绩覆盖(USD)',
  '个人合计扣减': '个人合计扣减',
  '个人扣减 = 基数 × 对应比例，修改基数后自动计算': '个人扣减 = 基数 × 对应比例，修改基数后自动计算',
  '个人承担': '个人承担',
  '个人提成与业务员相同（所有订单类型统一计算）；团队管理提成基于全团队总销售额（含本人）超额累进': '个人提成与业务员相同（所有订单类型统一计算）；团队管理提成基于全团队总销售额（含本人）超额累进',
  '个字段不匹配': '个字段不匹配',
  '个字段匹配': '个字段匹配',
  '个性加价成本': '个性加价成本',
  '个税 = (应发 - 社保 - 公积金 - 起征点) × 税率': '个税 = (应发 - 社保 - 公积金 - 起征点) × 税率',
  '个税社保参数（上海）': '个税社保参数（上海）',
  '个订单工厂': '个订单工厂',
  '个采购单修改物料供应商': '个采购单修改物料供应商',
  '个采购单关联订单的工厂': '个采购单关联订单的工厂',
  '个门店': '个门店',
  '中文翻译': '中文翻译',
  '主索引': '主索引',
  '主色调': '主色调',
  '主题模式': '主题模式',
  '主题配置说明': '主题配置说明',
  '互斥冲突 / 自动改动记录': '互斥冲突 / 自动改动记录',
  '仅可添加同门店、未开票、未付款且已初审（含）以上的订单。运费/关税/特殊设计费/折扣默认0，可在此编辑为准确值，手续费自动计算；勾选或点“添加”即带着这些费用并入上方关联订单。': '仅可添加同门店、未开票、未付款且已初审（含）以上的订单。运费/关税/特殊设计费/折扣默认0，可在此编辑为准确值，手续费自动计算；勾选或点“添加”即带着这些费用并入上方关联订单。',
  '仅失败': '仅失败',
  '仅成功': '仅成功',
  '仅用于员工提成和工资USD→CNY换算，不影响产品定价': '仅用于员工提成和工资USD→CNY换算，不影响产品定价',
  '仅用于销售价格表计算，独立于定价汇率和薪酬汇率': '仅用于销售价格表计算，独立于定价汇率和薪酬汇率',
  '今日本人新增': '今日本人新增',
  '从': '从',
  '从设计项选择（可选）': '从设计项选择（可选）',
  '付款时间': '付款时间',
  '价格档区间': '价格档区间',
  '供应商单号': '供应商单号',
  '侧边栏导航': '侧边栏导航',
  '保存工资条': '保存工资条',
  '保存比例': '保存比例',
  '修改工厂供应商': '修改工厂供应商',
  '修改工厂失败': '修改工厂失败',
  '修改汇率将影响薪酬计算，确认保存？': '修改汇率将影响薪酬计算，确认保存？',
  '修改物料供应商': '修改物料供应商',
  '允许用户切换语言': '允许用户切换语言',
  '入账业绩(USD)': '入账业绩(USD)',
  '全勤扣减': '全勤扣减',
  '全员工资明细': '全员工资明细',
  '全局定价汇率（CNY/USD）': '全局定价汇率（CNY/USD）',
  '全部字段匹配': '全部字段匹配',
  '全部季节': '全部季节',
  '全部性别': '全部性别',
  '全部操作': '全部操作',
  '全部模块': '全部模块',
  '全部结果': '全部结果',
  '公司': '公司',
  '公司合计承担': '公司合计承担',
  '公司承担': '公司承担',
  '公积金基数': '公积金基数',
  '公积金扣缴': '公积金扣缴',
  '关联发票号': '关联发票号',
  '关键指标': '关键指标',
  '其它订单已添加': '其它订单已添加',
  '其它费用 (USD)': '其它费用 (USD)',
  '养老保险': '养老保险',
  '出让方': '出让方',
  '出让方（请假人）': '出让方（请假人）',
  '分享链接已生成，外部客户无需登录即可查看': '分享链接已生成，外部客户无需登录即可查看',
  '分摊金额': '分摊金额',
  '划转管理': '划转管理',
  '删除?': '删除?',
  '删除后可在回收站中恢复': '删除后可在回收站中恢复',
  '利润贡献率': '利润贡献率',
  '到': '到',
  '加工厂': '加工厂',
  '加工商/单号': '加工商/单号',
  '加载历史失败': '加载历史失败',
  '加载历史报价单失败': '加载历史报价单失败',
  '加载基础价格表失败': '加载基础价格表失败',
  '加载备忘词失败': '加载备忘词失败',
  '加载失败，请稍后重试': '加载失败，请稍后重试',
  '加载详情失败': '加载详情失败',
  '加载门店列表失败': '加载门店列表失败',
  '包含品类列': '包含品类列',
  '包含工艺': '包含工艺',
  '医疗保险': '医疗保险',
  '单位：CNY': '单位：CNY',
  '即将修改': '即将修改',
  '卷': '卷',
  '厂单': '厂单',
  '原始返回 / Raw response': '原始返回 / Raw response',
  '双': '双',
  '反查工厂': '反查工厂',
  '发票创建日期': '发票创建日期',
  '发票已付总额': '发票已付总额',
  '发货单号：': '发货单号：',
  '发货地': '发货地',
  '发货通知Webhook': '发货通知Webhook',
  '取消入账': '取消入账',
  '受让方': '受让方',
  '受让方（代管人）': '受让方（代管人）',
  '只有未完成初审、已驳回或已取消的订单才能删除': '只有未完成初审、已驳回或已取消的订单才能删除',
  '可添加同门店、已初审（含）以上的西服订单（不限付款状态）；或添加无订单号的其它类型订单（如零散费用等）。运费/关税/折扣默0，可编辑，手续费自动计算。': '可添加同门店、已初审（含）以上的西服订单（不限付款状态）；或添加无订单号的其它类型订单（如零散费用等）。运费/关税/折扣默0，可编辑，手续费自动计算。',
  '可用变量': '可用变量',
  '可直接 Ctrl+V 粘贴图片': '可直接 Ctrl+V 粘贴图片',
  '可补充备注信息': '可补充备注信息',
  '后浪': '后浪',
  '启用API对接': '启用API对接',
  '启用API日志': '启用API日志',
  '启用对接': '启用对接',
  '启用（激活后账号才能登录）': '启用（激活后账号才能登录）',
  '品名': '品名',
  '品类利润分析': '品类利润分析',
  '回填审核成衣尺寸': '回填审核成衣尺寸',
  '团队业绩覆盖(USD)': '团队业绩覆盖(USD)',
  '团队合计（': '团队合计（',
  '团队成员销售业绩': '团队成员销售业绩',
  '固定$/单': '固定$/单',
  '固定头部': '固定头部',
  '固定金额($)': '固定金额($)',
  '图片不能超过10MB': '图片不能超过10MB',
  '图片已下载到本地': '图片已下载到本地',
  '圆角大小': '圆角大小',
  '基础价格表（价格档×工艺×品类）': '基础价格表（价格档×工艺×品类）',
  '备忘记录': '备忘记录',
  '备忘词总数不能超过20个': '备忘词总数不能超过20个',
  '备注（交代事项，可选，保存到该合并采购单）': '备注（交代事项，可选，保存到该合并采购单）',
  '备注（交代事项，可选，保存到该采购单）': '备注（交代事项，可选，保存到该采购单）',
  '备注（可选）': '备注（可选）',
  '备注，如：产假/请假一周': '备注，如：产假/请假一周',
  '复制图片': '复制图片',
  '复用全部': '复用全部',
  '大 (16px)': '大 (16px)',
  '失业保险': '失业保险',
  '失败信息': '失败信息',
  '套': '套',
  '如 0.85 表示 8.5 折': '如 0.85 表示 8.5 折',
  '如 FAC-HP，JD 留空': '如 FAC-HP，JD 留空',
  '如: Church\'s, John Lobb': '如: Church\\\'s, John Lobb',
  '如: F001': '如: F001',
  '如: order.status.pending': '如: order.status.pending',
  '如: order_confirmation_email': '如: order_confirmation_email',
  '如: salesperson': '如: salesperson',
  '如：Front Length，用于英文界面/工艺单/发票展示': '如：Front Length，用于英文界面/工艺单/发票展示',
  '如：jacket_front_length，空=使用字段代码': '如：jacket_front_length，空=使用字段代码',
  '如：里布编号/面料编号': '如：里布编号/面料编号',
  '字体大小': '字体大小',
  '字段': '字段',
  '实发': '实发',
  '实发合计': '实发合计',
  '实发工资明细': '实发工资明细',
  '客户已创建': '客户已创建',
  '密码错误，还可尝试__n__次': '密码错误，还可尝试__n__次',
  '导出 Excel 价格表': '导出 Excel 价格表',
  '导出PNG并复制': '导出PNG并复制',
  '导出工艺单': '导出工艺单',
  '导出模式': '导出模式',
  '导出洗唛': '导出洗唛',
  '导出采购图片': '导出采购图片',
  '将使用当前筛选条件（品牌、样本册、价格档、关键词）导出数据': '将使用当前筛选条件（品牌、样本册、价格档、关键词）导出数据',
  '将本品类的成衣尺寸覆盖到审核成衣尺寸（推送尺寸），请确认无误后继续。': '将本品类的成衣尺寸覆盖到审核成衣尺寸（推送尺寸），请确认无误后继续。',
  '将清除该员工该月的手工编辑（业绩、提成、社保、公积金、个税、缺勤），重新按发票记录与配置自动计算，是否继续？': '将清除该员工该月的手工编辑（业绩、提成、社保、公积金、个税、缺勤），重新按发票记录与配置自动计算，是否继续？',
  '小 (12px)': '小 (12px)',
  '尖角': '尖角',
  '工伤': '工伤',
  '工伤+生育': '工伤+生育',
  '工伤保险': '工伤保险',
  '工作汇总工资条的社保/公积金/个税计算基数与比例；缴费基数默认按员工实际工资总额（可在工资条中单独修改），低于下限按下限、高于上限按上限': '工作汇总工资条的社保/公积金/个税计算基数与比例；缴费基数默认按员工实际工资总额（可在工资条中单独修改），低于下限按下限、高于上限按上限',
  '工厂API地址': '工厂API地址',
  '工厂API配置': '工厂API配置',
  '工厂单号/工厂供应商': '工厂单号/工厂供应商',
  '工厂单号：': '工厂单号：',
  '工厂反查结果': '工厂反查结果',
  '工厂地址': '工厂地址',
  '工厂工费对账与结算管理': '工厂工费对账与结算管理',
  '工厂接口配置': '工厂接口配置',
  '工厂编码': '工厂编码',
  '工厂记录': '工厂记录',
  '工艺互斥验证未通过': '工艺互斥验证未通过',
  '工艺检测通过，可推送': '工艺检测通过，可推送',
  '工资条尚未分发，请耐心等待财务确认后查看': '工资条尚未分发，请耐心等待财务确认后查看',
  '已取消入账': '已取消入账',
  '已启用，账号可登录': '已启用，账号可登录',
  '已复制到剪贴板': '已复制到剪贴板',
  '已恢复上次编辑的未保存数据': '已恢复上次编辑的未保存数据',
  '已恢复历史报价单': '已恢复历史报价单',
  '已撤回推送': '已撤回推送',
  '已撤销': '已撤销',
  '已新增': '已新增',
  '已新增划转': '已新增划转',
  '已有': '已有',
  '已标记离职': '已标记离职',
  '已添加': '已添加',
  '已申请/待处理': '已申请/待处理',
  '已确认入账': '已确认入账',
  '已确认签收': '已确认签收',
  '已禁用该选项': '已禁用该选项',
  '已禁用，账号无法登录': '已禁用，账号无法登录',
  '已自动匹配': '已自动匹配',
  '已设为不推送工厂': '已设为不推送工厂',
  '已设为推送工厂': '已设为推送工厂',
  '已设置所有人基数为默认值': '已设置所有人基数为默认值',
  '已达': '已达',
  '已选记录数': '已选记录数',
  '已重新计算': '已重新计算',
  '布局方式': '布局方式',
  '布局配置': '布局配置',
  '平均完成率': '平均完成率',
  '平均客单价': '平均客单价',
  '平均订单毛利': '平均订单毛利',
  '平均订单金额': '平均订单金额',
  '平摆': '平摆',
  '序号': '序号',
  '应急手机号': '应急手机号',
  '开始(可选)': '开始(可选)',
  '当前': '当前',
  '彻底删除订单': '彻底删除订单',
  '待审订单': '待审订单',
  '总提成': '总提成',
  '总毛利': '总毛利',
  '总毛利率': '总毛利率',
  '总订单数': '总订单数',
  '总订单金额': '总订单金额',
  '总销售额': '总销售额',
  '成本构成': '成本构成',
  '成本率': '成本率',
  '我方名称': '我方名称',
  '我方字段': '我方字段',
  '我方工艺项': '我方工艺项',
  '我方工艺项关键词': '我方工艺项关键词',
  '我方工艺项编码': '我方工艺项编码',
  '我方推送': '我方推送',
  '我的工资条': '我的工资条',
  '我的采购': '我的采购',
  '截图': '截图',
  '所属业务员': '所属业务员',
  '手续费将自动计算（金额×4.5%+0.3），添加后发票总额自动更新，已付金额不变，未付金额相应增加。': '手续费将自动计算（金额×4.5%+0.3），添加后发票总额自动更新，已付金额不变，未付金额相应增加。',
  '打印模版': '打印模版',
  '批量修改工厂供应商': '批量修改工厂供应商',
  '批量修改物料供应商': '批量修改物料供应商',
  '批量申请要求所有采购单使用相同的工厂供应商，请重新选择': '批量申请要求所有采购单使用相同的工厂供应商，请重新选择',
  '批量申请要求所有采购单使用相同的物料供应商，请重新选择': '批量申请要求所有采购单使用相同的物料供应商，请重新选择',
  '批量转交': '批量转交',
  '批量转交门店': '批量转交门店',
  '找到': '找到',
  '技术人员': '技术人员',
  '技术经理': '技术经理',
  '报价单数据不存在': '报价单数据不存在',
  '报价单编号': '报价单编号',
  '报价汇率（CNY/USD）': '报价汇率（CNY/USD）',
  '按当月订单总金额分档计算，超额累进（所有订单类型统一计算）': '按当月订单总金额分档计算，超额累进（所有订单类型统一计算）',
  '按成衣订单总金额计算提成': '按成衣订单总金额计算提成',
  '按样本册/品牌分 Sheet（推荐）': '按样本册/品牌分 Sheet（推荐）',
  '按订单号查询': '按订单号查询',
  '按跟单订单总金额分档计算，技术人员/行政人员适用': '按跟单订单总金额分档计算，技术人员/行政人员适用',
  '按钮权限': '按钮权限',
  '推给工厂的尺寸 JSON': '推给工厂的尺寸 JSON',
  '推给工厂的工艺 JSON': '推给工厂的工艺 JSON',
  '推送到无API工厂': '推送到无API工厂',
  '推送到照片反馈': '推送到照片反馈',
  '推送日志': '推送日志',
  '推送详情': '推送详情',
  '提交补充': '提交补充',
  '提成值': '提成值',
  '提成划转管理': '提成划转管理',
  '提成合计明细': '提成合计明细',
  '提成结算': '提成结算',
  '搜索...': '搜索...',
  '搜索业务员': '搜索业务员',
  '搜索名称/联系人': '搜索名称/联系人',
  '搜索员工': '搜索员工',
  '搜索失败': '搜索失败',
  '搜索客户名/电话': '搜索客户名/电话',
  '搜索我方或HP编码、名称': '搜索我方或HP编码、名称',
  '搜索用户/详情': '搜索用户/详情',
  '搜索编号/名称/联系人': '搜索编号/名称/联系人',
  '搜索订单号/客户名': '搜索订单号/客户名',
  '搜索键名/内容': '搜索键名/内容',
  '搜索门店名称 / 门店编号...': '搜索门店名称 / 门店编号...',
  '撤回后将删除该采购记录，是否继续？': '撤回后将删除该采购记录，是否继续？',
  '撤回采购申请': '撤回采购申请',
  '撤销付款': '撤销付款',
  '撤销后将回滚订单已付金额、付款状态与门店余额，确定撤销该付款记录吗？': '撤销后将回滚订单已付金额、付款状态与门店余额，确定撤销该付款记录吗？',
  '支付通知Webhook': '支付通知Webhook',
  '支持拖拽图片到此处或 Ctrl+V 粘贴': '支持拖拽图片到此处或 Ctrl+V 粘贴',
  '整体毛利率': '整体毛利率',
  '整月': '整月',
  '斑马纹表格': '斑马纹表格',
  '新增用户成功': '新增用户成功',
  '新增门店用户': '新增门店用户',
  '新建发票': '新建发票',
  '新建采购': '新建采购',
  '新建采购申请': '新建采购申请',
  '无互斥工艺，工艺验证通过 / No conflicts, tech validation passed': '无互斥工艺，工艺验证通过 / No conflicts, tech validation passed',
  '时间段': '时间段',
  '暂无历史报价单': '暂无历史报价单',
  '暂无历史记录': '暂无历史记录',
  '暂无备忘词': '暂无备忘词',
  '暂无工厂API配置，请在工厂管理中添加工厂后配置': '暂无工厂API配置，请在工厂管理中添加工厂后配置',
  '暂无工资数据': '暂无工资数据',
  '暂无推送日志（推送订单后会自动记录）': '暂无推送日志（推送订单后会自动记录）',
  '暂无数据可导出': '暂无数据可导出',
  '暂无生产节点记录': '暂无生产节点记录',
  '暂无门店数据': '暂无门店数据',
  '更新单号': '更新单号',
  '更新物流单号': '更新物流单号',
  '最低($)': '最低($)',
  '最低基数': '最低基数',
  '最近消费日期': '最近消费日期',
  '最高($,空=无限)': '最高($,空=无限)',
  '月销售额区间': '月销售额区间',
  '有工艺互斥冲突，需修改后推送': '有工艺互斥冲突，需修改后推送',
  '有效期': '有效期',
  '有新生产状态，点击查看': '有新生产状态，点击查看',
  '未付款金额': '未付款金额',
  '未找到匹配订单': '未找到匹配订单',
  '未签收': '未签收',
  '未绑定': '未绑定',
  '未绑定角色': '未绑定角色',
  '未结算': '未结算',
  '本人销售额': '本人销售额',
  '本人销售额 $': '本人销售额 $',
  '本批次暂无采购单': '本批次暂无采购单',
  '本月暂无数据': '本月暂无数据',
  '本月暂无订单': '本月暂无订单',
  '本月累计订单': '本月累计订单',
  '本次推送未发现问题': '本次推送未发现问题',
  '条更新失败': '条更新失败',
  '条结果，请输入完整订单号精确匹配': '条结果，请输入完整订单号精确匹配',
  '标准 (14px)': '标准 (14px)',
  '标题客户/门店名称（选填，用于标题行）': '标题客户/门店名称（选填，用于标题行）',
  '格式：{"suit": "工艺项,工艺项,调整量/工艺项,工艺项,调整量"}': '格式：{"suit": "工艺项,工艺项,调整量/工艺项,工艺项,调整量"}',
  '检测到互斥工艺，请与客户确认后修改 / Conflicting craft items detected': '检测到互斥工艺，请与客户确认后修改 / Conflicting craft items detected',
  '模版代码': '模版代码',
  '模版内容': '模版内容',
  '模版内容，使用 {{variable}} 作为变量占位符': '模版内容，使用 {{variable}} 作为变量占位符',
  '模版预览': '模版预览',
  '次': '次',
  '次上限': '次上限',
  '正在生成图片...': '正在生成图片...',
  '每个订单行都必须绑定订单号，请先绑定或删除未绑定的行': '每个订单行都必须绑定订单号，请先绑定或删除未绑定的行',
  '每年7月更新基数（按上年月均工资申报，低于下限按下限7460）。修改后点"保存设置"生效。': '每年7月更新基数（按上年月均工资申报，低于下限按下限7460）。修改后点"保存设置"生效。',
  '比例已保存': '比例已保存',
  '毛利占比': '毛利占比',
  '永久删除不可恢复，确认删除该用户账号？': '永久删除不可恢复，确认删除该用户账号？',
  '永久删除不可恢复，确认删除该用户？': '永久删除不可恢复，确认删除该用户？',
  '永久删除不可恢复，确认删除该门店？': '永久删除不可恢复，确认删除该门店？',
  '没有可合并的其他发票': '没有可合并的其他发票',
  '没有可复制的成衣尺寸（业务员尚未填写成衣尺寸）': '没有可复制的成衣尺寸（业务员尚未填写成衣尺寸）',
  '没有待付款订单': '没有待付款订单',
  '浅色模式': '浅色模式',
  '消费总额': '消费总额',
  '消费者': '消费者',
  '消费者明细': '消费者明细',
  '深色模式': '深色模式',
  '混合布局': '混合布局',
  '点击选择/取消备忘词（最多20个）': '点击选择/取消备忘词（最多20个）',
  '照片反馈内容': '照片反馈内容',
  '照片反馈（已发给工厂）': '照片反馈（已发给工厂）',
  '物料采购': '物料采购',
  '环比': '环比',
  '现住址': '现住址',
  '生产工厂': '生产工厂',
  '生产进度': '生产进度',
  '生成日期': '生成日期',
  '生成采购单': '生成采购单',
  '生育': '生育',
  '生育保险': '生育保险',
  '用于面料成本→售价计算，修改将影响所有产品报价': '用于面料成本→售价计算，修改将影响所有产品报价',
  '用户名至少3位': '用户名至少3位',
  '留空则不修改密码': '留空则不修改密码',
  '留空则无需密码即可访问': '留空则无需密码即可访问',
  '登录用户名': '登录用户名',
  '省份': '省份',
  '短信模版': '短信模版',
  '确定撤销': '确定撤销',
  '确认入账': '确认入账',
  '确认删除消费者': '确认删除消费者',
  '确认删除该划转？': '确认删除该划转？',
  '确认删除该报价单?': '确认删除该报价单?',
  '确认发放': '确认发放',
  '确认后将发放该月工资给所有员工，员工即可在我的工资条中查看。': '确认后将发放该月工资给所有员工，员工即可在我的工资条中查看。',
  '确认启用该账号？启用后可登录': '确认启用该账号？启用后可登录',
  '确认密码': '确认密码',
  '确认将所有人社保/公积金基数设为默认值？': '确认将所有人社保/公积金基数设为默认值？',
  '确认将所选采购单标记为': '确认将所选采购单标记为',
  '确认将该员工标记为离职？离职后将不参与工资与提成计算。': '确认将该员工标记为离职？离职后将不参与工资与提成计算。',
  '确认恢复此客户？': '确认恢复此客户？',
  '确认撤回推送吗？本地的供应商与工厂单号一定会被清除，订单回到待发布。有对接接口的工厂会同时删除工厂端订单；删不掉的会提示你到工厂后台手动处理。': '确认撤回推送吗？本地的供应商与工厂单号一定会被清除，订单回到待发布。有对接接口的工厂会同时删除工厂端订单；删不掉的会提示你到工厂后台手动处理。',
  '确认撤回采购申请': '确认撤回采购申请',
  '确认禁用该账号？禁用后无法登录': '确认禁用该账号？禁用后无法登录',
  '确认移除该员工？': '确认移除该员工？',
  '确认签收': '确认签收',
  '确认编辑': '确认编辑',
  '确认要再次推送吗？': '确认要再次推送吗？',
  '确认覆盖': '确认覆盖',
  '社保': '社保',
  '社保个人合计': '社保个人合计',
  '社保公积金基数默认值来自系统配置': '社保公积金基数默认值来自系统配置',
  '社保基数': '社保基数',
  '社保扣缴': '社保扣缴',
  '禁用（禁用后无法登录）': '禁用（禁用后无法登录）',
  '签出成功': '签出成功',
  '签到': '签到',
  '签到成功': '签到成功',
  '签收': '签收',
  '签退': '签退',
  '简体中文': '简体中文',
  '管理系统全局参数（提成规则请前往主数据-提成规则配置）': '管理系统全局参数（提成规则请前往主数据-提成规则配置）',
  '籍贯': '籍贯',
  '系统API配置说明': '系统API配置说明',
  '系统操作日志': '系统操作日志',
  '紧凑': '紧凑',
  '紧凑模式': '紧凑模式',
  '组件样式': '组件样式',
  '组合分组ID': '组合分组ID',
  '经理本人': '经理本人',
  '经理本人 $': '经理本人 $',
  '绑定业务员': '绑定业务员',
  '绑定角色': '绑定角色',
  '绑定门店失败': '绑定门店失败',
  '结束(可选)': '结束(可选)',
  '继承自上衣': '继承自上衣',
  '编码模糊搜索': '编码模糊搜索',
  '编辑提成规则': '编辑提成规则',
  '编辑警告': '编辑警告',
  '耗料 & 价格': '耗料 & 价格',
  '联系方式': '联系方式',
  '自动带出该经理上月业绩与团队成员业绩记录': '自动带出该经理上月业绩与团队成员业绩记录',
  '自定义备忘词': '自定义备忘词',
  '自定义系统界面风格。修改后会立即生效，仅影响当前用户的显示效果。': '自定义系统界面风格。修改后会立即生效，仅影响当前用户的显示效果。',
  '英文工艺单': '英文工艺单',
  '菜单权限': '菜单权限',
  '薪酬汇率（USD→CNY）': '薪酬汇率（USD→CNY）',
  '薪酬设置': '薪酬设置',
  '补充信息提交成功': '补充信息提交成功',
  '补充备注': '补充备注',
  '表格配置': '表格配置',
  '裤子': '裤子',
  '裤装': '裤装',
  '西裤(单褶)': '西裤(单褶)',
  '西裤(双褶)': '西裤(双褶)',
  '西裤(无褶)': '西裤(无褶)',
  '规则类型': '规则类型',
  '计算价格': '计算价格',
  '计薪人数': '计薪人数',
  '计薪人数明细': '计薪人数明细',
  '订单号：': '订单号：',
  '订单将直接标记为生产中，请选择目标工厂：': '订单将直接标记为生产中，请选择目标工厂：',
  '订单总量': '订单总量',
  '订单数据加载中，请稍后再试': '订单数据加载中，请稍后再试',
  '订单状态变更Webhook': '订单状态变更Webhook',
  '订单量': '订单量',
  '记录为空，无法计算': '记录为空，无法计算',
  '记录系统中所有用户的操作行为，可用于审计和问题追踪。日志保留期限为90天。': '记录系统中所有用户的操作行为，可用于审计和问题追踪。日志保留期限为90天。',
  '设计师': '设计师',
  '证件信息': '证件信息',
  '词条用途说明': '词条用途说明',
  '词条管理': '词条管理',
  '该备忘词已存在': '该备忘词已存在',
  '该订单已复审通过，编辑将记录变更日志。确认继续编辑？': '该订单已复审通过，编辑将记录变更日志。确认继续编辑？',
  '该设计项有工厂映射，请谨慎操作': '该设计项有工厂映射，请谨慎操作',
  '该选项有工厂映射，请谨慎操作': '该选项有工厂映射，请谨慎操作',
  '说明：比例 100% = 全额划转；平均分配给多人时，为每人各建一条（如 3 人各 33%）；不填时间段则整月生效': '说明：比例 100% = 全额划转；平均分配给多人时，为每人各建一条（如 3 人各 33%）；不填时间段则整月生效',
  '请上传付款截图': '请上传付款截图',
  '请上传参考图片': '请上传参考图片',
  '请为以下订单选择工厂供应商': '请为以下订单选择工厂供应商',
  '请为以下采购记录选择采购用途': '请为以下采购记录选择采购用途',
  '请为所有采购单选择工厂供应商': '请为所有采购单选择工厂供应商',
  '请先勾选一条订单，或输入订单号搜索': '请先勾选一条订单，或输入订单号搜索',
  '请先搜索并选择订单': '请先搜索并选择订单',
  '请只勾选一条订单进行复制': '请只勾选一条订单进行复制',
  '请填写品名': '请填写品名',
  '请填写备注或上传付款截图': '请填写备注或上传付款截图',
  '请求异常 / Request Error': '请求异常 / Request Error',
  '请求超时时间(秒)': '请求超时时间(秒)',
  '请添加至少一个订单行': '请添加至少一个订单行',
  '请输入合作折扣': '请输入合作折扣',
  '请输入品名/说明': '请输入品名/说明',
  '请输入物流公司名称': '请输入物流公司名称',
  '请输入真实姓名': '请输入真实姓名',
  '请输入绣字内容': '请输入绣字内容',
  '请输入订单号或客户名': '请输入订单号或客户名',
  '请选择入账状态': '请选择入账状态',
  '请选择出让方': '请选择出让方',
  '请选择出货期': '请选择出货期',
  '请选择刺绣位置': '请选择刺绣位置',
  '请选择受让方': '请选择受让方',
  '请选择员工': '请选择员工',
  '请选择字体颜色': '请选择字体颜色',
  '请选择有效期': '请选择有效期',
  '请选择物料供应商（可选）': '请选择物料供应商（可选）',
  '财务人员': '财务人员',
  '账号状态': '账号状态',
  '跟单业绩': '跟单业绩',
  '跟单提成计算': '跟单提成计算',
  '跟单提成阶梯': '跟单提成阶梯',
  '跟单提成（技术人员/行政人员）': '跟单提成（技术人员/行政人员）',
  '跟单金额': '跟单金额',
  '跟单金额区间 (USD)': '跟单金额区间 (USD)',
  '身份证正面': '身份证正面',
  '身高筛选': '身高筛选',
  '转交给业务员': '转交给业务员',
  '辅料标记': '辅料标记',
  '输入变量名，按回车确认': '输入变量名，按回车确认',
  '运费 (USD)': '运费 (USD)',
  '运输公司：': '运输公司：',
  '选填，设置后需输入密码才能查看': '选填，设置后需输入密码才能查看',
  '选择业务经理': '选择业务经理',
  '选择后自动填写下方字段': '选择后自动填写下方字段',
  '选择员工': '选择员工',
  '选择推送到哪个尺寸串': '选择推送到哪个尺寸串',
  '选择无API工厂': '选择无API工厂',
  '选择模块': '选择模块',
  '选择经理': '选择经理',
  '选择角色': '选择角色',
  '选设计项自动填写编码': '选设计项自动填写编码',
  '选项（自动填写我方编码/名称）': '选项（自动填写我方编码/名称）',
  '邮件主题': '邮件主题',
  '邮件主题，可使用变量如 {{order_no}}': '邮件主题，可使用变量如 {{order_no}}',
  '邮件模版': '邮件模版',
  '部分采购单未能自动匹配供应商，请手动选择': '部分采购单未能自动匹配供应商，请手动选择',
  '配置与各个工厂的API对接参数。每个工厂需要独立的API密钥和接口地址。': '配置与各个工厂的API对接参数。每个工厂需要独立的API密钥和接口地址。',
  '配置系统API的基础设置和工厂对接接口。修改配置后可能需要重启服务才能生效。': '配置系统API的基础设置和工厂对接接口。修改配置后可能需要重启服务才能生效。',
  '配置系统对外推送通知的Webhook地址，用于订单状态变更、发货通知等。': '配置系统对外推送通知的Webhook地址，用于订单状态变更、发货通知等。',
  '采购专员': '采购专员',
  '采购申请已提交': '采购申请已提交',
  '采购详情': '采购详情',
  '重新计算业绩提成': '重新计算业绩提成',
  '销售业绩 (USD)': '销售业绩 (USD)',
  '销售业绩(USD)': '销售业绩(USD)',
  '销售总额': '销售总额',
  '销售总额 (USD)': '销售总额 (USD)',
  '销售明细': '销售明细',
  '销售额%': '销售额%',
  '销售额明细': '销售额明细',
  '门店号/工厂单号/面料号/客户（空格隔开多个）': '门店号/工厂单号/面料号/客户（空格隔开多个）',
  '门店号/工厂单号/面料号（空格隔开多个）': '门店号/工厂单号/面料号（空格隔开多个）',
  '门店编号模糊搜索': '门店编号模糊搜索',
  '面料×品类×工艺组合定价': '面料×品类×工艺组合定价',
  '面料供应商/面料编号': '面料供应商/面料编号',
  '顶部导航': '顶部导航',
  '项成衣尺寸到审核尺寸': '项成衣尺寸到审核尺寸',
  '项目': '项目',
  '颜色主题': '颜色主题',
  '驳回原因': '驳回原因',
  '验证工艺互斥': '验证工艺互斥',
  '默认收起侧边栏': '默认收起侧边栏',
  '默认表格密度': '默认表格密度',
  '默认语言设置': '默认语言设置',
  '（自动创建新门店并分配登录账号）': '（自动创建新门店并分配登录账号）',
  '（自动创建门店并生成登录账号）': '（自动创建门店并生成登录账号）',
  // ===== 2026-09-21 出入库模块：模板字符串陷阱修复引入的占位符 key =====
  '已识别物流单号：{no}': '已识别物流单号：{no}',
  '识别到 {n} 个候选，请点击选择': '识别到 {n} 个候选，请点击选择',
  '识别到 {n} 个候选工厂单号，请核对': '识别到 {n} 个候选工厂单号，请核对',
  '已匹配 {n} 个待入库订单': '已匹配 {n} 个待入库订单',
  '已入库 {n} 单': '已入库 {n} 单',
  '即将对 {n} 个订单标记入库': '即将对 {n} 个订单标记入库',
  '即将对 {n} 个订单标记出库': '即将对 {n} 个订单标记出库',
  '即将撤销 {n} 个订单的入库记录': '即将撤销 {n} 个订单的入库记录',
  '即将撤销 {n} 个订单的出库记录': '即将撤销 {n} 个订单的出库记录',
  '确认入库 ({n} 单)': '确认入库 ({n} 单)',
  '匹配到 {n} 个待入库订单，请勾选后确认入库': '匹配到 {n} 个待入库订单，请勾选后确认入库',
  // ===== 2026-09-21 i18n A 类批次A1：工厂映射管理（FactoryMappingManager）=====
  '+ 追加推送': '+ 追加推送',
  'CSS色值 (如 #FF0000)': 'CSS色值 (如 #FF0000)',
  'HP品类代码（工厂）': 'HP品类代码（工厂）',
  'HP品类名（如:上衣/大衣/马甲）': 'HP品类名（如:上衣/大衣/马甲）',
  'HP特体代码 code（工厂）': 'HP特体代码 code（工厂）',
  'HP特体参数 JSON ({"suit":"字段,值/字段,值"})': 'HP特体参数 JSON ({"suit":"字段,值/字段,值"})',
  'HP特体参数 adjustments': 'HP特体参数 adjustments',
  'HP订单类型 ordertype（工厂）': 'HP订单类型 ordertype（工厂）',
  'HP部位名称（工厂，推送时写入）': 'HP部位名称（工厂，推送时写入）',
  'JD品类代码（我方）': 'JD品类代码（我方）',
  'JD套装类型（我方）': 'JD套装类型（我方）',
  'adjustments 存储 HP 推送时 measure_up/down/vest_alter 特体参数': 'adjustments 存储 HP 推送时 measure_up/down/vest_alter 特体参数',
  'auto（自动替换为默认值）': 'auto（自动替换为默认值）',
  'boya_key（推送字段名，空=用field_code）': 'boya_key（推送字段名，空=用field_code）',
  'ignore（不处理）': 'ignore（不处理）',
  'photo_feedback（推到备注说明）': 'photo_feedback（推到备注说明）',
  'tech_name（中文）': 'tech_name（中文）',
  '→ HP部位名（工厂）': '→ HP部位名（工厂）',
  '→ 工厂刺绣线编码': '→ 工厂刺绣线编码',
  '→ 工厂品类': '→ 工厂品类',
  '→ 工厂工艺项': '→ 工厂工艺项',
  '① 选品类': '① 选品类',
  '② 选设计项': '② 选设计项',
  '③ 筛选选项（可选/可输入）': '③ 筛选选项（可选/可输入）',
  '上衣 JKT': '上衣 JKT',
  '上衣 suit': '上衣 suit',
  '上衣 up': '上衣 up',
  '下裤 down': '下裤 down',
  '中文 / 英文名称（我方）': '中文 / 英文名称（我方）',
  '中文名称（我方）': '中文名称（我方）',
  '从工厂同步互斥规则': '从工厂同步互斥规则',
  '保存映射': '保存映射',
  '全部缺失': '全部缺失',
  '共享 shared': '共享 shared',
  '关联线色号设计项 code（共享线颜色）': '关联线色号设计项 code（共享线颜色）',
  '刺绣线颜色（工厂映射）': '刺绣线颜色（工厂映射）',
  '可选品类+设计项精确筛选，或直接在下方关键词框搜索我方/HP编码': '可选品类+设计项精确筛选，或直接在下方关键词框搜索我方/HP编码',
  '右侧互斥工艺': '右侧互斥工艺',
  '右侧互斥工艺描述（中文）': '右侧互斥工艺描述（中文）',
  '同步后可在此处为每条规则补充中文说明，操作员推送时将看到中文互斥提示': '同步后可在此处为每条规则补充中文说明，操作员推送时将看到中文互斥提示',
  '含照片反馈': '含照片反馈',
  '固定默认': '固定默认',
  '固定默认 (fixed_default)': '固定默认 (fixed_default)',
  '处理策略': '处理策略',
  '多推送': '多推送',
  '大工艺项代码（tech_xxx）': '大工艺项代码（tech_xxx）',
  '大衣 OCT': '大衣 OCT',
  '大衣 coat': '大衣 coat',
  '如 coat~108~bs547，纯照片反馈填 __photo__': '如 coat~108~bs547，纯照片反馈填 __photo__',
  '如 coat~115': '如 coat~115',
  '如 coat~115~xw101': '如 coat~115~xw101',
  '如需同时追加备注照片，填入反馈文本': '如需同时追加备注照片，填入反馈文本',
  '如需追加备注照片文字，填此处': '如需追加备注照片文字，填此处',
  '展示所有推送字段映射关系，含我方 + 工厂的中英文名称与编码': '展示所有推送字段映射关系，含我方 + 工厂的中英文名称与编码',
  '工厂位置编码 factory_code': '工厂位置编码 factory_code',
  '工厂工艺项中文名（可空）': '工厂工艺项中文名（可空）',
  '工厂工艺项代码': '工厂工艺项代码',
  '工厂编码 (factory_itemid)': '工厂编码 (factory_itemid)',
  '工厂编码 (normal)': '工厂编码 (normal)',
  '工厂编码 factory_code': '工厂编码 factory_code',
  '工厂编码和照片反馈至少填一个': '工厂编码和照片反馈至少填一个',
  '工厂选项ID编码': '工厂选项ID编码',
  '工厂选项中文名': '工厂选项中文名',
  '工厂选项中文名（可空）': '工厂选项中文名（可空）',
  '工厂选项名称 (factory_option_name)': '工厂选项名称 (factory_option_name)',
  '工厂选项名称（中文）': '工厂选项名称（中文）',
  '工艺项名称 (factory_tech_item)': '工艺项名称 (factory_tech_item)',
  '左侧工艺描述（中文，如贡针位置-wz101）': '左侧工艺描述（中文，如贡针位置-wz101）',
  '左侧工艺（触发条件）': '左侧工艺（触发条件）',
  '忽略': '忽略',
  '我方品类': '我方品类',
  '我方线色号（共享）': '我方线色号（共享）',
  '我方设计项 / 选项': '我方设计项 / 选项',
  '我方设计项 key（只读）': '我方设计项 key（只读）',
  '我方选项中文名': '我方选项中文名',
  '我方选项值 value（只读）': '我方选项值 value（只读）',
  '我方部位': '我方部位',
  '按品类筛选': '按品类筛选',
  '按设计项筛选': '按设计项筛选',
  '推备注': '推备注',
  '推送目标': '推送目标',
  '推送项已添加': '推送项已添加',
  '搜我方/HP编码、名称': '搜我方/HP编码、名称',
  '搜索 itemid / item_name / tech_name': '搜索 itemid / item_name / tech_name',
  '搜索名称/code...': '搜索名称/code...',
  '搜索品类/设计项/选项名...': '搜索品类/设计项/选项名...',
  '搜索规则名/标签/选项编码': '搜索规则名/标签/选项编码',
  '整项无工厂映射': '整项无工厂映射',
  '整项无映射': '整项无映射',
  '新增后将自动合并为同一组合分组。': '新增后将自动合并为同一组合分组。',
  '映射已添加': '映射已添加',
  '是否启用': '是否启用',
  '服装类型': '服装类型',
  '未配置': '未配置',
  '未配置工厂名': '未配置工厂名',
  '来自共享设计项「线色号」，工厂字段 tech_cixiuxian': '来自共享设计项「线色号」，工厂字段 tech_cixiuxian',
  '模糊搜索...': '模糊搜索...',
  '模糊搜索名称/编码...': '模糊搜索名称/编码...',
  '照片反馈 (photo_feedback)': '照片反馈 (photo_feedback)',
  '照片反馈文字 (photo_feedback)': '照片反馈文字 (photo_feedback)',
  '特体推送': '特体推送',
  '状态 (1=启用)': '状态 (1=启用)',
  '直接映射 (direct)': '直接映射 (direct)',
  '确认删除此推送行？': '确认删除此推送行？',
  '筛选品类': '筛选品类',
  '筛选工厂': '筛选工厂',
  '筛选：': '筛选：',
  '组合分组': '组合分组',
  '组合推送 (composite)': '组合推送 (composite)',
  '绑定工厂': '绑定工厂',
  '编码+反馈': '编码+反馈',
  '编辑推送行': '编辑推送行',
  '缺失选项': '缺失选项',
  '自动替换': '自动替换',
  '色值 / 关联线色号（工厂共享）': '色值 / 关联线色号（工厂共享）',
  '英文名称（我方）': '英文名称（我方）',
  '补充配置': '补充配置',
  '衬衫 SHT': '衬衫 SHT',
  '衬衫 shirt': '衬衫 shirt',
  '西服上衣 suit': '西服上衣 suit',
  '西裤 TRS': '西裤 TRS',
  '西裤 pant': '西裤 pant',
  '西裤 trousers': '西裤 trousers',
  '规则名称': '规则名称',
  '设计项（key）': '设计项（key）',
  '请先选择工厂': '请先选择工厂',
  '选项值（空=整项）': '选项值（空=整项）',
  '选项显示名': '选项显示名',
  '选项未配置': '选项未配置',
  '部位名称（中文，我方）': '部位名称（中文，我方）',
  '部分选项缺失': '部分选项缺失',
  '马甲 VST': '马甲 VST',
  '马甲 vest': '马甲 vest',
  '（与线色号共享，design_item_code 关联）': '（与线色号共享，design_item_code 关联）',
  // ===== 2026-09-21 i18n A 类批次A2：设计选项互斥规则 + HP历史订单 =====
  'A 方（触发条件）': 'A 方（触发条件）',
  'A方（触发条件）': 'A方（触发条件）',
  'B 方（目标）': 'B 方（目标）',
  'B方（目标）': 'B方（目标）',
  'HP itemid（多个逗号分隔）': 'HP itemid（多个逗号分隔）',
  'HP tech_json 键': 'HP tech_json 键',
  'HP单号': 'HP单号',
  'HP工厂历史订单': 'HP工厂历史订单',
  'HP码：': 'HP码：',
  'HP编码': 'HP编码',
  'HP键：': 'HP键：',
  'coat - 大衣': 'coat - 大衣',
  'pant - 西裤': 'pant - 西裤',
  'shirt - 衬衫': 'shirt - 衬衫',
  'suit - 西服上衣': 'suit - 西服上衣',
  'vest - 马甲': 'vest - 马甲',
  '上衣：': '上衣：',
  '下裤': '下裤',
  '下裤：': '下裤：',
  '互斥': '互斥',
  '互斥：选了A，B不能选；关联必选：选了A，必须同时选B。记录我方字段码和HP工艺码，便于推送前校验。': '互斥：选了A，B不能选；关联必选：选了A，必须同时选B。记录我方字段码和HP工艺码，便于推送前校验。',
  '关系': '关系',
  '关联=必须选此项；互斥=不能选此项': '关联=必须选此项；互斥=不能选此项',
  '关联必选': '关联必选',
  '关键词（选项名/HP码/说明）': '关键词（选项名/HP码/说明）',
  '净体尺寸': '净体尺寸',
  '刺绣 JSON：': '刺绣 JSON：',
  '加减': '加减',
  '只显示': '只显示',
  '同品类': '同品类',
  '同步 HP 历史订单列表': '同步 HP 历史订单列表',
  '名称：': '名称：',
  '品类（空=通用）': '品类（空=通用）',
  '品类：': '品类：',
  '图片链接': '图片链接',
  '如 coat~101~bt101,coat~101~bt102': '如 coat~101~bt101,coat~101~bt102',
  '如 coat~133~xk107': '如 coat~133~xk107',
  '如 lapel_type、sleeve_style': '如 lapel_type、sleeve_style',
  '如 notch_lapel（空=字段任意值触发）': '如 notch_lapel（空=字段任意值触发）',
  '如 sleeve_button': '如 sleeve_button',
  '如 tech_botouxing': '如 tech_botouxing',
  '如 tech_xiukou': '如 tech_xiukou',
  '如 平驳领': '如 平驳领',
  '如 真眼3粒': '如 真眼3粒',
  '字段：': '字段：',
  '导入到门店': '导入到门店',
  '导入完成：成功 ': '导入完成：成功 ',
  '尺寸原始串：': '尺寸原始串：',
  '工艺 JSON：': '工艺 JSON：',
  '工艺选项互斥/关联规则': '工艺选项互斥/关联规则',
  '已入表': '已入表',
  '开始同步': '开始同步',
  '快递单号': '快递单号',
  '我方字段码': '我方字段码',
  '我方选项码（空=任意选项）': '我方选项码（空=任意选项）',
  '批量导入到正式订单': '批量导入到正式订单',
  '抓取备注': '抓取备注',
  '拉取信息+照片反馈': '拉取信息+照片反馈',
  '拉取订单详情：': '拉取订单详情：',
  '搜索门店编号或名称': '搜索门店编号或名称',
  '放量': '放量',
  '新建规则': '新建规则',
  '无尺寸数据': '无尺寸数据',
  '无特体调整': '无特体调整',
  '无特体调整记录': '无特体调整记录',
  '无设计项数据': '无设计项数据',
  '暂无拉取记录': '暂无拉取记录',
  '暂无照片反馈记录': '暂无照片反馈记录',
  '未找到': '未找到',
  '未拉取到任何订单': '未拉取到任何订单',
  '未映射': '未映射',
  '条 HP 历史订单，导入后订单状态为「已完成」': '条 HP 历史订单，导入后订单状态为「已完成」',
  '版型文件': '版型文件',
  '目标 HP itemid（多个逗号分隔）': '目标 HP itemid（多个逗号分隔）',
  '目标 HP tech_json 键': '目标 HP tech_json 键',
  '目标品类（空=同品类）': '目标品类（空=同品类）',
  '目标字段码': '目标字段码',
  '目标选项中文名': '目标选项中文名',
  '目标选项码（空=整个字段）': '目标选项码（空=整个字段）',
  '确认删除该规则？': '确认删除该规则？',
  '确认导入': '确认导入',
  '规则说明': '规则说明',
  '订单号 / 姓名 / 电话': '订单号 / 姓名 / 电话',
  '订单日期范围（不填则全量）': '订单日期范围（不填则全量）',
  '该订单暂无照片反馈记录': '该订单暂无照片反馈记录',
  '说明该规则的业务含义，如：袖山款式为xs104时，袖扣数量只能选3粒或4粒': '说明该规则的业务含义，如：袖山款式为xs104时，袖扣数量只能选3粒或4粒',
  '请输入HP订单号': '请输入HP订单号',
  '选A不能选B': '选A不能选B',
  '选A必须选B': '选A必须选B',
  '选A时B只显示指定项': '选A时B只显示指定项',
  '选项': '选项',
  '选项中文名': '选项中文名',
  '通用': '通用',
  '通用（所有品类）': '通用（所有品类）',
  '顾客': '顾客',
  '马甲：': '马甲：',
  '（自动识别西服/衬衫账号，拉取即存入记录表）': '（自动识别西服/衬衫账号，拉取即存入记录表）',
  // ===== 2026-09-21 i18n A 类批次A3：采购管理 + 工厂工艺映射 =====
  'HP名称': 'HP名称',
  'HP品类名': 'HP品类名',
  'HP工艺': 'HP工艺',
  'HP选项名': 'HP选项名',
  '▸ HP工厂字段': '▸ HP工厂字段',
  '▸ HP工厂字段（手工填写）': '▸ HP工厂字段（手工填写）',
  '▸ 我方字段': '▸ 我方字段',
  '▸ 我方字段（支持手工编辑）': '▸ 我方字段（支持手工编辑）',
  '上衣/大衣/裤子等': '上衣/大衣/裤子等',
  '关联订单：': '关联订单：',
  '发货工厂：': '发货工厂：',
  '发货状态': '发货状态',
  '固定': '固定',
  '固定触发': '固定触发',
  '地址：': '地址：',
  '如: buttonhole_thread': '如: buttonhole_thread',
  '如: pant~522~mjj100': '如: pant~522~mjj100',
  '如: tech_menjinyanxian': '如: tech_menjinyanxian',
  '如: trousers_threads_1000': '如: trousers_threads_1000',
  '如: 顺面料色': '如: 顺面料色',
  '工艺项编码': '工艺项编码',
  '搜索编码/名称': '搜索编码/名称',
  '照片反馈文字': '照片反馈文字',
  '电话：': '电话：',
  '组合推送时填写': '组合推送时填写',
  '缺失': '缺失',
  '选项编码': '选项编码',
  '采购数量：': '采购数量：',
  '采购日期：': '采购日期：',
  '风衣': '风衣',
  // ===== 2026-09-21 i18n A 类批次A4：加放/特体 + 归码规则 + 面料导入 =====
  '20m+价': '20m+价',
  '60m+价': '60m+价',
  'HP特体处理': 'HP特体处理',
  'HP特体处理记录': 'HP特体处理记录',
  'HP特体已保存': 'HP特体已保存',
  'JD 标准扩展版': 'JD 标准扩展版',
  'USD价': 'USD价',
  'XM特体处理': 'XM特体处理',
  'XM特体处理功能开发中': 'XM特体处理功能开发中',
  '修正值': '修正值',
  '修正部位': '修正部位',
  '华品': '华品',
  '单价USD': '单价USD',
  '参考范围': '参考范围',
  '参考订单：': '参考订单：',
  '夏梦完整版': '夏梦完整版',
  '女装': '女装',
  '审单': '审单',
  '审单操作': '审单操作',
  '尖角马甲': '尖角马甲',
  '尺寸加放功能仅限技术、技术经理、管理员使用': '尺寸加放功能仅限技术、技术经理、管理员使用',
  '幅宽cm': '幅宽cm',
  '平摆马甲': '平摆马甲',
  '当前为新建订单模式，无法回填': '当前为新建订单模式，无法回填',
  '拖动移位': '拖动移位',
  '收起': '收起',
  '暂无HP特体处理记录': '暂无HP特体处理记录',
  '暂无操作': '暂无操作',
  '点击右侧导航栏 HP 或操作区「HP特体处理」按钮展开': '点击右侧导航栏 HP 或操作区「HP特体处理」按钮展开',
  '男装': '男装',
  '组织': '组织',
  '腹围': '腹围',
  '腹围/肚围': '腹围/肚围',
  '西裤-单褶': '西裤-单褶',
  '西裤-双褶': '西裤-双褶',
  '西裤-无褶': '西裤-无褶',
  '记录': '记录',
  '该步骤不能操作': '该步骤不能操作',
  '该步骤不能操作审核按钮': '该步骤不能操作审核按钮',
  '调整值': '调整值',
  '需要订单ID才能查询HP特体处理记录': '需要订单ID才能查询HP特体处理记录',
  '颜色说明': '颜色说明',
  '（已匹配3个月内记录，请人工确认是否同一客户）': '（已匹配3个月内记录，请人工确认是否同一客户）',
  '（无特体记录）': '（无特体记录）',
  // ===== 2026-09-21 i18n A 类批次A5（最后一批）=====
  '{"suit": "胸宽,腰宽,+1.5/..."}': '{"suit": "胸宽,腰宽,+1.5/..."}',
  '⚠ 本次推送发现以下互斥工艺（已自动处理）': '⚠ 本次推送发现以下互斥工艺（已自动处理）',
  '⚠ 检测到工艺互斥冲突': '⚠ 检测到工艺互斥冲突',
  '上衣(up)': '上衣(up)',
  '下裤(down)': '下裤(down)',
  '全量交接（适用于离职）：将该门店所有历史订单和发票提成归属一并转给新业务员，旧业务员完全清出该门店': '全量交接（适用于离职）：将该门店所有历史订单和发票提成归属一并转给新业务员，旧业务员完全清出该门店',
  '同字段代码': '同字段代码',
  '排产中': '排产中',
  '新增刺绣位置': '新增刺绣位置',
  '最近3天': '最近3天',
  '最近一周': '最近一周',
  '沪ICP备2026036452号': '沪ICP备2026036452号',
  '用于推送工厂的位置标识，如 coat~115~xw100': '用于推送工厂的位置标识，如 coat~115~xw100',
  '编辑刺绣位置': '编辑刺绣位置',
  '马甲(vest)': '马甲(vest)',
  // ===== 2026-09-21 i18n A 类批次A6：字典值补翻 =====
  '互斥冲突': '互斥冲突',
  '仓库发货': '仓库发货',
  '供应商发货': '供应商发货',
  '供应商批量发货': '供应商批量发货',
  '创建采购单': '创建采购单',
  '刺绣位置未命中': '刺绣位置未命中',
  '发送采购单': '发送采购单',
  '品类不符未推送': '品类不符未推送',
  '处理售后': '处理售后',
  '开具发票': '开具发票',
  '录入付款': '录入付款',
  '批量分享采购': '批量分享采购',
  '映射缺失': '映射缺失',
  '照片上传失败': '照片上传失败',
  '特体项未推送': '特体项未推送',
  '确认收款': '确认收款',
  '确认采购完成': '确认采购完成',
  '编辑备注': '编辑备注',
  '编辑订单': '编辑订单',
  '自动改动设计项': '自动改动设计项',
  '财审通过': '财审通过',
  '财审驳回': '财审驳回',
  '超宽松': '超宽松',
  '超紧身': '超紧身',
  '采购人员发货': '采购人员发货',
  '标记已发货': '标记已发货',
  '发货日期': '发货日期',
  '已标记已发货': '已标记已发货',
  '仅已采购/已发货状态可标记已发货': '仅已采购/已发货状态可标记已发货',
  '请选择物流公司（选填）': '请选择物流公司（选填）',
  '请输入物流单号（选填）': '请输入物流单号（选填）',
  '物流信息均为选填；确认后状态变为「已发货」并自动记录发货时间。': '物流信息均为选填；确认后状态变为「已发货」并自动记录发货时间。',
  // 以下 4 个 key 原先只存在于 en-US.ts，中文端靠 t() 的 || key 回退碰巧显示正确，一并补全
  '结账状态': '结账状态',
  '已结清': '已结清',
  '部分结清': '部分结清',
  '未结': '未结',
  // 左侧菜单栏遗漏的 key：这 6 项原先都没有定义，中文端靠 t() 的 || key 回退碰巧显示正确，
  // 一并补全，保证中英两个表 key 对齐（2026-09-23）。
  '历史订单': '历史订单',
  'JD工艺互斥表': 'JD工艺互斥表',
  '工厂数据映射': '工厂数据映射',
  '薪酬参数设置': '薪酬参数设置',
  '加工商对账': '加工商对账',
  '年终分红（完善中）': '年终分红（完善中）',
  '该订单的尺寸数据已被他人修改，请刷新页面后重试': '该订单的尺寸数据已被他人修改，请刷新页面后重试',
  '功能已更新': '功能已更新',
  '当前页面是旧版本，点击刷新即可使用最新功能（未提交的内容会自动保留）': '当前页面是旧版本，点击刷新即可使用最新功能（未提交的内容会自动保留）',
  '立即刷新': '立即刷新',

  // ── 本地既有、服务器缺失的 key（2026-09-26 合并保留，避免丢失）──
  '一键复制成衣尺寸': '一键复制成衣尺寸',
  '已复制': '已复制',
  '将用各品类「业务员填写的成衣尺寸」覆盖「最终审核的成衣尺寸」，原审核值会被替换。': '将用各品类「业务员填写的成衣尺寸」覆盖「最终审核的成衣尺寸」，原审核值会被替换。',
  '覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位），请确认无误后继续。': '覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位），请确认无误后继续。',
  '将用成衣尺寸列覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位），请确认无误后继续。': '将用成衣尺寸列覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位），请确认无误后继续。',
  '将成衣尺寸列覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位）至审核成衣尺寸（推送尺寸），请确认无误后继续。': '将成衣尺寸列覆盖所有品类（上衣/裤子/马甲/衬衫/大衣及自定义部位）至审核成衣尺寸（推送尺寸），请确认无误后继续。',
  '映射表': '映射表',
  '查询': '查询',
  '详情': '详情',
  '复制': '复制',
  '复制失败': '复制失败',
  '查询失败': '查询失败',
  '管理我方设计选项与工厂工艺编码的映射关系，并查看每次推送到工厂的日志': '管理我方设计选项与工厂工艺编码的映射关系，并查看每次推送到工厂的日志',

  // ── 出入库管理 · 工厂单据 AI 识别（2026-09-26）──
  '再次识别': 'Re-recognize',
  '识别值': 'Recognized Value',
  '命中列': 'Matched Column',
  '请先上传工厂单据图片': 'Please upload the factory document image first',
  '未匹配到任何待入库订单，请点「再次识别」换一种列切分再试': 'No pending order matched. Click "Re-recognize" to try a different column split.',
  '已匹配 {n} 个待入库订单（订单号列：第 {c} 列）': 'Matched {n} pending order(s) (order-no column: #{c})',
  '当前列切分策略': 'Column Split Strategy',
  '订单号列': 'Order No. Column',

  // ── 出入库AI识别：已入库标记（2026-09-26）──
  '待入库': 'Pending Inbound',
  '已匹配 {n} 条（待入库 {p} 条，已入库 {d} 条）': 'Matched {n} record(s) (pending inbound {p}, already inbound {d})',
  '匹配到 {n} 条记录，请勾选后确认入库': 'Matched {n} record(s). Check the ones to stock in.',
  // ── 发票管理：按月份搜索（2026-10-15）──
  '开票月份': '开票月份',
  '结算月份': '结算月份',
  '选择月份': '选择月份',

  // ── 加工商对账改版：订单级列表+账单编号模型（2026-10-22）──
  '工厂工费对账与付款管理': '工厂工费对账与付款管理',
  '账单编号': '账单编号',
  '账单截图': '账单截图',
  '单号': '单号',
  '订单号/客户号': '订单号/客户号',
  '面料编号/面料供应商': '面料编号/面料供应商',
  '未对账': '未对账',
  '已对账': '已对账',
  '对账状态': '对账状态',
  '单号 / 门店': '单号 / 门店',
  '客户名': '客户名',
  '品类 / 面料号': '品类 / 面料号',
  '工费金额': '工费金额',
  '工费金额(CNY)': '工费金额(CNY)',
  '对账': '对账',
  '回滚': '回滚',
  '回滚为未对账？': '回滚为未对账？',
  '标记为已对账？': '标记为已对账？',
  '已标记为已对账': '已标记为已对账',
  '已回滚为未对账': '已回滚为未对账',
  '标记已对账': '标记已对账',
  '标记未对账': '标记未对账',
  '标记已付款': '标记已付款',
  '标记未付款': '标记未付款',
  '已更新对账状态': '已更新对账状态',
  '已更新付款状态': '已更新付款状态',
  '批量对账': '批量对账',
  '批量对账成功': '批量对账成功',
  '批量对账需所选订单属于同一加工商': '批量对账需所选订单属于同一加工商',
  '批量付款': '批量付款',
  '批量付款需所选订单属于同一账单编号': '批量付款需所选订单属于同一账单编号',
  '请选择订单': '请选择订单',
  '格式为 NO + 8位日期，如 NO20261010': '格式为 NO + 8位日期，如 NO20261010',
  '账单编号格式不正确，应为 NO+8位日期，如 NO20261010': '账单编号格式不正确，应为 NO+8位日期，如 NO20261010',
  '确认对账': '确认对账',
  '完成日期': '完成日期',
  '付款': '付款',
  '付款金额(CNY)': '付款金额(CNY)',
  '付款截图': '付款截图',
  '付款已记录': '付款已记录',
  '确认付款': '确认付款',
  '核销': '核销',
  '勾选本次完成付款的订单；支持多次付款，金额由财务手工输入，不按比例自动分配': '勾选本次完成付款的订单；支持多次付款，金额由财务手工输入，不按比例自动分配',

  // ── 加工商对账二次优化：账单编号带点格式、按钮精简、单条对账弹框（2026-10-22）──
  '供应商 / 工厂单号': '供应商 / 工厂单号',
  '对账确认': '对账确认',
  '批量回滚': '批量回滚',
  '批量回滚需所选订单均为已对账': '批量回滚需所选订单均为已对账',
  '格式为 NO. + 8位日期，如 NO.20261010': '格式为 NO. + 8位日期，如 NO.20261010',
  '清空选择': '清空选择',
  '账单编号格式不正确，应为 NO.+8位日期，如 NO.20261010': '账单编号格式不正确，应为 NO.+8位日期，如 NO.20261010',

  // ── 加工商对账三次优化：按钮布局/品类中文/付款校验（2026-10-22）──
  '请至少勾选一个订单或填写付款金额': '请至少勾选一个订单或填写付款金额',
  '可粘贴/拖拽图片': '可粘贴/拖拽图片',

  // ── 加工商对账：回滚时若已有付款记录需二次警示确认（2026-10-22）──
  '该订单已标记付款，仍要回滚为未对账吗？': '该订单已标记付款，仍要回滚为未对账吗？',
  '回滚会清空该订单的账单编号与付款状态，但已记录的付款流水不会被删除，请确认后再操作': '回滚会清空该订单的账单编号与付款状态，但已记录的付款流水不会被删除，请确认后再操作',
  '所选订单中有 {n} 条已标记付款，仍要批量回滚吗？': '所选订单中有 {n} 条已标记付款，仍要批量回滚吗？',
  '回滚会清空这些订单的账单编号与付款状态，但已记录的付款流水不会被删除，请确认后再操作': '回滚会清空这些订单的账单编号与付款状态，但已记录的付款流水不会被删除，请确认后再操作',
  '确认回滚': '确认回滚',

  // ── 新建/编辑订单面料选择：品牌/样本册实时搜索下拉（2026-11-03）──
  '按品牌搜索': '按品牌搜索',
  '按样本册搜索': '按样本册搜索',
} as Record<string, string>;
